const partNumberSchemas = [
  {
  id: "peacoc-360-spooling-panel",
  familyCode: "P",
  matchPrefix: "P36",
  minLength: 7,
  maxLength: 12,
  productName: "PEACOC® 360 Spooling Patch Panel",
  productPage: "/peacoc-360-spooling-patch-panel",
  datasheet: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FPEACOC%20360%20Spooling%20Panel.pdf?alt=media&token=03a37b9f-ed5e-4648-a181-07afe1559ae6",

  positions: [
    {
      index: 0,
      label: "Product Family",
      required: true,
      options: [
        { code: "P", description: "PEACOC" }
      ]
    },
    {
      index: 1,
      label: "PEACOC Version - Digit 1",
      required: true,
      options: [
        { code: "3", description: "PEACOC 360" }
      ]
    },
    {
      index: 2,
      label: "PEACOC Version - Digit 2",
      required: true,
      options: [
        { code: "6", description: "PEACOC 360 Spooling Panel" }
      ]
    },
    {
      index: 3,
      label: "Number of RU",
      required: true,
      options: [
        { code: "1", description: "1 RU" },
        { code: "L", description: "Left Cassette" },
        { code: "R", description: "Right Cassette" },
        { code: "X", description: "Cassette Only" },
        { code: "S", description: "Spool Only" }
      ]
    },
    {
      index: 4,
      label: "Number of Cassettes",
      required: true,
      options: [
        { code: "P", description: "Empty Chassis" },
        { code: "A", description: "Fully Loaded 1 RU (4)" },
        { code: "B", description: "1" },
        { code: "C", description: "2" },
        { code: "D", description: "3" }
      ]
    },
    {
      index: 5,
      label: "Front Connector Type",
      required: true,
      options: [
        { code: "K", description: "LC UPC Single Mode" },
        { code: "L", description: "LC APC Single Mode" },
        { code: "N", description: "LC Multi-Mode OM4 Aqua" },
        { code: "S", description: "SC UPC Single Mode" },
        { code: "T", description: "SC APC Single Mode" },
        { code: "U", description: "SC Multi-Mode OM4 Aqua" }
      ]
    },
    {
      index: 6,
      label: "Fiber Count",
      required: true,
      options: [
        { code: "1", description: "12F" },
        { code: "2", description: "24F" }
      ]
    },
    {
      index: 7,
      label: "Far End Connector",
      required: true,
      options: [
        { code: "B", description: "MPO - 1 x 12 SMF" },
        { code: "D", description: "MPO - 1 x 24 SMF" },
        { code: "F", description: "MPO - 2 x 12 SMF" },
        { code: "H", description: "MPO - 3 x 8 SMF" },
        { code: "K", description: "LC UPC Single Mode" },
        { code: "L", description: "LC APC Single Mode" },
        { code: "N", description: "LC Multi-Mode OM4 Aqua" },
        { code: "S", description: "SC UPC Single Mode" },
        { code: "T", description: "SC APC Single Mode" },
        { code: "U", description: "SC Multi-Mode OM4 Aqua" },
        { code: "A", description: "MPO - 1 x 12 MMF" },
        { code: "V", description: "MPO - 1 x 24 MMF" },
        { code: "W", description: "MPO - 2 x 12 MMF" },
        { code: "Y", description: "MPO - 3 x 8 MMF" },
        { code: "X", description: "None" }
      ]
    },
    {
      index: 8,
      label: "Polarity",
      required: true,
      options: [
        { code: "A", description: "Method A" },
        { code: "B", description: "Method B" },
        { code: "X", description: "Not Applicable" }
      ]
    },
    {
      index: 9,
      label: "Cable Length",
      required: true,
      options: [
        { code: "3", description: "100' (31m) Standard" },
        { code: "4", description: "150' (46m)" },
        { code: "5", description: "200' (61m)" },
        { code: "6", description: "250' (76m)" },
        { code: "7", description: "300' (92m)" },
        { code: "8", description: "350' (107m)" },
        { code: "9", description: "400' (122m)" },
        { code: "A", description: "450' (137m)" },
        { code: "B", description: "500' (153m)" },
        { code: "X", description: "Empty Spools" },
        { code: "Y", description: "Custom" }
      ]
    },
    {
      index: 10,
      label: "Cable Type",
      required: true,
      options: [
        { code: "P", description: "Plenum (OFNP)" },
        { code: "R", description: "Riser (OFNR)" },
        { code: "S", description: "I/O" },
        { code: "X", description: "Not Applicable" }
      ]
    },
    {
      index: 11,
      label: "Far End Break Out Length",
      required: true,
      options: [
        { code: "1", description: "39 inches" },
        { code: "2", description: "80 inches" },
        { code: "5", description: "60 inches" },
        { code: "X", description: "None (MPO)" }
      ]
    }
  ],

  notes: [
    "All cables are 3.0 mm diameter unless otherwise specified.",
    "Cable diameter affects the total cable length on spool."
  ]
},

  {
  id: "nemo-fiber-patch-panel",
  familyCode: "P",
  matchPrefix: "PN",
  minLength: 7,
  maxLength: 18,
  productName: "PEACOC® NEMO Any Density Patch Panel",
  productPage: "/peacoc-nemo-any-density-patch-panel",
  datasheet: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FNEMO%20Fiber%20Patch%20Panel%20Datasheet.pdf?alt=media&token=56500998-29f3-4439-ad5c-72428b926ad2",

  positions: [
    {
      index: 0,
      label: "Product Family",
      required: true,
      options: [
        { code: "P", description: "PEACOC" }
      ]
    },
    {
      index: 1,
      label: "Product Type",
      required: true,
      options: [
        { code: "N", description: "NEMO" }
      ]
    },
    {
      index: 2,
      label: "Number of RUs",
      required: true,
      options: [
        { code: "1", description: "1RU" },
        { code: "X", description: "Single Rail" }
      ]
    },
    {
      index: 3,
      label: "Type of Ports",
      required: true,
      options: [
        { code: "L", description: "LC Duplex" },
        { code: "S", description: "SC Simplex" },
        { code: "P", description: "MPO (8/12/24)" },
        { code: "X", description: "None (Empty Panel)" }
      ]
    },
    {
      index: 4,
      label: "Port Color",
      required: true,
      options: [
        { code: "B", description: "Blue" },
        { code: "E", description: "Beige" },
        { code: "K", description: "Black" },
        { code: "G", description: "Green" },
        { code: "Q", description: "Aqua" },
        { code: "V", description: "Violet" },
        { code: "X", description: "None (Empty Panel)" }
      ]
    },

    {
      index: 5,
      label: "Number of Ports - Digit 1",
      group: "numberOfPorts",
      required: true,
      options: [
        { code: "0", description: "First digit of 3-digit port count" }
      ]
    },
    {
      index: 6,
      label: "Number of Ports - Digit 2",
      group: "numberOfPorts",
      required: true,
      options: [
        { code: "0", description: "Second digit of 3-digit port count" },
        { code: "1", description: "Second digit of 3-digit port count" },
        { code: "2", description: "Second digit of 3-digit port count" },
        { code: "3", description: "Second digit of 3-digit port count" },
        { code: "4", description: "Second digit of 3-digit port count" },
        { code: "6", description: "Second digit of 3-digit port count" },
        { code: "7", description: "Second digit of 3-digit port count" }
      ]
    },
    {
      index: 7,
      label: "Number of Ports - Digit 3",
      group: "numberOfPorts",
      required: true,
      options: [
        { code: "0", description: "Third digit of 3-digit port count" },
        { code: "2", description: "Third digit of 3-digit port count" },
        { code: "4", description: "Third digit of 3-digit port count" },
        { code: "6", description: "Third digit of 3-digit port count" },
        { code: "8", description: "Third digit of 3-digit port count" }
      ]
    },

    {
      index: 8,
      label: "Rear Cable Connection / Inner Cabling",
      required: true,
      options: [
        { code: "X", description: "None (Patch Panel Only)" },
        { code: "P", description: "Pre-term Pigtail" }
      ]
    },
    {
      index: 9,
      label: "Port Labels",
      required: true,
      options: [
        { code: "A", description: "Port Number" },
        { code: "B", description: "Fiber Number / Count" },
        { code: "D", description: "Letters (By Port)" },
        { code: "C", description: "Custom" },
        { code: "X", description: "None" }
      ]
    },
    {
      index: 10,
      label: "Cable Management",
      required: true,
      options: [
        { code: "1", description: "Front & Rear (Side Exit)" },
        { code: "2", description: "Front (Side Exit) + Rear (Rear Exit)" },
        { code: "3", description: "Front Only (Side Exit)" },
        { code: "4", description: "Rear Only (Side Exit)" },
        { code: "5", description: "Rear Only (Rear Exit)" },
        { code: "X", description: "None" }
      ]
    },
    {
      index: 11,
      label: "Doors",
      required: true,
      options: [
        { code: "1", description: "Front & Rear" },
        { code: "2", description: "Front Only" },
        { code: "3", description: "Rear Only" },
        { code: "X", description: "None" }
      ]
    },

    {
      index: 12,
      label: "Customer Code - Letter 1",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 13,
      label: "Customer Code - Letter 2",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 14,
      label: "Customer Code - Letter 3",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },

    {
      index: 15,
      label: "Product Series - Digit 1",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 16,
      label: "Product Series - Digit 2",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 17,
      label: "Product Series - Digit 3",
      group: "productSeries",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "numberOfPorts",
      label: "Number of Ports",
      indexes: [5, 6, 7],
      options: [
        { code: "000", description: "None (Empty Panel)" },
        { code: "006", description: "6 Ports" },
        { code: "012", description: "12 Ports" },
        { code: "024", description: "24 Ports" },
        { code: "036", description: "36 Ports" },
        { code: "048", description: "48 Ports" },
        { code: "060", description: "60 Ports" },
        { code: "072", description: "72 Ports" }
      ]
    },
    {
      group: "customerCode",
      label: "Customer Code",
      indexes: [12, 13, 14],
      description: "Customer Code, 3 letters"
    },
    {
      group: "productSeries",
      label: "Product Series",
      indexes: [15, 16, 17],
      description: "Product Series, 3 numbers"
    }
  ]
},


{
  id: "peacoc-3ru-splice-chassis",
  familyCode: "P",
  matchPrefix: "PS3",
  minLength: 7,
  maxLength: 13,
  productName: "PEACOC® 3RU Splice Chassis",
  productPage: "/peacoc-3ru-splice-chassis",
  datasheet: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FPEACOC-3RU-Splice-Chasis-Datasheet.pdf?alt=media&token=54c872eb-d1e4-41d1-a4c3-9dcb499021a2",

  positions: [
    {
      index: 0,
      label: "Product Family Code",
      required: true,
      options: [
        { code: "P", description: "PEACOC" }
      ]
    },
    {
      index: 1,
      label: "Splice Chassis",
      required: true,
      options: [
        { code: "S", description: "Splice Chassis" }
      ]
    },
    {
      index: 2,
      label: "Capacity",
      required: true,
      options: [
        { code: "3", description: "3 RU" }
      ]
    },
    {
      index: 3,
      label: "Tray Type",
      required: true,
      options: [
        { code: "2", description: "TE Connectivity Tray" },
        { code: "3", description: "AFL Tray" },
        { code: "C", description: "Custom Trays" },
        { code: "O", description: "Chassis Only" }
      ]
    },
    {
      index: 4,
      label: "Splice Type",
      required: true,
      options: [
        { code: "1", description: "Single Fusion (24 per Tray)" }
      ]
    },

    {
      index: 5,
      label: "Number of Trays Included - Digit 1",
      group: "numberOfTraysIncluded",
      required: true,
      options: "0-9"
    },
    {
      index: 6,
      label: "Number of Trays Included - Digit 2",
      group: "numberOfTraysIncluded",
      required: true,
      options: "0-9"
    },

    {
      index: 7,
      label: "Customer Code - Letter 1",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 8,
      label: "Customer Code - Letter 2",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 9,
      label: "Customer Code - Letter 3",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },

    {
      index: 10,
      label: "Product Series - Digit 1",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 11,
      label: "Product Series - Digit 2",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 12,
      label: "Product Series - Digit 3",
      group: "productSeries",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "numberOfTraysIncluded",
      label: "Number of Trays Included",
      indexes: [5, 6],
      description: "Number of trays, 2 numeric digits"
    },
    {
      group: "customerCode",
      label: "Customer Code",
      indexes: [7, 8, 9],
      description: "Customer Code, 3 letters only"
    },
    {
      group: "productSeries",
      label: "Product Series",
      indexes: [10, 11, 12],
      description: "Product Series, 3 numeric digits"
    }
  ],

  example: {
    code: "PS32118",
    description: "3RU Splice Chassis with 18 TE trays installed, single fusion."
  }
},

{
  id: "peacoc-high-density-fiber-patch-panel",
  familyCode: "P",
  matchPrefix: "P3",
  minLength: 7,
  maxLength: 12,
  productName: "PEACOC® High Density Patch Panel",
  productPage: "/peacoc-high-density-patch-panel",
  datasheet: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FPEACOC%C2%AE%20High-Density%20Fiber%20Patch%20Panel%20Datasheet.pdf?alt=media&token=ac46e9ef-8ee2-432e-a4e9-78a616574ae3",

  positions: [
    {
      index: 0,
      label: "Product Family",
      required: true,
      options: [
        { code: "P", description: "PEACOC" }
      ]
    },
    {
      index: 1,
      label: "PEACOC Version - Digit 1",
      group: "peacocVersion",
      required: true,
      options: [
        { code: "3", description: "PEACOC Version prefix" }
      ]
    },
    {
      index: 2,
      label: "PEACOC Version - Digit 2",
      group: "peacocVersion",
      required: true,
      options: [
        { code: "S", description: "V3 Short" },
        { code: "L", description: "V3 Long" },
        { code: "E", description: "V3 Short with Extension" },
        { code: "D", description: "V3 Long with Deep Back Door" }
      ]
    },
    {
      index: 3,
      label: "Panel / Tray Type",
      required: true,
      options: [
        { code: "O", description: "Chassis Only" },
        { code: "P", description: "Patch Panel" },
        { code: "X", description: "Cassette Tray Only" },
        { code: "S", description: "Patching Tray with Splicing" },
        { code: "C", description: "Custom Tray Configuration" },
        { code: "L", description: "Cassette Tray Only - Left Side" },
        { code: "R", description: "Cassette Tray Only - Right Side" }
      ]
    },
    {
      index: 4,
      label: "Front Cable Sleeve Length - Digit 1",
      group: "frontCableSleeveLength",
      required: true,
      options: "0-9"
    },
    {
      index: 5,
      label: "Front Cable Sleeve Length - Digit 2",
      group: "frontCableSleeveLength",
      required: true,
      options: "0-9"
    },
    {
      index: 6,
      label: "Rear Cable Sleeve Length - Digit 1",
      group: "rearCableSleeveLength",
      required: true,
      options: "0-9"
    },
    {
      index: 7,
      label: "Rear Cable Sleeve Length - Digit 2",
      group: "rearCableSleeveLength",
      required: true,
      options: "0-9"
    },
    {
      index: 8,
      label: "Cable Routing Direction",
      required: true,
      options: [
        { code: "F", description: "Front" },
        { code: "R", description: "Rear" },
        { code: "X", description: "None or N/A" }
      ]
    },
    {
      index: 9,
      label: "Number of Trays",
      required: true,
      options: [
        { code: "1", description: "1 Tray" },
        { code: "2", description: "2 Trays" },
        { code: "3", description: "3 Trays" },
        { code: "4", description: "4 Trays" },
        { code: "5", description: "5 Trays" },
        { code: "6", description: "6 Trays, max full load" },
        { code: "X", description: "None" }
      ]
    },
    {
      index: 10,
      label: "Connector Type / Adapter Type",
      required: true,
      options: [
        { code: "1", description: "LC-UPC / Blue Duplex Adapters" },
        { code: "2", description: "LC-APC / Green Duplex Adapters" },
        { code: "3", description: "SC-UPC / Blue Simplex Adapters" },
        { code: "4", description: "SC-APC / Green Simplex Adapters" },
        { code: "5", description: "LC-UPC / Blue Simplex Adapters" },
        { code: "6", description: "LC-APC / Green Simplex Adapters" },
        { code: "7", description: "MPO - Black Adapters" },
        { code: "8", description: "LC-PC / Aqua Duplex Adapters" },
        { code: "9", description: "SC-PC / Aqua Simplex Adapters" },
        { code: "P", description: "Others - Custom Configuration" }
      ]
    },
    {
      index: 11,
      label: "Inner Cable Options",
      required: true,
      options: [
        { code: "C", description: "1x24F Male MPO to LC Fan-outs SMF" },
        { code: "D", description: "2x12F Male MPO to LC Fan-outs SMF" },
        { code: "E", description: "3x8F Male MPO to LC Fan-outs SMF" },
        { code: "F", description: "1x12F Male MPO to SC Fan-outs SMF" },
        { code: "H", description: "2x8 Male MPO to SC Fan-outs OM4" },
        { code: "J", description: "1x12F Male MPO to LC Fan-outs SMF" },
        { code: "K", description: "1x12F Male MPO to LC Fan-outs OM4" },
        { code: "N", description: "Mass Fusion Splice" },
        { code: "P", description: "Single Splice or Other" },
        { code: "R", description: "2x8 Male MPO to LC Fan-outs SMF" },
        { code: "S", description: "2x8 Male MPO to LC Fan-outs OM4" },
        { code: "T", description: "1x24F Male MPO to LC Fan-outs OM4" },
        { code: "U", description: "2x12F Male MPO to LC Fan-outs OM4" },
        { code: "V", description: "3x8F Male MPO to LC Fan-outs OM4" },
        { code: "W", description: "1x12F Male MPO to SC Fan-outs OM4" },
        { code: "X", description: "None" }
      ]
    }
  ],

  groupedOptions: [
    {
      group: "peacocVersion",
      label: "PEACOC Version",
      indexes: [1, 2],
      options: [
        { code: "3S", description: "V3 Short" },
        { code: "3L", description: "V3 Long" },
        { code: "3E", description: "V3 Short with Extension" },
        { code: "3D", description: "V3 Long with Deep Back Door" }
      ]
    },
    {
      group: "frontCableSleeveLength",
      label: "Front Cable Sleeve Length",
      indexes: [4, 5],
      description: "2 digits length in cm, or X for none",
      options: [
        { code: "XX", description: "None" }
      ],
      allowNumeric: true
    },
    {
      group: "rearCableSleeveLength",
      label: "Rear Cable Sleeve Length",
      indexes: [6, 7],
      description: "2 digits length in cm, or X for none",
      options: [
        { code: "XX", description: "None" }
      ],
      allowNumeric: true
    }
  ]
},

{
  id: "peacoc-eva",
  familyCode: "P",
  matchPrefix: "P",
  minLength: 8,
  maxLength: 8,
  productName: "PEACOC® Enhanced View and Access (EVA) High Density Patch Panel",
  productPage: "/peacoc-enhanced-view-and-access-eva-high-density-patch-panel",
  datasheet: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FPEACOC%20EVA%20Datasheet.pdf?alt=media&token=8f78d380-6691-4ca3-9d06-ce248458a706",

  positions: [
    {
      index: 0,
      label: "Product Family",
      required: true,
      options: [
        { code: "P", description: "PEACOC" }
      ]
    },
    {
      index: 1,
      label: "Number of RU",
      required: true,
      options: [
        { code: "1", description: "1 RU" },
        { code: "2", description: "2 RU" },
        { code: "4", description: "4 RU" },
        { code: "X", description: "Cassette Only" }
      ]
    },
    {
      index: 2,
      label: "Number of Cassettes",
      required: true,
      options: [
        { code: "P", description: "Empty Chassis" },
        { code: "A", description: "1" },
        { code: "B", description: "2" },
        { code: "C", description: "3" },
        { code: "D", description: "4" },
        { code: "E", description: "5" },
        { code: "F", description: "Fully Loaded 1RU" },
        { code: "G", description: "Fully Loaded 2RU" },
        { code: "H", description: "Fully Loaded 4RU" }
      ]
    },
    {
      index: 3,
      label: "Cassette Type",
      required: true,
      options: [
        { code: "A", description: "All Front Access" },
        { code: "P", description: "Patch" },
        { code: "S", description: "Splice" }
      ]
    },
    {
      index: 4,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "Single Mode (SMF)" },
        { code: "2", description: "Multi-Mode (OM4)" }
      ]
    },
    {
      index: 5,
      label: "Cassette Adapter Type",
      required: true,
      options: [
        { code: "A", description: "CS" },
        { code: "B", description: "SN" },
        { code: "C", description: "MMC" },
        { code: "D", description: "MDC" },
        { code: "G", description: "SN-MT" },
        { code: "K", description: "LC Simplex" },
        { code: "L", description: "LC Duplex" },
        { code: "M", description: "MPO 8/12/24" },
        { code: "N", description: "MPO 16" },
        { code: "S", description: "SC Simplex" }
      ]
    },
    {
      index: 6,
      label: "Adapter Type / Color",
      required: true,
      options: [
        { code: "A", description: "UPC (Aqua - Multimode)" },
        { code: "B", description: "UPC (Blue - Single Mode)" },
        { code: "G", description: "APC (Green - Single Mode)" },
        { code: "K", description: "MPO (Black)" }
      ]
    },
    {
      index: 7,
      label: "Inner Cable Options",
      required: true,
      options: [
        { code: "A", description: "1x12F Male MPO to SC Fanout" },
        { code: "D", description: "1x16F Male MPO to LC Fanout" },
        { code: "E", description: "1x20F Male MPO to LC Fanout" },
        { code: "F", description: "1x24F Male MPO to LC Fanout" },
        { code: "H", description: "2x8F Male MPO to LC Fanout" },
        { code: "K", description: "2x12F Male MPO to LC Fanout" },
        { code: "M", description: "3x8F Male MPO to LC Fanout" },
        { code: "N", description: "Mass Fusion Splice" },
        { code: "P", description: "Single Splice" },
        { code: "R", description: "4-24F Male MPO to 8-12F Male MPO FA" },
        { code: "X", description: "None" }
      ]
    }
  ]
}, 

{
  id: "simplex-duplex-patch-cords",
  familyCode: "J",
  matchPrefix: "J",
  minLength: 11,
  maxLength: 11,
  productName: "Simplex and Duplex Patch Cords",
  productPage: "/simplex-and-duplex-patch-cords",
  datasheet: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FSimplex%20and%20Duplex%20Patch%20Cords%20Data%20Sheet.pdf?alt=media&token=3ea6998d-5ed3-4a56-a26d-eeaa73bc848a",

  positions: [
    {
      index: 0,
      label: "Product Family",
      required: true,
      options: [
        { code: "J", description: "Simplex and Duplex Patch Cords" }
      ]
    },
    {
      index: 1,
      label: "Connector Type End A",
      required: true,
      options: [
        { code: "A", description: "LC/APC" },
        { code: "B", description: "FC/PC" },
        { code: "C", description: "LC/APC" },
        { code: "D", description: "LC/PC" },
        { code: "E", description: "MU/PC" },
        { code: "F", description: "SC/APC" },
        { code: "G", description: "SC/PC" },
        { code: "H", description: "ST/APC" },
        { code: "J", description: "ST/PC" },
        { code: "K", description: "CS/UPC" },
        { code: "N", description: "MU/APC" },
        { code: "R", description: "MDC/APC" },
        { code: "S", description: "MDC/PC" },
        { code: "T", description: "D4" },
        { code: "U", description: "SN" },
        { code: "P", description: "Others" },
        { code: "X", description: "No Connector" }
      ]
    },
    {
      index: 2,
      label: "Connector Type End B",
      required: true,
      options: [
        { code: "A", description: "LC/APC" },
        { code: "B", description: "FC/PC" },
        { code: "C", description: "LC/APC" },
        { code: "D", description: "LC/PC" },
        { code: "E", description: "MU/PC" },
        { code: "F", description: "SC/APC" },
        { code: "G", description: "SC/PC" },
        { code: "H", description: "ST/APC" },
        { code: "J", description: "ST/PC" },
        { code: "K", description: "CS/UPC" },
        { code: "N", description: "MU/APC" },
        { code: "R", description: "MDC/APC" },
        { code: "S", description: "MDC/PC" },
        { code: "T", description: "D4" },
        { code: "U", description: "SN" },
        { code: "P", description: "Others" },
        { code: "X", description: "No Connector" }
      ]
    },
    {
      index: 3,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "ITU G.652D Compliant (SMF)" },
        { code: "2", description: "ITU G.652A1 Compliant (SMF)" },
        { code: "3", description: "ITU G.652A2/B2 Compliant (SMF)" },
        { code: "4", description: "ITU G.652B3 Compliant (SMF)" },
        { code: "5", description: "OM1 62.5/125µm (MMF)" },
        { code: "6", description: "OM2 50/125µm (MMF)" },
        { code: "7", description: "OM3 50/125µm (MMF)" },
        { code: "8", description: "OM4 50/125µm (MMF)" },
        { code: "P", description: "N/A" }
      ]
    },
    {
      index: 4,
      label: "Cordage Diameter",
      required: true,
      options: [
        { code: "A", description: "250µm Tight Fiber" },
        { code: "B", description: "900µm Tight Buffer" },
        { code: "C", description: "1.2mm" },
        { code: "D", description: "1.6mm" },
        { code: "E", description: "2.0mm" },
        { code: "F", description: "3.0mm" },
        { code: "G", description: "4.0mm" },
        { code: "H", description: "4.8mm" },
        { code: "J", description: "Bowtie/Figure 8" },
        { code: "K", description: "5.0mm" },
        { code: "L", description: "165µm Bare Fiber" },
        { code: "P", description: "Others" }
      ]
    },
    {
      index: 5,
      label: "Jacket Rating",
      required: true,
      options: [
        { code: "1", description: "LSZH" },
        { code: "2", description: "Nylon" },
        { code: "3", description: "Plenum" },
        { code: "4", description: "Polyethylene (PE)" },
        { code: "5", description: "Riser" },
        { code: "6", description: "PUR" },
        { code: "7", description: "PVC" },
        { code: "8", description: "Indoor/Outdoor (I/O)" },
        { code: "9", description: "Riser-LSZH" },
        { code: "P", description: "Others" },
        { code: "X", description: "Non-jacketed" }
      ]
    },
    {
      index: 6,
      label: "Fiber Count",
      required: true,
      options: [
        { code: "A", description: "1 Fiber (Simplex)" },
        { code: "B", description: "2 Fiber (Duplex)" }
      ]
    },
    {
      index: 7,
      label: "Length Designator",
      required: true,
      options: [
        { code: "C", description: "Length in Centimeters" },
        { code: "M", description: "Length in Meters" },
        { code: "F", description: "Length in Feet" },
        { code: "K", description: "Length in Kilometers" },
        { code: "D", description: "Length in Decimeters" }
      ]
    },
    {
      index: 8,
      label: "Fiber Length - Digit 1",
      group: "fiberLength",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "Fiber Length - Digit 2",
      group: "fiberLength",
      required: true,
      options: "0-9"
    },
    {
      index: 10,
      label: "Fiber Length - Digit 3",
      group: "fiberLength",
      required: true,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "fiberLength",
      label: "Fiber Length",
      indexes: [8, 9, 10],
      description: "3 digit length. Unit depends on the Length Designator selected in position 8.",
      allowNumeric: true
    }
  ],

  example: {
    code: "JCC3J5BC134",
    description: "Example Simplex/Duplex patch cord configuration with LC/APC connectors on both ends, G.652A2/B2 SMF, Bowtie/Figure 8 cordage, riser jacket, duplex fiber count, length in centimeters, and 134 length."
  }
},

{
  id: "mdc-patch-cords",
  familyCode: "J",
  matchPrefix: "J",
  minLength: 11,
  maxLength: 11,
  productName: "MDC Patch Cords",
  productPage: "/mdc-patch-cords",
  datasheet: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FMDC%20Data%20Sheet.pdf?alt=media&token=7677bc6c-9bf8-4707-b1d9-a98c2b21bad7",

  positions: [
    {
      index: 0,
      label: "Product Family",
      required: true,
      options: [
        { code: "J", description: "MDC Patch Cords" }
      ]
    },
    {
      index: 1,
      label: "Connector Type End A",
      required: true,
      options: [
        { code: "C", description: "LC/APC" },
        { code: "D", description: "LC/PC" },
        { code: "R", description: "MDC/APC" },
        { code: "S", description: "MDC/PC" },
        { code: "P", description: "Others" },
        { code: "X", description: "No Connector" }
      ]
    },
    {
      index: 2,
      label: "Connector Type End B",
      required: true,
      options: [
        { code: "C", description: "LC/APC" },
        { code: "D", description: "LC/PC" },
        { code: "R", description: "MDC/APC" },
        { code: "S", description: "MDC/PC" },
        { code: "P", description: "Others" },
        { code: "X", description: "No Connector" }
      ]
    },
    {
      index: 3,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "ITU G.652D Compliant (Singlemode)" },
        { code: "2", description: "ITU G.652A1 Compliant (Singlemode)" },
        { code: "3", description: "ITU G.652A2/B2 Compliant (Singlemode)" },
        { code: "4", description: "ITU G.652B3 Compliant (Singlemode)" }
      ]
    },
    {
      index: 4,
      label: "Cordage Diameter",
      required: true,
      options: [
        { code: "B", description: "900µm Tight Buffer" },
        { code: "D", description: "1.6mm" }
      ]
    },
    {
      index: 5,
      label: "Jacket Rating",
      required: true,
      options: [
        { code: "1", description: "LSZH" },
        { code: "3", description: "OFNP" },
        { code: "5", description: "OFNR" },
        { code: "7", description: "PVC" },
        { code: "P", description: "Others" }
      ]
    },
    {
      index: 6,
      label: "Fiber Count",
      required: true,
      options: [
        { code: "B", description: "2 Fiber (Duplex)" }
      ]
    },
    {
      index: 7,
      label: "Length Designator",
      required: true,
      options: [
        { code: "C", description: "Length in Centimeters" },
        { code: "M", description: "Length in Meters" },
        { code: "F", description: "Length in Feet" },
        { code: "K", description: "Length in Kilometers" }
      ]
    },
    {
      index: 8,
      label: "Fiber Length - Digit 1",
      group: "fiberLength",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "Fiber Length - Digit 2",
      group: "fiberLength",
      required: true,
      options: "0-9"
    },
    {
      index: 10,
      label: "Fiber Length - Digit 3",
      group: "fiberLength",
      required: true,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "fiberLength",
      label: "Fiber Length",
      indexes: [8, 9, 10],
      description: "3 digit length. Unit depends on the Length Designator selected in position 8.",
      allowNumeric: true
    }
  ],

  example: {
    code: "JRR3D5BC050",
    description: "Example MDC patch cord configuration with MDC/APC connectors on both ends, G.652A2/B2 singlemode fiber, 1.6mm cordage, OFNR jacket, duplex fiber count, length in centimeters, and 050 length."
  }
},

{
  id: "mpo-patch-cords",
  familyCode: "M",
  matchPrefix: "M",
  minLength: 11,
  maxLength: 11,
  productName: "MPO Patch Cords",
  productPage: "/mpo-patch-cords",
  datasheet: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FMPO%20Data%20Sheet.pdf?alt=media&token=d6a95eae-d582-4cf0-a795-771abcbe7a60",

  positions: [
    {
      index: 0,
      label: "Product Family",
      required: true,
      options: [
        { code: "M", description: "MPO Patch Cords" }
      ]
    },
    {
      index: 1,
      label: "Connector Type End 1",
      required: true,
      options: [
        { code: "A", description: "MPO/PC (male)" },
        { code: "B", description: "MPO/APC (male)" },
        { code: "C", description: "MPO/PC (female)" },
        { code: "D", description: "MPO/APC (female)" },
        { code: "E", description: "Fiber Array" },
        { code: "P", description: "Others" },
        { code: "X", description: "No Connector" }
      ]
    },
    {
      index: 2,
      label: "Connector Type End 2",
      required: true,
      options: [
        { code: "A", description: "MPO/PC (male)" },
        { code: "B", description: "MPO/APC (male)" },
        { code: "C", description: "MPO/PC (female)" },
        { code: "D", description: "MPO/APC (female)" },
        { code: "E", description: "Fiber Array" },
        { code: "P", description: "Others" },
        { code: "X", description: "No Connector" }
      ]
    },
    {
      index: 3,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "ITU G.652D Compliant (SMF)" },
        { code: "2", description: "ITU G.657A1 Compliant (SMF)" },
        { code: "3", description: "ITU G.657A2/B2 Compliant (SMF)" },
        { code: "4", description: "ITU G.657B3 Compliant (SMF)" },
        { code: "5", description: "OM1 62.5/125µm (MMF)" },
        { code: "6", description: "OM2 50/125µm (MMF)" },
        { code: "7", description: "OM3 50/125µm (MMF)" },
        { code: "8", description: "OM4 50/125µm (MMF)" },
        { code: "P", description: "Others" }
      ]
    },
    {
      index: 4,
      label: "Cordage Diameter",
      required: true,
      options: [
        { code: "A", description: "250µm Tight Fiber" },
        { code: "B", description: "900µm Tight Buffer" },
        { code: "C", description: "1.2mm" },
        { code: "D", description: "1.6mm" },
        { code: "E", description: "2.0mm" },
        { code: "F", description: "3.0mm" },
        { code: "G", description: "3.8mm" },
        { code: "H", description: "4.0mm" },
        { code: "J", description: "4.5mm" },
        { code: "K", description: "5.0mm" },
        { code: "L", description: "5.5mm" },
        { code: "M", description: "11mm" },
        { code: "N", description: "18mm" },
        { code: "Q", description: "2x3mm" },
        { code: "R", description: "Oval Ribbon Cable" },
        { code: "S", description: "165µm Bare Buffer" },
        { code: "P", description: "Others" },
        { code: "X", description: "Bare Fiber Ribbon (no outer jacket)" }
      ]
    },
    {
      index: 5,
      label: "Jacket Rating",
      required: true,
      options: [
        { code: "1", description: "LSZH" },
        { code: "2", description: "Nylon" },
        { code: "3", description: "Plenum" },
        { code: "4", description: "Polyethylene (PE)" },
        { code: "5", description: "Riser" },
        { code: "6", description: "PUR" },
        { code: "7", description: "PVC" },
        { code: "8", description: "Indoor/Outdoor (I/O)" },
        { code: "9", description: "Riser-LSZH" },
        { code: "P", description: "Others" },
        { code: "X", description: "Non-jacketed" }
      ]
    },
    {
      index: 6,
      label: "Fiber Count",
      required: true,
      options: [
        { code: "A", description: "8 Fiber (Ribbon Bare)" },
        { code: "B", description: "12 Fiber (Ribbon Bare)" },
        { code: "C", description: "24 Fiber (Ribbon Bare)" },
        { code: "D", description: "16 Fiber (Ribbon Bare)" },
        { code: "E", description: "32 Fiber (Ribbon Bare)" },
        { code: "F", description: "8 Fiber (Distribution Bare)" },
        { code: "G", description: "12 Fiber (Distribution Bare)" },
        { code: "H", description: "24 Fiber (Distribution Bare)" },
        { code: "J", description: "16 Fiber (Distribution Bare)" },
        { code: "K", description: "32 Fiber (Distribution Bare)" },
        { code: "L", description: "8F Loopback" },
        { code: "M", description: "12F Loopback" },
        { code: "N", description: "24F Loopback" },
        { code: "Q", description: "16F Loopback" },
        { code: "P", description: "Others" }
      ]
    },
    {
      index: 7,
      label: "Length Designator",
      required: true,
      options: [
        { code: "C", description: "Length in Centimeters" },
        { code: "M", description: "Length in Meters" },
        { code: "F", description: "Length in Feet" },
        { code: "K", description: "Length in Kilometers" },
        { code: "D", description: "Length in Decimeters" }
      ]
    },
    {
      index: 8,
      label: "Fiber Length - Digit 1",
      group: "fiberLength",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "Fiber Length - Digit 2",
      group: "fiberLength",
      required: true,
      options: "0-9"
    },
    {
      index: 10,
      label: "Fiber Length - Digit 3",
      group: "fiberLength",
      required: true,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "fiberLength",
      label: "Fiber Length",
      indexes: [8, 9, 10],
      description: "3 digit length. Unit depends on the Length Designator selected in position 8.",
      allowNumeric: true
    }
  ],

  example: {
    code: "MDD3F5GM001",
    description: "JUMPER 12F MFA-MFA A2 RSR 3MM 1M"
  }
},
{
  id: "multifiber-fanout-breakout-cables",
  familyCode: "B",
  matchPrefix: "B",
  minLength: 11,
  maxLength: 11,
  productName: "Multifiber Fanout / Breakout Cables",
  productPage: "/multifiber-fanout-breakout-cables",
  datasheet: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FFanout%20Cables%20%26%20MPO%20Breakouts.pdf?alt=media&token=aaa65ddc-224e-40ab-af72-659485bc0625",

  positions: [
    {
      index: 0,
      label: "Product Family",
      required: true,
      options: [
        {
          code: "B",
          description: "Multifiber Fanout / Breakout Cables"
        }
      ]
    },

    {
      index: 1,
      label: "Connector Type End 1",
      required: true,
      options: [
        { code: "A", description: "MPO/PC (Male)" },
        { code: "B", description: "MPO/APC (Male)" },
        { code: "C", description: "MPO/PC (Female)" },
        { code: "D", description: "MPO/APC (Female)" },
        { code: "E", description: "Fiber Array" },
        { code: "F", description: "FC/PC" },
        { code: "G", description: "FC/APC" },
        { code: "H", description: "LC/APC" },
        { code: "J", description: "LC/PC" },
        { code: "K", description: "SC/APC" },
        { code: "L", description: "SC/PC" },
        { code: "M", description: "MU/PC" },
        { code: "N", description: "MU/APC" },
        { code: "Q", description: "CS/UPC" },
        { code: "R", description: "MDC/APC" },
        { code: "S", description: "MDC/PC" },
        { code: "T", description: "D4" },
        { code: "U", description: "SN" },
        { code: "P", description: "Others" },
        { code: "X", description: "No Connector" }
      ]
    },

    {
      index: 2,
      label: "Connector Type End 2",
      required: true,
      options: [
        { code: "A", description: "MPO/PC (Male)" },
        { code: "B", description: "MPO/APC (Male)" },
        { code: "C", description: "MPO/PC (Female)" },
        { code: "D", description: "MPO/APC (Female)" },
        { code: "E", description: "Fiber Array" },
        { code: "F", description: "FC/PC" },
        { code: "G", description: "FC/APC" },
        { code: "H", description: "LC/APC" },
        { code: "J", description: "LC/PC" },
        { code: "K", description: "SC/APC" },
        { code: "L", description: "SC/PC" },
        { code: "M", description: "MU/PC" },
        { code: "N", description: "MU/APC" },
        { code: "Q", description: "CS/UPC" },
        { code: "R", description: "MDC/APC" },
        { code: "S", description: "MDC/PC" },
        { code: "T", description: "D4" },
        { code: "U", description: "SN" },
        { code: "P", description: "Others" },
        { code: "X", description: "No Connector" }
      ]
    },

    {
      index: 3,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "ITU G.652D Compliant (Singlemode)" },
        { code: "2", description: "ITU G.657A1 Compliant (Singlemode)" },
        { code: "3", description: "ITU G.657A2/B2 Compliant (Singlemode)" },
        { code: "4", description: "ITU G.657B3 Compliant (Singlemode)" },
        { code: "5", description: "OM1 62.5/125um (Multimode)" },
        { code: "6", description: "OM2 50/125um (Multimode)" },
        { code: "7", description: "OM3 50/125um (Multimode)" },
        { code: "8", description: "OM4 50/125um (Multimode)" }
      ]
    },

    {
      index: 4,
      label: "Cordage Diameter",
      required: true,
      options: [
        { code: "A", description: "250um Bare Fiber" },
        { code: "B", description: "900um Tight Buffer" },
        { code: "C", description: "1.2mm" },
        { code: "D", description: "1.6mm" },
        { code: "E", description: "2.0mm" },
        { code: "F", description: "3.0mm" },
        { code: "G", description: "3.8mm" },
        { code: "H", description: "4.0mm" },
        { code: "J", description: "4.5mm" },
        { code: "K", description: "5.0mm" },
        { code: "L", description: "5.5mm" },
        { code: "M", description: "11mm" },
        { code: "N", description: "18mm" },
        { code: "Q", description: "2x3mm" },
        { code: "R", description: "Oval Ribbon Cable" },
        { code: "S", description: "165um Bare Fiber" },
        { code: "T", description: "10.5mm" },
        { code: "U", description: "14mm" },
        { code: "V", description: "15mm" },
        { code: "W", description: "16mm" },
        { code: "Y", description: "21mm" },
        { code: "P", description: "Others" }
      ]
    },

    {
      index: 5,
      label: "Jacket Rating",
      required: true,
      options: [
        { code: "1", description: "LSZH" },
        { code: "2", description: "Nylon" },
        { code: "3", description: "Plenum" },
        { code: "4", description: "Polyethylene (PE)" },
        { code: "5", description: "Riser" },
        { code: "6", description: "PUR" },
        { code: "7", description: "PVC" },
        { code: "8", description: "Indoor/Outdoor (I/O)" },
        { code: "9", description: "Riser-LSZH" },
        { code: "P", description: "Others" },
        { code: "X", description: "Non-jacketed" }
      ]
    },

    {
      index: 6,
      label: "Fiber Count",
      required: true,
      options: [
        { code: "A", description: "8 Fiber (Ribbon Bare Fiber)" },
        { code: "B", description: "12 Fiber (Ribbon Bare Fiber)" },
        { code: "C", description: "24 Fiber (Ribbon Bare Fiber)" },
        { code: "D", description: "16 Fiber (Ribbon Bare Fiber)" },
        { code: "E", description: "32 Fiber (Ribbon Bare Fiber)" },
        { code: "F", description: "4 Fiber (Distribution Bare Fiber)" },
        { code: "G", description: "12 Fiber (Distribution Bare Fiber)" },
        { code: "H", description: "24 Fiber (Distribution Bare Fiber)" },
        { code: "J", description: "16 Fiber (Distribution Bare Fiber)" },
        { code: "K", description: "32 Fiber (Distribution Bare Fiber)" },
        { code: "L", description: "8 Fiber (Distribution Bare Fiber)" },
        { code: "M", description: "72 Fiber (Distribution Bare Fiber)" },
        { code: "N", description: "144 Fiber (Distribution Bare Fiber)" },
        { code: "Q", description: "288 Fiber (Distribution Bare Fiber)" },
        { code: "R", description: "2 Fiber (Distribution Bare Fiber)" },
        { code: "S", description: "4 Fiber (Distribution Bare Fiber)" },
        { code: "T", description: "6 Fiber (Distribution Bare Fiber)" },
        { code: "U", description: "432 Fiber (Distribution Bare Fiber)" },
        { code: "V", description: "864 Fiber (Distribution Bare Fiber)" },
        { code: "P", description: "Others" }
      ]
    },

    {
      index: 7,
      label: "Length Designator",
      required: true,
      options: [
        { code: "C", description: "Length in Centimeters" },
        { code: "M", description: "Length in Meters" },
        { code: "F", description: "Length in Feet" },
        { code: "K", description: "Length in Kilometers" },
        { code: "D", description: "Length in Decimeters" }
      ]
    },

    {
      index: 8,
      label: "Fiber Length - Digit 1",
      group: "fiberLength",
      required: true,
      options: "0-9"
    },

    {
      index: 9,
      label: "Fiber Length - Digit 2",
      group: "fiberLength",
      required: true,
      options: "0-9"
    },

    {
      index: 10,
      label: "Fiber Length - Digit 3",
      group: "fiberLength",
      required: true,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "fiberLength",
      label: "Fiber Length",
      indexes: [8, 9, 10],
      description:
        "3 digit length. Unit depends on the Length Designator selected in position 8.",
      allowNumeric: true
    }
  ],

  notes: [
    "All cable assemblies may be custom configured as required for specific applications.",
    "If the needed configuration is not listed, contact CustomerService@gofoton.com."
  ]
},

{
  id: "fiberfast-indoor-living-unit-ilu-solutions",
  familyCode: "J",
  matchPrefix: "J",
  minLength: 5,
  maxLength: 12,
  lookupOnly: true,
  productName: "Fiber!FAST® Indoor Living Unit (ILU) Solutions",
  productPage: "/fiberfast-indoor-living-unit-ilu-solutions",
  datasheet: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FFiber-Fast-Indoor-Living-Unit-Solutions.pdf?alt=media&token=82d9ee47-592b-453b-87ad-b27165816d35",

  positions: [
    {
      index: 0,
      label: "Product Family",
      required: true,
      options: [
        { code: "J", description: "Fiber!FAST® Indoor Living Unit (ILU) Solutions" }
      ]
    },
    {
      index: 1,
      label: "Product Type",
      required: true,
      options: [
        { code: "X", description: "Optical Fiber ILU" },
        { code: "A", description: "Accessory Clip-A Plastic Indoor" },
        { code: "B", description: "Accessory Clip-B Plastic Indoor" },
        { code: "C", description: "Indoor Optical Outlet Box" }
      ]
    },
    {
      index: 2,
      label: "Product Variant",
      required: false,
      options: [
        { code: "X", description: "Optical Fiber ILU variant" },
        { code: "1", description: "Accessory / outlet box variant" }
      ]
    },
    {
      index: 3,
      label: "Product Variant",
      required: false,
      options: [
        { code: "4", description: "Optical Fiber ILU variant" },
        { code: "A", description: "Accessory Clip-A / Indoor Optical Outlet Box variant" },
        { code: "B", description: "Accessory Clip-B variant" }
      ]
    },
    {
      index: 4,
      label: "Product Variant",
      required: false,
      options: [
        { code: "B", description: "Optical Fiber ILU variant" },
        { code: "1", description: "Accessory variant" },
        { code: "2", description: "Indoor Optical Outlet Box variant" }
      ]
    },
    {
      index: 5,
      label: "Fiber Type / Configuration",
      required: false,
      options: [
        { code: "2", description: "Optical Fiber ILU configuration" }
      ]
    },
    {
      index: 6,
      label: "Fiber Type / Configuration",
      required: false,
      options: [
        { code: "A", description: "Optical Fiber ILU configuration" }
      ]
    },
    {
      index: 7,
      label: "Length / Configuration",
      required: false,
      options: [
        { code: "M", description: "Optical Fiber ILU length/configuration" }
      ]
    },
    {
      index: 8,
      label: "Length / Configuration",
      required: false,
      options: [
        { code: "3", description: "350M / 3500 depending on full code" }
      ]
    },
    {
      index: 9,
      label: "Length / Configuration",
      required: false,
      options: [
        { code: "5", description: "350M / 3500 depending on full code" }
      ]
    }
  ],

  groupedOptions: [
    {
      group: "knownPartNumbers",
      label: "Known Part Numbers",
      indexes: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      options: [
        {
          code: "JXX4B2AM350B",
          description: "OPTICAL FIBER ILU 0.9MM 350M GR"
        },
        {
          code: "JA1A1001",
          description: "ACCESSORY CLIP-A PLASTIC INDOOR (Inside Limiters)"
        },
        {
          code: "JB1A1001",
          description: "ACCESSORY CLIP-B PLASTIC INDOOR (Outside Limiters)"
        },
        {
          code: "JC1A2B",
          description: "INDOOR OPTICAL OUTLET BOX"
        }
      ]
    }
  ],

  knownPartNumbers: [
    {
      code: "JXX4B2AM350B",
      description: "OPTICAL FIBER ILU 0.9MM 350M GR"
    },
    {
      code: "JA1A1001",
      description: "ACCESSORY CLIP-A PLASTIC INDOOR (Inside Limiters)"
    },
    {
      code: "JB1A1001",
      description: "ACCESSORY CLIP-B PLASTIC INDOOR (Outside Limiters)"
    },
    {
      code: "JC1A2B",
      description: "INDOOR OPTICAL OUTLET BOX"
    }
  ]
},

{
  id: "mpo-lc-loopbacks",
  familyCode: "J",
  matchPrefix: "J",
  minLength: 10,
  maxLength: 10,
  productName: "MPO and LC Loopbacks",
  productPage: "/mpo-and-lc-loopbacks",
  datasheet: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FLoopbacks.pdf?alt=media&token=9e768beb-f8b1-457e-b6c5-24343643ebc8",

  positions: [
    {
      index: 0,
      label: "Product Family",
      required: true,
      options: [
        { code: "J", description: "LC Connector Loopback" },
        { code: "M", description: "MPO Connector Loopback" }
      ]
    },
    {
      index: 1,
      label: "Connector Type End",
      required: true,
      options: [
        { code: "D", description: "LC Loopback connector type" },
        { code: "C", description: "MPO OM3 loopback connector type" },
        { code: "D", description: "MPO singlemode loopback connector type" }
      ]
    },
    {
      index: 2,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "4", description: "Singlemode LC / MPO loopback fiber type" },
        { code: "7", description: "OM3 multimode MPO loopback fiber type" }
      ]
    },
    {
      index: 3,
      label: "Cordage Diameter",
      required: true,
      options: [
        { code: "A", description: "Loopback cordage / configuration" }
      ]
    },
    {
      index: 4,
      label: "Jacket Rating",
      required: true,
      options: [
        { code: "X", description: "Loopback jacket / configuration" }
      ]
    },
    {
      index: 5,
      label: "Fiber Count",
      required: true,
      options: [
        { code: "B", description: "LC loopback fiber count" },
        { code: "L", description: "8F MPO Loopback" },
        { code: "M", description: "12F MPO Loopback" },
        { code: "N", description: "24F MPO Loopback" }
      ]
    },
    {
      index: 6,
      label: "Length Designator",
      required: true,
      options: [
        { code: "M", description: "Length in Meters" }
      ]
    },
    {
      index: 7,
      label: "Fiber Length - Digit 1",
      group: "fiberLength",
      required: true,
      options: "0-9"
    },
    {
      index: 8,
      label: "Fiber Length - Digit 2",
      group: "fiberLength",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "Fiber Length - Digit 3",
      group: "fiberLength",
      required: true,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "fiberLength",
      label: "Fiber Length",
      indexes: [7, 8, 9],
      description: "3 digit length. Loopback examples use 000.",
      allowNumeric: true
    },
    {
      group: "knownPartNumbers",
      label: "Known Loopback Model Codes",
      indexes: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      options: [
        {
          code: "JDD4XBM000",
          description: "SM LC Loopback"
        },
        {
          code: "JDD7XBM000",
          description: "MM LC Loopback (OM3)"
        },
        {
          code: "MDX4AXLM000",
          description: "SM 8F MPO Loopback"
        },
        {
          code: "MDX4AXM000",
          description: "SM 12F MPO Loopback"
        },
        {
          code: "MDX4AXNM000",
          description: "SM 24F MPO Loopback"
        },
        {
          code: "MCX7AXLM000",
          description: "MM 8F MPO Loopback (OM3)"
        },
        {
          code: "MCX7AXM000",
          description: "MM 12F MPO Loopback (OM3)"
        },
        {
          code: "MCX7AXNM000",
          description: "MM 24F MPO Loopback (OM3)"
        }
      ]
    }
  ],

  knownPartNumbers: [
    {
      code: "JDD4XBM000",
      description: "SM LC Loopback"
    },
    {
      code: "JDD7XBM000",
      description: "MM LC Loopback (OM3)"
    },
    {
      code: "MDX4AXLM000",
      description: "SM 8F MPO Loopback"
    },
    {
      code: "MDX4AXM000",
      description: "SM 12F MPO Loopback"
    },
    {
      code: "MDX4AXNM000",
      description: "SM 24F MPO Loopback"
    },
    {
      code: "MCX7AXLM000",
      description: "MM 8F MPO Loopback (OM3)"
    },
    {
      code: "MCX7AXM000",
      description: "MM 12F MPO Loopback (OM3)"
    },
    {
      code: "MCX7AXNM000",
      description: "MM 24F MPO Loopback (OM3)"
    }
  ]
},
{
  id: "large-peacoc-multiport-mid-span-terminal-mmt",
  familyCode: "P",
  matchPrefix: "PMM",
  minLength: 12,
  maxLength: 12,
  productName: "Large PEACOC® Multiport Mid-Span Terminal (MMT)",
  productPage: "/large-peacoc-multiport-mid-span-terminal-mmt",
  datasheet: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FGoFoton%20Product%20Data%20Sheet%20-%20MMT%20Family%2010.25.pdf?alt=media&token=a74154a0-52c5-4c8b-8072-d4aa7aa15ff0",

  positions: [
    {
      index: 0,
      label: "Product Family",
      required: true,
      options: [{ code: "P", description: "PEACOC" }]
    },
    {
      index: 1,
      label: "Product Type",
      required: true,
      options: [{ code: "M", description: "Multiport Mid-Span Terminal" }]
    },
    {
      index: 2,
      label: "Terminal Size",
      required: true,
      options: [{ code: "M", description: "Large MMT" }]
    },
    {
      index: 3,
      label: "Terminal Type",
      required: true,
      options: [
        { code: "S", description: "Splitter" },
        { code: "L", description: "Splice" },
        { code: "T", description: "Engineered TAPs" }
      ]
    },
    {
      index: 4,
      label: "Installed Adapters/Pigtails",
      required: true,
      options: [
        { code: "2", description: "2 ports" },
        { code: "4", description: "4 ports" },
        { code: "8", description: "8 ports" },
        { code: "L", description: "12 ports" },
        { code: "P", description: "16 ports" },
        { code: "X", description: "None" }
      ]
    },
    {
      index: 5,
      label: "Adapter Type",
      required: true,
      options: [
        { code: "1", description: "LC/UPC" },
        { code: "2", description: "LC/APC" },
        { code: "3", description: "SC/UPC" },
        { code: "4", description: "SC/APC" },
        { code: "X", description: "None" }
      ]
    },
    {
      index: 6,
      label: "Optical Components - Character 1",
      group: "opticalComponents",
      required: true,
      options: [
        { code: "X", description: "Splitter component prefix" },
        { code: "0", description: "Splice component prefix" },
        { code: "1", description: "Splice component prefix" },
        { code: "T", description: "Engineered TAP code prefix" }
      ]
    },
    {
      index: 7,
      label: "Optical Components - Character 2",
      group: "opticalComponents",
      required: true,
      options: "0-9"
    },
    {
      index: 8,
      label: "Optical Components - Character 3",
      group: "opticalComponents",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "Optical Components - Character 4",
      group: "opticalComponents",
      required: true,
      options: "0-9"
    },
    {
      index: 10,
      label: "Feeder/Branch Port",
      required: true,
      options: [
        { code: "B", description: "Bottom only (butt splice)" },
        { code: "T", description: "Top & bottom (inline splice)" }
      ]
    },
    {
      index: 11,
      label: "Drop Cable Ports",
      required: true,
      options: [
        {
          code: "1",
          description: "3.0mm & 4.8mm round; 8.4mm x 4.6mm standard flat"
        },
        {
          code: "2",
          description: "4.8mm round; 8.4mm x 4.6mm standard flat"
        }
      ]
    }
  ],

  groupedOptions: [
    {
      group: "opticalComponents",
      label: "Optical Components",
      indexes: [6, 7, 8, 9],
      description:
        "Total part number length varies by terminal type. Splitter terminals use all four digits, splice terminals use three digits, and engineered TAP terminals use two digits.",
      options: [
        { code: "X102", description: "Splitter: 1 set of 1x2" },
        { code: "X104", description: "Splitter: 1 set of 1x4" },
        { code: "X204", description: "Splitter: 2 sets of 1x4" },
        { code: "X108", description: "Splitter: 1 set of 1x8" },
        { code: "X304", description: "Splitter: 3 sets of 1x4" },
        { code: "X404", description: "Splitter: 4 sets of 1x4" },
        { code: "X208", description: "Splitter: 2 sets of 1x8" },
        { code: "X116", description: "Splitter: 1 set of 1x16" },
        { code: "096", description: "Splice: 96 fibers (inline splice)" },
        { code: "114", description: "Splice: 144 fibers (butt splice)" }
      ]
    }
  ]
},

{
  id: "mid-size-peacoc-multiport-mid-span-terminal-mmt",
  familyCode: "P",
  matchPrefix: "PM12",
  minLength: 12,
  maxLength: 12,
  productName: "Mid-Size PEACOC® Multiport Mid-Span Terminal (MMT)",
  productPage: "/mid-size-peacoc-multiport-mid-span-terminal-mmt",
  datasheet: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FGoFoton%20Product%20Data%20Sheet%20-%20MMT%20Family%2010.25.pdf?alt=media&token=a74154a0-52c5-4c8b-8072-d4aa7aa15ff0",

  positions: [
    {
      index: 0,
      label: "Product Family",
      required: true,
      options: [{ code: "P", description: "PEACOC" }]
    },
    {
      index: 1,
      label: "Product Type",
      required: true,
      options: [{ code: "M", description: "Multiport Mid-Span Terminal" }]
    },
    {
      index: 2,
      label: "MMT Size Digit 1",
      required: true,
      options: [{ code: "1", description: "Mid-Size MMT" }]
    },
    {
      index: 3,
      label: "MMT Size Digit 2",
      required: true,
      options: [{ code: "2", description: "Mid-Size MMT" }]
    },
    {
      index: 4,
      label: "Connector/Adapter Type",
      required: true,
      options: [
        { code: "1", description: "LC/UPC" },
        { code: "2", description: "LC/APC" },
        { code: "3", description: "SC/UPC" },
        { code: "4", description: "SC/APC" },
        { code: "X", description: "None - splice only" }
      ]
    },
    {
      index: 5,
      label: "Installed Pigtails",
      required: true,
      options: [
        { code: "2", description: "2 pigtails" },
        { code: "4", description: "4 pigtails" },
        { code: "8", description: "8 pigtails" },
        { code: "L", description: "12 pigtails" },
        { code: "N", description: "None or pre-installed splitter/TAP" }
      ]
    },
    {
      index: 6,
      label: "Installed Adapters",
      required: true,
      options: [
        { code: "2", description: "2 adapters" },
        { code: "4", description: "4 adapters" },
        { code: "8", description: "8 adapters" },
        { code: "L", description: "12 adapters" },
        { code: "N", description: "None" }
      ]
    },
    {
      index: 7,
      label: "Optical Components - Character 1",
      group: "opticalComponents",
      required: true,
      options: [
        { code: "L", description: "144F splice prefix" },
        { code: "1", description: "Splitter prefix" },
        { code: "2", description: "Splitter prefix" },
        { code: "T", description: "Engineered TAP code prefix" }
      ]
    },
    {
      index: 8,
      label: "Optical Components - Character 2",
      group: "opticalComponents",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "Optical Components - Character 3",
      group: "opticalComponents",
      required: true,
      options: "0-9"
    },
    {
      index: 10,
      label: "Drop Cable Ports",
      required: true,
      options: [
        { code: "1", description: "8.4mm x 4.6mm standard flat" },
        { code: "2", description: "4.8mm round; 5.4mm x 3.0mm micro flat" },
        {
          code: "3",
          description: "3.0mm round, 4.8mm round, 8.4mm x 4.6mm standard flat"
        }
      ]
    },
    {
      index: 11,
      label: "Mounting Bracket",
      required: true,
      options: [
        { code: "A", description: "Universal Mounting Bracket" },
        { code: "B", description: "Universal Mounting Bracket + Grounding Kit" }
      ]
    }
  ],

  groupedOptions: [
    {
      group: "opticalComponents",
      label: "Optical Components",
      indexes: [7, 8, 9],
      description:
        "Optical component selection. Engineered TAPs use a 2-digit code from the TAPs list.",
      options: [
        { code: "L01", description: "144F splice" },
        { code: "102", description: "1x2 splitter" },
        { code: "104", description: "1x4 splitter" },
        { code: "204", description: "2 sets of 1x4 splitters" },
        { code: "108", description: "1x8 splitter" }
      ]
    }
  ]
},

{
  id: "small-peacoc-multiport-mid-span-terminal-mmt",
  familyCode: "P",
  matchPrefix: "PM4",
  minLength: 12,
  maxLength: 12,
  productName: "Small PEACOC® Multiport Mid-Span Terminal (MMT)",
  productPage: "/small-peacoc-multiport-mid-span-terminal-mmt",
  datasheet: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FGoFoton%20Product%20Data%20Sheet%20-%20MMT%20Family%2010.25.pdf?alt=media&token=a74154a0-52c5-4c8b-8072-d4aa7aa15ff0",

  positions: [
    {
      index: 0,
      label: "Product Family",
      required: true,
      options: [{ code: "P", description: "PEACOC" }]
    },
    {
      index: 1,
      label: "Product Type",
      required: true,
      options: [{ code: "M", description: "Multiport Mid-Span Terminal" }]
    },
    {
      index: 2,
      label: "MMT Size",
      required: true,
      options: [{ code: "4", description: "Small MMT" }]
    },
    {
      index: 3,
      label: "Connector/Adapter Type",
      required: true,
      options: [
        { code: "1", description: "LC/UPC" },
        { code: "2", description: "LC/APC" },
        { code: "3", description: "SC/UPC" },
        { code: "4", description: "SC/APC" },
        { code: "X", description: "None - splice only" }
      ]
    },
    {
      index: 4,
      label: "Installed Pigtails",
      required: true,
      options: [
        { code: "2", description: "2 pigtails" },
        { code: "4", description: "4 pigtails" },
        { code: "N", description: "None or pre-installed splitter/TAP" }
      ]
    },
    {
      index: 5,
      label: "Installed Adapters",
      required: true,
      options: [
        { code: "2", description: "2 adapters" },
        { code: "4", description: "4 adapters" },
        { code: "N", description: "None" }
      ]
    },
    {
      index: 6,
      label: "Optical Components - Character 1",
      group: "opticalComponents",
      required: true,
      options: [
        { code: "L", description: "24F splice prefix" },
        { code: "1", description: "Splitter prefix" },
        { code: "T", description: "Engineered TAP prefix" }
      ]
    },
    {
      index: 7,
      label: "Optical Components - Character 2",
      group: "opticalComponents",
      required: true,
      options: "0-9"
    },
    {
      index: 8,
      label: "Optical Components - Character 3",
      group: "opticalComponents",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "Plug-and-Play TAP / Splitter Input",
      required: true,
      options: [
        { code: "A", description: "Yes" },
        { code: "B", description: "No" }
      ]
    },
    {
      index: 10,
      label: "Drop Cable Ports",
      required: true,
      options: [
        {
          code: "2",
          description: "3.0mm round, 4.8mm round, 8.4mm x 4.6mm standard flat"
        },
        { code: "3", description: "5.4mm x 3.0mm micro flat" }
      ]
    },
    {
      index: 11,
      label: "Mounting Bracket",
      required: true,
      options: [
        { code: "A", description: "Universal Mounting Bracket" },
        { code: "B", description: "Universal Mounting Bracket + Grounding Kit" }
      ]
    }
  ],

  groupedOptions: [
    {
      group: "opticalComponents",
      label: "Optical Components",
      indexes: [6, 7, 8],
      description:
        "Optical component selection. Engineered TAPs use a 2-digit code from the TAPs list.",
      options: [
        { code: "L01", description: "24F splice" },
        { code: "102", description: "1x2 splitter" },
        { code: "104", description: "1x4 splitter" }
      ]
    }
  ]
},

{
  id: "core-kit-12f-splice",
  familyCode: "C",
  matchPrefix: "CO",
  lookupOnly: true,
  allowPrefixMatch: true,
  minLength: 9,
  maxLength: 10,
  productName: "CORE Kit",
  productPage: "/core-kit",
  datasheet: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FConnect%20or%20Repair%20Enclosure%20Kit%20Datasheet.pdf?alt=media&token=74883a01-f5e5-4e4d-89d3-28285be4a7ae",

  positions: [
    { index: 0, label: "Model Code", required: true, options: "A-Z" },
    { index: 1, label: "Model Code", required: true, options: "A-Z" },
    { index: 2, label: "Model Code", required: true, options: "A-Z" },
    { index: 3, label: "Model Code", required: true, options: "A-Z" },
    { index: 4, label: "Model Code", required: true, options: "A-Z0-9" },
    { index: 5, label: "Model Code", required: true, options: "A-Z0-9" },
    { index: 6, label: "Model Code", required: true, options: "A-Z0-9" },
    { index: 7, label: "Model Code", required: true, options: "A-Z0-9" },
    { index: 8, label: "Model Code", required: true, options: "A-Z0-9" },
    { index: 9, label: "Model Code", required: false, options: "A-Z0-9" }
  ],

  groupedOptions: [
    {
      group: "knownPartNumbers",
      label: "Known Part Numbers",
      indexes: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      options: [
        {
          code: "CORE12FXX",
          description: "CORE Kit, 12F splice"
        },
        {
          code: "PMHTGB010",
          description: "3-12mm cable grommet, 10pcs"
        },
        {
          code: "7MMGMT010",
          description: "7mm microduct grommet, 10pcs"
        },
        {
          code: "MFTGMT010",
          description: "Micro flat 5.4mm x 3.0mm grommet, 10pcs"
        },
        {
          code: "STDGMT010",
          description: "Standard flat 8.4mm x 4.6mm grommet, 10pcs"
        },
        {
          code: "CORESCA005",
          description: "SC/APC adapter bulkhead, 5pcs"
        },
        {
          code: "CORECMPKIT",
          description: "Strength member clamp kit"
        },
        {
          code: "COREBDGKIT",
          description: "Bonding clamp kit"
        }
      ]
    }
  ],

  knownPartNumbers: [
    {
      code: "CORE12FXX",
      description: "CORE Kit, 12F splice"
    },
    {
      code: "PMHTGB010",
      description: "3-12mm cable grommet, 10pcs"
    },
    {
      code: "7MMGMT010",
      description: "7mm microduct grommet, 10pcs"
    },
    {
      code: "MFTGMT010",
      description: "Micro flat 5.4mm x 3.0mm grommet, 10pcs"
    },
    {
      code: "STDGMT010",
      description: "Standard flat 8.4mm x 4.6mm grommet, 10pcs"
    },
    {
      code: "CORESCA005",
      description: "SC/APC adapter bulkhead, 5pcs"
    },
    {
      code: "CORECMPKIT",
      description: "Strength member clamp kit"
    },
    {
      code: "COREBDGKIT",
      description: "Bonding clamp kit"
    }
  ],

  notes: [
    "This schema uses known part number lookup only.",
    "Accessory part numbers identify the accessory name, but the product page and datasheet still route to the main CORE Kit page."
  ],

  example: {
    code: "CORE12FXX",
    description: "CORE Kit, 12F splice"
  }
},
{
  id: "peacoc-compact-osp-terminal",
  familyCode: "P",
  matchPrefix: "PCT",
  minLength: 7,
  maxLength: 12,
  productName: "PEACOC® Compact OSP Terminal",
  productPage: "/peacoc-compact-osp-terminal",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FPEACOC%20Compact%20OSP%20Terminal%20Datasheet.pdf?alt=media&token=8c02d8bf-624f-43a2-956e-b7ffc3367436",

  positions: [
    {
      index: 0,
      label: "Product Family",
      group: "productType",
      required: true,
      options: [{ code: "P", description: "PEACOC" }]
    },
    {
      index: 1,
      label: "Product Type - Character 1",
      group: "productType",
      required: true,
      options: [{ code: "C", description: "Compact OSP prefix" }]
    },
    {
      index: 2,
      label: "Product Type - Character 2",
      group: "productType",
      required: true,
      options: [{ code: "T", description: "Compact OSP Terminal" }]
    },

    {
      index: 3,
      label: "Version",
      required: true,
      options: [
        { code: "P", description: "Pre-terminated / stubbed" },
        { code: "N", description: "Non-stubbed" },
        { code: "M", description: "Non-stubbed with MPO input" },
        { code: "L", description: "Splice loose tube" },
        { code: "R", description: "Splice ribbon" }
      ]
    },

    {
      index: 4,
      label: "Number of Ports - Digit 1",
      group: "numberOfPorts",
      required: true,
      options: "0-9"
    },
    {
      index: 5,
      label: "Number of Ports - Digit 2",
      group: "numberOfPorts",
      required: true,
      options: "0-9"
    },

    {
      index: 6,
      label: "Adapter Type",
      required: true,
      options: [
        { code: "1", description: "LC/UPC (blue) simplex" },
        { code: "2", description: "LC/APC (green) simplex" },
        { code: "3", description: "LC/UPC (aqua) simplex" },
        { code: "4", description: "SC/UPC (blue) simplex" },
        { code: "5", description: "SC/APC (green) simplex" },
        { code: "6", description: "SC/UPC (aqua) simplex" },
        { code: "7", description: "MPO (black)" }
      ]
    },

    {
      index: 7,
      label: "F1 Input Cable Type",
      required: false,
      options: [
        { code: "A", description: "12F OSP loose tube all dry" },
        { code: "B", description: "12F OSP ribbon all dry" },
        { code: "C", description: "24F OSP loose tube all dry" },
        { code: "D", description: "24F OSP ribbon all dry" },
        { code: "E", description: "48F OSP loose tube all dry" },
        { code: "F", description: "48F OSP ribbon all dry" },
        { code: "G", description: "12F OSP armored" },
        { code: "H", description: "72F indoor loose tube" },
        { code: "J", description: "72F indoor ribbon" },
        { code: "K", description: "144F indoor loose tube" },
        { code: "L", description: "144F indoor ribbon" }
      ]
    },

    {
      index: 8,
      label: "Unit of Measurement",
      required: false,
      options: [
        { code: "F", description: "Feet" },
        { code: "M", description: "Meters" },
        { code: "K", description: "Kilometers" }
      ]
    },

    {
      index: 9,
      label: "Stub Cable Length - Digit 1",
      group: "stubCableLength",
      required: false,
      options: "0-9"
    },
    {
      index: 10,
      label: "Stub Cable Length - Digit 2",
      group: "stubCableLength",
      required: false,
      options: "0-9"
    },
    {
      index: 11,
      label: "Stub Cable Length - Digit 3",
      group: "stubCableLength",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productType",
      label: "Product Type",
      indexes: [0, 1, 2],
      options: [
        { code: "PCT", description: "PEACOC® Compact OSP Terminal" }
      ]
    },
    {
      group: "numberOfPorts",
      label: "Number of Ports",
      indexes: [4, 5],
      options: [
        { code: "06", description: "6 ports" },
        { code: "12", description: "12 ports" },
        { code: "16", description: "16 ports" },
        { code: "24", description: "24 ports" },
        { code: "36", description: "36 ports" },
        { code: "48", description: "48 ports" }
      ]
    },
    {
      group: "stubCableLength",
      label: "Stub Cable Length",
      indexes: [9, 10, 11],
      description: "3-digit stub cable length. Only used for stubbed/pre-terminated configurations.",
      allowNumeric: true
    }
  ],

  notes: [
    "Non-stubbed configurations may stop after the adapter type, such as PCTN122.",
    "Stubbed/pre-terminated configurations continue with F1 input cable type, unit of measurement, and 3-digit stub cable length, such as PCTP122AF100.",
    "Customer Code and Product Series are only applicable for products not covered by the standard specification."
  ],

  examples: [
    {
      code: "PCTN122",
      description:
        "OSP Compact Terminal, non-stubbed version, 12 ports, LC/APC adapters only."
    },
    {
      code: "PCTP122AF100",
      description:
        "OSP Compact Terminal, stubbed version, 12 ports, LC/APC, 12F OSP loose tube all dry, 100 feet."
    }
  ]
},

{
  id: "peacoc-compact-osp-dwdm-terminal",
  familyCode: "P",
  matchPrefix: "PCTD",
  minLength: 14,
  maxLength: 14,
  productName: "PEACOC® Compact OSP Terminal",
  productPage: "/peacoc-compact-osp-terminal",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FPEACOC%20Compact%20OSP%20Terminal%20Datasheet.pdf?alt=media&token=8c02d8bf-624f-43a2-956e-b7ffc3367436",

  positions: [
    {
      index: 0,
      label: "Product Family",
      group: "productType",
      required: true,
      options: [{ code: "P", description: "PEACOC" }]
    },
    {
      index: 1,
      label: "Product Type - Character 1",
      group: "productType",
      required: true,
      options: [{ code: "C", description: "Compact OSP prefix" }]
    },
    {
      index: 2,
      label: "Product Type - Character 2",
      group: "productType",
      required: true,
      options: [{ code: "T", description: "Terminal prefix" }]
    },
    {
      index: 3,
      label: "Terminal Type",
      group: "productType",
      required: true,
      options: [{ code: "D", description: "DWDM Terminal" }]
    },

    {
      index: 4,
      label: "Adapter Type",
      required: true,
      options: [
        { code: "A", description: "LC/UPC (blue) simplex" },
        { code: "B", description: "LC/APC (green) simplex" },
        { code: "C", description: "LC/UPC (blue) duplex" },
        { code: "D", description: "LC/APC (green) duplex" },
        { code: "E", description: "SC/UPC (blue) simplex" },
        { code: "F", description: "SC/APC (green) simplex" },
        { code: "P", description: "Others" }
      ]
    },
    {
      index: 5,
      label: "Configuration Type",
      required: true,
      options: [
        { code: "1", description: "No test port" },
        { code: "2", description: "With single test port (STP)" },
        { code: "3", description: "With dual test port (DTP)" },
        { code: "4", description: "With express port (EXP)" },
        { code: "5", description: "With upgrade port (UPG)" },
        { code: "6", description: "With UPG + DTP" },
        { code: "7", description: "With EXP + DTP" },
        { code: "8", description: "With EXP + UPG + DTP" },
        { code: "9", description: "Custom configuration" }
      ]
    },

    {
      index: 6,
      label: "Channel Configuration - Character 1",
      group: "channelConfiguration",
      required: true,
      options: [
        { code: "A", description: "Channel configuration prefix" },
        { code: "B", description: "Channel configuration prefix" },
        { code: "C", description: "Channel configuration prefix" },
        { code: "D", description: "Channel configuration prefix" },
        { code: "_", description: "Other combinations" }
      ]
    },
    {
      index: 7,
      label: "Channel Configuration - Character 2",
      group: "channelConfiguration",
      required: true,
      options: [
        { code: "1", description: "1x4 channel set" },
        { code: "2", description: "1x8 channel set" },
        { code: "3", description: "1x12 channel set" },
        { code: "4", description: "1x16 channel set" },
        { code: "5", description: "1x20 channel set" },
        { code: "_", description: "Other combinations" }
      ]
    },
    {
      index: 8,
      label: "Channel Configuration - Character 3",
      group: "channelConfiguration",
      required: true,
      options: [
        { code: "M", description: "Mux" },
        { code: "D", description: "Demux" },
        { code: "_", description: "Other combinations" }
      ]
    },

    {
      index: 9,
      label: "Channel ID",
      required: true,
      options: [{ code: "C", description: "C-band" }]
    },
    {
      index: 10,
      label: "Shortest Channel - Digit 1",
      group: "shortestChannel",
      required: true,
      options: "0-9"
    },
    {
      index: 11,
      label: "Shortest Channel - Digit 2",
      group: "shortestChannel",
      required: true,
      options: "0-9"
    },
    {
      index: 12,
      label: "Longest Channel - Digit 1",
      group: "longestChannel",
      required: true,
      options: "0-9"
    },
    {
      index: 13,
      label: "Longest Channel - Digit 2",
      group: "longestChannel",
      required: true,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productType",
      label: "Product Type",
      indexes: [0, 1, 2, 3],
      options: [
        { code: "PCTD", description: "PEACOC Compact OSP DWDM Terminal" }
      ]
    },
    {
      group: "channelConfiguration",
      label: "Channel Configuration",
      indexes: [6, 7, 8],
      options: [
        { code: "A1M", description: "1x4 CH Mux" },
        { code: "A1D", description: "1x4 CH Demux" },
        { code: "B1M", description: "Dual 1x4 CH Mux" },
        { code: "B1D", description: "Dual 1x4 CH Demux" },
        { code: "C1M", description: "Triple 1x4 CH Mux" },
        { code: "C1D", description: "Triple 1x4 CH Demux" },
        { code: "D1M", description: "Quad 1x4 CH Mux" },
        { code: "D1D", description: "Quad 1x4 CH Demux" },
        { code: "A2M", description: "1x8 CH Mux" },
        { code: "A2D", description: "1x8 CH Demux" },
        { code: "B2M", description: "Dual 1x8 CH Mux" },
        { code: "B2D", description: "Dual 1x8 CH Demux" },
        { code: "A3M", description: "1x12 CH Mux" },
        { code: "A3D", description: "1x12 CH Demux" },
        { code: "B3M", description: "Dual 1x12 CH Mux" },
        { code: "B3D", description: "Dual 1x12 CH Demux" },

        { code: "A4M", description: "1x16 CH Mux" },
        { code: "A4D", description: "1x16 CH Demux" },
        { code: "A5M", description: "1x20 CH Mux" },
        { code: "A5D", description: "1x20 CH Demux" },

        { code: "___", description: "Other combinations" }
      ]
    },
    {
      group: "shortestChannel",
      label: "Shortest Channel",
      indexes: [10, 11],
      description: "Channel number of the shortest wavelength.",
      allowNumeric: true
    },
    {
      group: "longestChannel",
      label: "Longest Channel",
      indexes: [12, 13],
      description: "Channel number of the longest wavelength.",
      allowNumeric: true
    }
  ],

  notes: [
    "This DWDM terminal configuration points to the PEACOC® Compact OSP Terminal product page and datasheet.",
    "Removed B4M, B4D, B5M, and B5D from the channel configuration list.",
    "Customer Code and Product Series are only applicable for products not covered by the standard specification."
  ],

  example: {
    code: "PCTDA1A4MC2539",
    description:
      "Example PEACOC Compact OSP DWDM Terminal configuration."
  }
},

{
  id: "peacoc-compact-osp-splitter-terminal",
  familyCode: "P",
  matchPrefix: "PCTS",
  minLength: 13,
  maxLength: 13,
  productName: "PEACOC® Compact OSP Terminal",
  productPage: "/peacoc-compact-osp-terminal",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FPEACOC%20Compact%20OSP%20Terminal%20Datasheet.pdf?alt=media&token=8c02d8bf-624f-43a2-956e-b7ffc3367436",

  positions: [
    {
      index: 0,
      label: "Product Family",
      group: "productType",
      required: true,
      options: [{ code: "P", description: "PEACOC" }]
    },
    {
      index: 1,
      label: "Product Type - Character 1",
      group: "productType",
      required: true,
      options: [{ code: "C", description: "Compact OSP prefix" }]
    },
    {
      index: 2,
      label: "Product Type - Character 2",
      group: "productType",
      required: true,
      options: [{ code: "T", description: "Terminal prefix" }]
    },
    {
      index: 3,
      label: "Terminal Type",
      group: "productType",
      required: true,
      options: [{ code: "S", description: "Splitter Terminal" }]
    },

    {
      index: 4,
      label: "Number of Output Ports - Digit 1",
      group: "numberOfOutputPorts",
      required: true,
      options: "0-9"
    },
    {
      index: 5,
      label: "Number of Output Ports - Digit 2",
      group: "numberOfOutputPorts",
      required: true,
      options: "0-9"
    },

    {
      index: 6,
      label: "Adapter Type",
      required: true,
      options: [
        { code: "C", description: "LC/UPC (blue) duplex" },
        { code: "D", description: "LC/APC (green) duplex" },
        { code: "E", description: "SC/UPC (blue) simplex" },
        { code: "F", description: "SC/APC (green) simplex" },
        { code: "P", description: "Others" }
      ]
    },

    {
      index: 7,
      label: "Module Configuration - Digit 1",
      group: "moduleConfiguration",
      required: true,
      options: "0-9"
    },
    {
      index: 8,
      label: "Module Configuration - Digit 2",
      group: "moduleConfiguration",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "Module Configuration - Digit 3",
      group: "moduleConfiguration",
      required: true,
      options: "0-9"
    },
    {
      index: 10,
      label: "Module Configuration - Digit 4",
      group: "moduleConfiguration",
      required: true,
      options: "0-9"
    },
    {
      index: 11,
      label: "Module Configuration - Digit 5",
      group: "moduleConfiguration",
      required: true,
      options: "0-9"
    },
    {
      index: 12,
      label: "Module Configuration - Digit 6",
      group: "moduleConfiguration",
      required: true,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productType",
      label: "Product Type",
      indexes: [0, 1, 2, 3],
      options: [
        { code: "PCTS", description: "PEACOC Compact OSP Splitter Terminal" }
      ]
    },
    {
      group: "numberOfOutputPorts",
      label: "Number of Output Ports",
      indexes: [4, 5],
      options: [
        { code: "04", description: "4 ports" },
        { code: "08", description: "8 ports" },
        { code: "12", description: "12 ports" },
        { code: "16", description: "16 ports" },
        { code: "24", description: "24 ports" },
        { code: "32", description: "32 ports" }
      ]
    },
    {
      group: "moduleConfiguration",
      label: "Module Configuration",
      indexes: [7, 8, 9, 10, 11, 12],
      options: [
        { code: "104000", description: "1 set of 1x4" },
        { code: "204000", description: "2 sets of 1x4" },
        { code: "304000", description: "3 sets of 1x4" },
        { code: "404000", description: "4 sets of 1x4" },
        { code: "108000", description: "1 set of 1x8" },
        { code: "208000", description: "2 sets of 1x8" },
        { code: "116000", description: "1 set of 1x16" },
        { code: "132000", description: "1 set of 1x32" },
        { code: "104108", description: "1 set of 1x4 & 1 set of 1x8" },
        { code: "204180", description: "2 sets of 1x4 & 1 set of 1x8" },
        { code: "304108", description: "3 sets of 1x4 & 1 set of 1x8" },
        { code: "104208", description: "1 set of 1x4 & 2 sets of 1x8" },
        { code: "204208", description: "2 sets of 1x4 & 2 sets of 1x8" },
        { code: "104116", description: "1 set of 1x4 & 1 set of 1x16" },
        { code: "204116", description: "2 sets of 1x4 & 1 set of 1x16" },
        { code: "304116", description: "3 sets of 1x4 & 1 set of 1x16" },
        { code: "108116", description: "1 set of 1x8 & 1 set of 1x16" }
      ]
    }
  ],

  notes: [
    "This splitter terminal configuration points to the PEACOC® Compact OSP Terminal product page and datasheet.",
    "Customer Code and Product Series are only applicable for products not covered by the standard specification."
  ],

  example: {
    code: "PCTS12D104000",
    description:
      "Example PEACOC Compact OSP Splitter Terminal configuration with 12 output ports, LC/APC duplex adapters, and 1 set of 1x4."
  }
},
{
  id: "peacoc-small-fiber-terminal",
  familyCode: "P",
  matchPrefix: "PST",
  minLength: 9,
  maxLength: 18,
  productName: "PEACOC® Small Fiber Terminal",
  productPage: "/peacoc-small-fiber-terminal",
  datasheet: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FPEACOC-Small-Fiber-Terminal-Datasheet.pdf?alt=media&token=159b6da2-b23a-4735-88a1-174b70580f74",

  positions: [
    {
      index: 0,
      label: "PEACOC Family Code",
      required: true,
      options: [{ code: "P", description: "PEACOC" }]
    },
    {
      index: 1,
      label: "Product Type - Character 1",
      group: "productType",
      required: true,
      options: [{ code: "S", description: "Small Terminal prefix" }]
    },
    {
      index: 2,
      label: "Product Type - Character 2",
      group: "productType",
      required: true,
      options: [{ code: "T", description: "Small Terminal" }]
    },
    {
      index: 3,
      label: "Version",
      required: true,
      options: [
        { code: "P", description: "Pre-Terminated / Stubbed" },
        { code: "N", description: "Non-Stubbed" },
        { code: "L", description: "Splice Terminal" }
      ]
    },
    {
      index: 4,
      label: "Number of Ports - Digit 1",
      group: "numberOfPorts",
      required: true,
      options: "0-9"
    },
    {
      index: 5,
      label: "Number of Ports - Digit 2",
      group: "numberOfPorts",
      required: true,
      options: "0-9"
    },
    {
      index: 6,
      label: "Adapter Type",
      required: true,
      options: [
        { code: "1", description: "LC / UPC (Blue Duplex)" },
        { code: "2", description: "LC / APC (Green Duplex)" },
        { code: "3", description: "SC / UPC (Blue Simplex)" },
        { code: "4", description: "SC / APC (Green Simplex)" }
      ]
    },
    {
      index: 7,
      label: "F1 Input Cable Type",
      required: true,
      options: [
        { code: "A", description: "12F I/O Loose Tube" },
        { code: "B", description: "12F I/O Ribbon" },
        { code: "C", description: "24F I/O Loose Tube" },
        { code: "D", description: "24F I/O Ribbon" },
        { code: "E", description: "12F MPO F1 Input" }
      ]
    },
    {
      index: 8,
      label: "Length Unit",
      required: true,
      options: [
        { code: "F", description: "Feet" }
      ]
    },
    {
      index: 9,
      label: "Stub Length - Digit 1",
      group: "stubLength",
      required: true,
      options: "0-9"
    },
    {
      index: 10,
      label: "Stub Length - Digit 2",
      group: "stubLength",
      required: true,
      options: "0-9"
    },
    {
      index: 11,
      label: "Stub Length - Digit 3",
      group: "stubLength",
      required: true,
      options: "0-9"
    },
    {
      index: 12,
      label: "Customer Code - Letter 1",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 13,
      label: "Customer Code - Letter 2",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 14,
      label: "Customer Code - Letter 3",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 15,
      label: "Product Series - Digit 1",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 16,
      label: "Product Series - Digit 2",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 17,
      label: "Product Series - Digit 3",
      group: "productSeries",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productType",
      label: "Product Type",
      indexes: [1, 2],
      options: [
        { code: "ST", description: "Small Terminal" }
      ]
    },
    {
      group: "numberOfPorts",
      label: "Number of Ports",
      indexes: [4, 5],
      description: "Number of ports, 2 digit code.",
      allowNumeric: true
    },
    {
      group: "stubLength",
      label: "Stub Length",
      indexes: [9, 10, 11],
      description: "Stub length from 001-999 length units.",
      allowNumeric: true
    },
    {
      group: "customerCode",
      label: "Customer Code",
      indexes: [12, 13, 14],
      description: "Customer Code, 3 letters."
    },
    {
      group: "productSeries",
      label: "Product Series",
      indexes: [15, 16, 17],
      description: "Product Series, 3 numeric digits."
    }
  ]
},

{
  id: "peacoc-panel-cassettes-peacoc-and-eva-patch-only",
  familyCode: "P",
  matchPrefix: "PX",
  minLength: 13,
  maxLength: 13,
  productName: "PEACOC® Panel Cassettes - PEACOC and EVA (Patch Only)",
  productPage: "/peacoc-panel-cassettes-peacoc-and-eva-patch-only",
  datasheet: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FPEACOC%20EVA%20Datasheet.pdf?alt=media&token=8f78d380-6691-4ca3-9d06-ce248458a706",

  positions: [
    {
      index: 0,
      label: "Product Family",
      required: true,
      options: [
        { code: "P", description: "PEACOC" }
      ]
    },
    {
      index: 1,
      label: "Number of RU",
      required: true,
      options: [
        { code: "X", description: "Cassette Only" }
      ]
    },
    {
      index: 2,
      label: "Number of Cassettes",
      required: true,
      options: [
        { code: "P", description: "Empty Chassis" },
        { code: "A", description: "1" },
        { code: "B", description: "2" },
        { code: "C", description: "3" },
        { code: "D", description: "4" },
        { code: "E", description: "5" },
        { code: "F", description: "Fully Loaded 1RU" },
        { code: "G", description: "Fully Loaded 2RU" },
        { code: "H", description: "Fully Loaded 4RU" }
      ]
    },
    {
      index: 3,
      label: "Cassette Type",
      required: true,
      options: [
        { code: "A", description: "All Front Access" },
        { code: "P", description: "Patch" },
        { code: "S", description: "Splice" }
      ]
    },
    {
      index: 4,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "Single Mode (SMF)" },
        { code: "2", description: "Multi-Mode (OM4)" }
      ]
    },
    {
      index: 5,
      label: "Cassette Adapter Type",
      required: true,
      options: [
        { code: "A", description: "CS" },
        { code: "B", description: "SN" },
        { code: "C", description: "MMC" },
        { code: "D", description: "MDC" },
        { code: "G", description: "SN-MT" },
        { code: "K", description: "LC Simplex" },
        { code: "L", description: "LC Duplex" },
        { code: "M", description: "MPO 8/12/24" },
        { code: "N", description: "MPO 16" },
        { code: "S", description: "SC Simplex" }
      ]
    },
    {
      index: 6,
      label: "Adapter Type / Color",
      required: true,
      options: [
        { code: "A", description: "UPC (Aqua - Multimode)" },
        { code: "B", description: "UPC (Blue - Single Mode)" },
        { code: "G", description: "APC (Green - Single Mode)" },
        { code: "K", description: "MPO (Black)" }
      ]
    },
    {
      index: 7,
      label: "Pre-Terminated Cable Assemblies",
      required: true,
      options: [
        { code: "T", description: "Pre-Terminated Cable Assemblies" }
      ]
    },
    {
      index: 8,
      label: "Cable Fiber Type",
      required: true,
      options: [
        { code: "L", description: "Loose Tube" },
        { code: "R", description: "Ribbon" }
      ]
    },
    {
      index: 9,
      label: "Standard Cable Length",
      required: true,
      options: [
        { code: "1", description: "15' (6 m)" },
        { code: "2", description: "75' (23 m)" },
        { code: "3", description: "100' (31 m)" },
        { code: "4", description: "150' (46 m)" },
        { code: "5", description: "200' (61 m)" },
        { code: "6", description: "300' (92 m)" },
        { code: "7", description: "400' (122 m)" },
        { code: "8", description: "500' (153 m)" },
        { code: "9", description: "1000' (305 m)" },
        { code: "C", description: "Custom" }
      ]
    },
    {
      index: 10,
      label: "Fiber Count",
      required: true,
      options: [
        { code: "A", description: "72" },
        { code: "B", description: "144" },
        { code: "C", description: "144 (2x72)" },
        { code: "D", description: "288" },
        { code: "E", description: "288 (2x144)" },
        { code: "F", description: "576" }
      ]
    },
    {
      index: 11,
      label: "Far End Adapter Type",
      required: true,
      options: [
        { code: "X", description: "None (Stub)" },
        { code: "A", description: "CS" },
        { code: "B", description: "SN" },
        { code: "C", description: "MMC" },
        { code: "D", description: "MDC" },
        { code: "G", description: "SN-MT" },
        { code: "L", description: "LC" },
        { code: "M", description: "MPO" },
        { code: "S", description: "SC" }
      ]
    },
    {
      index: 12,
      label: "Far End Cable Type",
      required: true,
      options: [
        { code: "A", description: "Riser" },
        { code: "P", description: "Plenum" },
        { code: "S", description: "I/O" },
        { code: "U", description: "Outdoor" },
        { code: "Z", description: "LSZH" }
      ]
    }
  ]
},

{
  id: "peacoc-panel-cassettes-peacoc-and-eva-patch-splice",
  familyCode: "P",
  matchPrefix: "PX",
  minLength: 8,
  maxLength: 13,
  productName: "PEACOC® Panel Cassettes - PEACOC and EVA (Patch & Splice)",
  productPage: "/peacoc-panel-cassettes-peacoc-and-eva-patch-splice",
  datasheet: "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FPEACOC%20EVA%20Datasheet.pdf?alt=media&token=8f78d380-6691-4ca3-9d06-ce248458a706",

  positions: [
    {
      index: 0,
      label: "Product Family",
      required: true,
      options: [
        { code: "P", description: "PEACOC" }
      ]
    },
    {
      index: 1,
      label: "Number of RU",
      required: true,
      options: [
        { code: "X", description: "Cassette Only" }
      ]
    },
    {
      index: 2,
      label: "Number of Cassettes",
      required: true,
      options: [
        { code: "P", description: "Empty Chassis" },
        { code: "A", description: "1" },
        { code: "B", description: "2" },
        { code: "C", description: "3" },
        { code: "D", description: "4" },
        { code: "E", description: "5" },
        { code: "F", description: "Fully Loaded 1RU" },
        { code: "G", description: "Fully Loaded 2RU" },
        { code: "H", description: "Fully Loaded 4RU" }
      ]
    },
    {
      index: 3,
      label: "Cassette Type",
      required: true,
      options: [
        { code: "P", description: "Patch" },
        { code: "S", description: "Splice" }
      ]
    },
    {
      index: 4,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "Single Mode (SMF)" },
        { code: "2", description: "Multi-Mode (OM4)" }
      ]
    },
    {
      index: 5,
      label: "Cassette Adapter Type",
      required: true,
      options: [
        { code: "A", description: "CS" },
        { code: "B", description: "SN" },
        { code: "C", description: "MMC" },
        { code: "D", description: "MDC" },
        { code: "G", description: "SN-MT" },
        { code: "K", description: "LC Simplex" },
        { code: "L", description: "LC Duplex" },
        { code: "M", description: "MPO 8/12/24" },
        { code: "N", description: "MPO 16" },
        { code: "S", description: "SC Simplex" }
      ]
    },
    {
      index: 6,
      label: "Adapter Type / Color",
      required: true,
      options: [
        { code: "A", description: "UPC (Aqua - Multimode)" },
        { code: "B", description: "UPC (Blue - Single Mode)" },
        { code: "G", description: "APC (Green - Single Mode)" },
        { code: "K", description: "MPO (Black)" }
      ]
    },
    {
      index: 7,
      label: "Inner Cable Options",
      required: true,
      options: [
        { code: "A", description: "1x12F Male MPO to SC Fanout" },
        { code: "D", description: "1x16F Male MPO to LC Fanout" },
        { code: "E", description: "1x20F Male MPO to LC Fanout" },
        { code: "F", description: "1x24F Male MPO to LC Fanout" },
        { code: "H", description: "2x8F Male MPO to LC Fanout" },
        { code: "K", description: "2x12F Male MPO to LC Fanout" },
        { code: "M", description: "3x8F Male MPO to LC Fanout" },
        { code: "N", description: "Mass Fusion Splice" },
        { code: "P", description: "Single Splice" },
        { code: "R", description: "4-24F Male MPO to 8-12F Male MPO FA" },
        { code: "X", description: "None" }
      ]
    }
  ]
},

{
  id: "planar-lightwave-circuit-plc-splitter-cassette",
  familyCode: "F",
  matchPrefix: "F",
  minLength: 11,
  maxLength: 11,
  productName: "Planar Lightwave Circuit (PLC) Splitter Cassette",
  productPage: "/planar-lightwave-circuit-plc-splitter-cassette",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FFleT_Splitter-Datasheet_%2008_1_2022.pdf?alt=media&token=d0e63802-2b5f-4222-8ac8-16cdfa6d5e96",

  positions: [
    {
      index: 0,
      label: "Product Family",
      required: true,
      options: [
        { code: "F", description: "FleT" }
      ]
    },
    {
      index: 1,
      label: "Cassette Configuration",
      required: true,
      options: [
        { code: "X", description: "Cassette only" },
        { code: "1", description: "1 Cassette" },
        { code: "2", description: "2 Cassettes" },
        { code: "3", description: "3 Cassettes" },
        { code: "4", description: "4 Cassettes" },
        { code: "5", description: "5 Cassettes" },
        { code: "L", description: "6 Cassettes Fully Loaded" },
        { code: "E", description: "Extended Chassis for 1x32 splitters and greater" }
      ]
    },
    {
      index: 2,
      label: "Family Type",
      required: true,
      options: [
        { code: "S", description: "Splitter" }
      ]
    },
    {
      index: 3,
      label: "Number of Inputs",
      required: true,
      options: [
        { code: "A", description: "One Input Fiber" },
        { code: "B", description: "Two Input Fibers" }
      ]
    },
    {
      index: 4,
      label: "Split Ratio - Digit 1",
      group: "splitRatio",
      required: true,
      options: "0-9"
    },
    {
      index: 5,
      label: "Split Ratio - Digit 2",
      group: "splitRatio",
      required: true,
      options: "0-9"
    },
    {
      index: 6,
      label: "Split Ratio - Digit 3",
      group: "splitRatio",
      required: true,
      options: "0-9"
    },
    {
      index: 7,
      label: "Adapter / Connector Type - Character 1",
      group: "adapterConnectorType",
      required: true,
      options: [
        { code: "S", description: "Simplex connector prefix" },
        { code: "M", description: "Mini Duplex connector prefix" },
        { code: "D", description: "Duplex connector prefix" }
      ]
    },
    {
      index: 8,
      label: "Adapter / Connector Type - Character 2",
      group: "adapterConnectorType",
      required: true,
      options: [
        { code: "L", description: "LC connector" },
        { code: "S", description: "SC connector" },
        { code: "D", description: "Mini Duplex connector" }
      ]
    },
    {
      index: 9,
      label: "Adapter / Connector Type - Character 3",
      group: "adapterConnectorType",
      required: true,
      options: [
        { code: "A", description: "Angle Polish" },
        { code: "U", description: "Ultra Polish" }
      ]
    },
    {
      index: 10,
      label: "Number of PLCs per Cassette",
      required: true,
      options: [
        { code: "1", description: "1 PLC Device" },
        { code: "2", description: "2 PLC Devices" },
        { code: "3", description: "3 PLC Devices" },
        { code: "4", description: "4 PLC Devices" },
        { code: "5", description: "5 PLC Devices" },
        { code: "6", description: "6 PLC Devices" },
        { code: "7", description: "7 PLC Devices" },
        { code: "8", description: "8 PLC Devices" }
      ]
    }
  ],

  groupedOptions: [
    {
      group: "splitRatio",
      label: "Split Ratio",
      indexes: [4, 5, 6],
      options: [
        { code: "002", description: "N x 2" },
        { code: "004", description: "N x 4" },
        { code: "008", description: "N x 8" },
        { code: "012", description: "N x 12" },
        { code: "016", description: "N x 16" },
        { code: "032", description: "N x 32" },
        { code: "064", description: "N x 64" },
        { code: "128", description: "N x 128" }
      ]
    },
    {
      group: "adapterConnectorType",
      label: "Adapter / Connector Type",
      indexes: [7, 8, 9],
      options: [
        { code: "SLA", description: "Simplex LC Angle Polish" },
        { code: "SLU", description: "Simplex LC Ultra Polish" },
        { code: "SSA", description: "Simplex SC Angle Polish" },
        { code: "SSU", description: "Simplex SC Ultra Polish" },
        { code: "MDA", description: "Mini Duplex Angle Polish" },
        { code: "MDU", description: "Mini Duplex Ultra Polish" },
        { code: "DLA", description: "Duplex LC Angle Polish" },
        { code: "DLU", description: "Duplex LC Ultra Polish" }
      ]
    }
  ],

  examples: [
    {
      code: "FXSA008SLA2",
      description: "FleT 1x8 splitter, 2 PLC devices, LC/APC simplex"
    },
    {
      code: "FLSA016SSU1",
      description: "FleT 1x16 splitter, 1 PLC device, SC/UPC simplex fully loaded"
    }
  ],

  notes: [
    "PLC quantity may depend on split ratio and connector type.",
    "Ordering guide assumes all front access."
  ]
},

{
  id: "tff-tap-splitter-1x2-and-2x2",
  familyCode: "F",
  matchPrefix: "F",
  minLength: 12,
  maxLength: 12,
  productName: "TFF Tap Splitter, 1x2 and 2x2",
  productPage: "/tff-tap-splitter-1x2-and-2x2",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FTFF%20Tap%20Splitter%2C%201x2%20and%202x2.pdf?alt=media&token=312c1cbc-ea4a-4bee-8c09-1252d6297e13",

  positions: [
    {
      index: 0,
      label: "Product Family Code",
      required: true,
      options: [
        { code: "F", description: "Flexible Tray" }
      ]
    },
    {
      index: 1,
      label: "Tray Configuration",
      required: true,
      options: [
        { code: "X", description: "V3.0, any tray" },
        { code: "L", description: "V3.0, fully loaded" },
        { code: "1", description: "V3.0, 1 tray" },
        { code: "2", description: "V3.0, 2 trays" },
        { code: "3", description: "V3.0, 3 trays" },
        { code: "4", description: "V3.0, 4 trays" },
        { code: "5", description: "V3.0, 5 trays" }
      ]
    },
    {
      index: 2,
      label: "Product Family",
      required: true,
      options: [
        { code: "S", description: "Splitter / Taps" },
        { code: "T", description: "Taps" }
      ]
    },
    {
      index: 3,
      label: "Tap Ratio - Digit 1",
      group: "tapRatio",
      required: true,
      options: [
        { code: "0", description: "Tap ratio prefix" },
        { code: "1", description: "Tap ratio prefix" },
        { code: "3", description: "Tap ratio prefix" },
        { code: "5", description: "Tap ratio prefix" },
        { code: "X", description: "Other tap ratio prefix" }
      ]
    },
    {
      index: 4,
      label: "Tap Ratio - Digit 2",
      group: "tapRatio",
      required: true,
      options: [
        { code: "5", description: "95/5 suffix" },
        { code: "0", description: "90/10, 70/30, or 50/50 suffix" },
        { code: "X", description: "Other tap ratio suffix" }
      ]
    },
    {
      index: 5,
      label: "Tap Configuration - Character 1",
      group: "tapConfiguration",
      required: true,
      options: [
        { code: "1", description: "1x2 TAP configuration prefix" },
        { code: "2", description: "2x2 TAP configuration prefix" }
      ]
    },
    {
      index: 6,
      label: "Tap Configuration - Character 2",
      group: "tapConfiguration",
      required: true,
      options: [
        { code: "X", description: "Configuration separator" }
      ]
    },
    {
      index: 7,
      label: "Tap Configuration - Character 3",
      group: "tapConfiguration",
      required: true,
      options: [
        { code: "2", description: "TAP configuration suffix" }
      ]
    },
    {
      index: 8,
      label: "Tap Bandpass - Character 1",
      group: "tapBandpass",
      required: true,
      options: [
        { code: "S", description: "Single Window prefix" },
        { code: "D", description: "Dual Window prefix" },
        { code: "F", description: "Full Band prefix" },
        { code: "M", description: "Multimode prefix" }
      ]
    },
    {
      index: 9,
      label: "Tap Bandpass - Character 2",
      group: "tapBandpass",
      required: true,
      options: [
        { code: "W", description: "Window / full band code" },
        { code: "M", description: "Multimode code" }
      ]
    },
    {
      index: 10,
      label: "Tap Bandpass - Character 3",
      group: "tapBandpass",
      required: true,
      options: [
        { code: "1", description: "Bandpass option 1" },
        { code: "2", description: "Bandpass option 2" },
        { code: "3", description: "Bandpass option 3" }
      ]
    },
    {
      index: 11,
      label: "Connector / Adapter Type",
      required: true,
      options: [
        { code: "1", description: "LC/UPC; Blue Duplex Adapter" },
        { code: "2", description: "LC/APC; Green Duplex Adapter" },
        { code: "3", description: "SC/UPC; Blue Simplex Adapter" },
        { code: "4", description: "SC/APC; Green Simplex Adapter" },
        { code: "5", description: "LC/UPC; Blue Simplex Adapter" },
        { code: "6", description: "LC/APC; Green Simplex Adapter" },
        { code: "P", description: "Others" }
      ]
    }
  ],

  groupedOptions: [
    {
      group: "tapRatio",
      label: "Tap Ratio",
      indexes: [3, 4],
      options: [
        { code: "05", description: "Tap 95/5" },
        { code: "10", description: "Tap 90/10" },
        { code: "30", description: "Tap 70/30" },
        { code: "50", description: "Tap 50/50" },
        { code: "XX", description: "Other tap ratio" }
      ]
    },
    {
      group: "tapConfiguration",
      label: "Tap Configuration",
      indexes: [5, 6, 7],
      options: [
        { code: "1X2", description: "For 1x2 TAPs" },
        { code: "2X2", description: "For 2x2 TAPs" }
      ]
    },
    {
      group: "tapBandpass",
      label: "Tap Bandpass",
      indexes: [8, 9, 10],
      options: [
        { code: "SW1", description: "Single Window 1310±40nm" },
        { code: "SW2", description: "Single Window 1550±40nm" },
        { code: "DW1", description: "Dual Window 1310±40nm and 1550±40nm" },
        { code: "FW1", description: "Full Band 1260-1625nm" },
        { code: "MM3", description: "Multimode 850nm OM3" }
      ]
    }
  ],

  examples: [
    {
      code: "FXSA5000FW11",
      description: "Example shown in ordering guide"
    }
  ]
},

{
  id: "dense-wdm-100-ghz-spacing-multi-channel",
  familyCode: "F",
  matchPrefix: "F",
  minLength: 12,
  maxLength: 18,
  productName: "Dense WDM, 100 GHz Spacing, Multi-Channel",
  productPage: "/dense-wdm-100-ghz-spacing-multi-channel",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FFleT_DWDM_100G-Datasheet-1.pdf?alt=media&token=00e499b3-4639-4fc9-919a-84dc316cd36b",

  positions: [
    {
      index: 0,
      label: "Product Family Code",
      required: true,
      options: [
        { code: "F", description: "FleT" }
      ]
    },
    {
      index: 1,
      label: "FleT Version / Tray Configuration",
      required: true,
      options: [
        { code: "A", description: "ver 1.0 tray A only" },
        { code: "B", description: "ver 1.0 tray B only" },
        { code: "C", description: "ver 1.0 tray C only" },
        { code: "D", description: "ver 1.0 tray D only" },
        { code: "E", description: "ver 1.0 tray E only" },
        { code: "F", description: "ver 1.0 tray F only" },
        { code: "X", description: "V3.0, any tray" },
        { code: "L", description: "V3.0, fully loaded" },
        { code: "M", description: "V1.0, fully loaded" },
        { code: "1", description: "V3.0, 1 tray" },
        { code: "2", description: "V3.0, 2 trays" },
        { code: "3", description: "V3.0, 3 trays" },
        { code: "4", description: "V3.0, 4 trays" },
        { code: "5", description: "V3.0, 5 trays" }
      ]
    },
    {
      index: 2,
      label: "Sub-Family",
      required: true,
      options: [
        { code: "D", description: "DWDM 100G" }
      ]
    },
    {
      index: 3,
      label: "Module Configuration - Character 1",
      group: "moduleConfiguration",
      required: true,
      options: [
        { code: "1", description: "4CH configuration prefix" },
        { code: "2", description: "8CH configuration prefix" },
        { code: "3", description: "16CH configuration prefix" },
        { code: "4", description: "20CH configuration prefix" },
        { code: "0", description: "Custom channel count prefix" }
      ]
    },
    {
      index: 4,
      label: "Module Configuration - Character 2",
      group: "moduleConfiguration",
      required: true,
      options: [
        { code: "S", description: "Standard" },
        { code: "P", description: "Premium" },
        { code: "9", description: "Custom channel count" }
      ]
    },
    {
      index: 5,
      label: "Shortest Channel - Character 1",
      group: "shortestChannel",
      required: true,
      options: [
        { code: "C", description: "DWDM C-band channel prefix" }
      ]
    },
    {
      index: 6,
      label: "Shortest Channel - Digit 1",
      group: "shortestChannel",
      required: true,
      options: "0-9"
    },
    {
      index: 7,
      label: "Shortest Channel - Digit 2",
      group: "shortestChannel",
      required: true,
      options: "0-9"
    },
    {
      index: 8,
      label: "Longest Channel - Character 1",
      group: "longestChannel",
      required: true,
      options: [
        { code: "C", description: "DWDM C-band channel prefix" }
      ]
    },
    {
      index: 9,
      label: "Longest Channel - Digit 1",
      group: "longestChannel",
      required: true,
      options: "0-9"
    },
    {
      index: 10,
      label: "Longest Channel - Digit 2",
      group: "longestChannel",
      required: true,
      options: "0-9"
    },
    {
      index: 11,
      label: "Connector Type / Adapter Type",
      required: true,
      options: [
        { code: "1", description: "LC/UPC; Blue Duplex Adapters" },
        { code: "2", description: "LC/APC; Green Duplex Adapters" },
        { code: "3", description: "SC/UPC; Blue Simplex Adapters" },
        { code: "4", description: "SC/APC; Green Simplex Adapters" },
        { code: "5", description: "LC/UPC; Blue Simplex Adapters" },
        { code: "6", description: "LC/APC; Green Simplex Adapters" },
        { code: "P", description: "Others" }
      ]
    },
    {
      index: 12,
      label: "Customer Code - Letter 1",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 13,
      label: "Customer Code - Letter 2",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 14,
      label: "Customer Code - Letter 3",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 15,
      label: "Product Series - Digit 1",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 16,
      label: "Product Series - Digit 2",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 17,
      label: "Product Series - Digit 3",
      group: "productSeries",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "moduleConfiguration",
      label: "Module Configuration",
      indexes: [3, 4],
      options: [
        { code: "1S", description: "4CH Standard" },
        { code: "1P", description: "4CH Premium" },
        { code: "2S", description: "8CH Standard" },
        { code: "2P", description: "8CH Premium" },
        { code: "3S", description: "16CH Standard" },
        { code: "3P", description: "16CH Premium" },
        { code: "4S", description: "20CH Standard" },
        { code: "4P", description: "20CH Premium" },
        { code: "09", description: "For custom number of channel count" }
      ]
    },
    {
      group: "shortestChannel",
      label: "Shortest Channel Plan",
      indexes: [5, 6, 7],
      description: "DWDM C-band channel number, such as C23."
    },
    {
      group: "longestChannel",
      label: "Longest Channel Plan",
      indexes: [8, 9, 10],
      description: "DWDM C-band channel number, such as C20."
    },
    {
      group: "customerCode",
      label: "Customer Code",
      indexes: [12, 13, 14],
      description: "Optional customer code, 3 letters."
    },
    {
      group: "productSeries",
      label: "Product Series",
      indexes: [15, 16, 17],
      description: "Optional product series, 3 numeric digits."
    }
  ],

  examples: [
    {
      code: "FXD1SC23C201",
      description:
        "FleT with version 3.0 design, 4CH standard DWDM 100GHz with wavelength range C23 to C20 and duplex LC blue adapters."
    }
  ]
},

{
  id: "peacoc-fiber-distribution-frame-open-framed-rack",
  familyCode: "P",
  matchPrefix: "PFRM",
  minLength: 14,
  maxLength: 14,
  productName: "PEACOC® Fiber Distribution Frame open framed rack",
  productPage: "/peacoc-fiber-distribution-frame-open-framed-rack",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FPEACOC-Fiber-Distribution-Frame.pdf?alt=media&token=3e042b6f-c5f5-4e53-8d16-6fb640242bef",

  positions: [
    {
      index: 0,
      label: "Product Family Code",
      required: true,
      options: [
        { code: "P", description: "PEACOC" }
      ]
    },
    {
      index: 1,
      label: "Frame - Character 1",
      group: "frame",
      required: true,
      options: [
        { code: "F", description: "Frame prefix" }
      ]
    },
    {
      index: 2,
      label: "Frame - Character 2",
      group: "frame",
      required: true,
      options: [
        { code: "R", description: "Frame prefix" }
      ]
    },
    {
      index: 3,
      label: "Frame - Character 3",
      group: "frame",
      required: true,
      options: [
        { code: "M", description: "Frame" }
      ]
    },
    {
      index: 4,
      label: "Frame Capacity",
      required: true,
      options: [
        { code: "J", description: "7ft (~40U)" },
        { code: "K", description: "9ft (~52U)" }
      ]
    },
    {
      index: 5,
      label: "Inner Mounting Rails - Character 1",
      group: "innerMountingRails",
      required: true,
      options: [
        { code: "1", description: "Standard 19 inch rack prefix" },
        { code: "2", description: "Standard 23 inch rack prefix" },
        { code: "C", description: "Customized" }
      ]
    },
    {
      index: 6,
      label: "Inner Mounting Rails - Character 2",
      group: "innerMountingRails",
      required: true,
      options: [
        { code: "9", description: "Standard 19 inch rack" },
        { code: "3", description: "Standard 23 inch rack" },
        { code: "X", description: "Customized suffix" }
      ]
    },
    {
      index: 7,
      label: "Mounting Option",
      required: true,
      options: [
        { code: "T", description: "Table-Top Mounted" },
        { code: "F", description: "Floor Mounted" }
      ]
    },
    {
      index: 8,
      label: "Color",
      required: true,
      options: [
        { code: "B", description: "Black" }
      ]
    },
    {
      index: 9,
      label: "Customer Code - Letter 1",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 10,
      label: "Customer Code - Letter 2",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 11,
      label: "Customer Code - Letter 3",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 12,
      label: "Product Series - Digit 1",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 13,
      label: "Product Series - Digit 2",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 14,
      label: "Product Series - Digit 3",
      group: "productSeries",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "frame",
      label: "Frame",
      indexes: [1, 2, 3],
      options: [
        { code: "FRM", description: "Frame" }
      ]
    },
    {
      group: "innerMountingRails",
      label: "Inner Mounting Rails",
      indexes: [5, 6],
      options: [
        { code: "19", description: "Standard 19 inch rack" },
        { code: "23", description: "Standard 23 inch rack" },
        { code: "CX", description: "Customized" }
      ]
    },
    {
      group: "customerCode",
      label: "Customer Code",
      indexes: [9, 10, 11],
      description: "Optional customer code, 3 letters."
    },
    {
      group: "productSeries",
      label: "Product Series",
      indexes: [12, 13, 14],
      description: "Optional product series, 3 numeric digits."
    }
  ],

  notes: [
    "For specific configurations, contact a Customer Sales Representative for the ordering code."
  ]
},

{
  id: "400g-800g-16tb",
  familyCode: "D",
  matchPrefix: "D",
  lookupOnly: true,
  minLength: 10,
  maxLength: 14,
  productName: "400G / 800G / 1.6Tb",
  productPage: "/400g-800g-16tb",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2F400%2C%20800%2C%201.6%20Transceivers%20Data%20Sheet.pdf?alt=media&token=86f74580-b34a-4bde-8fc5-0b86b6e80f39",

  knownPartNumbers: [
    {
      code: "DAOUC-AAQQA8-M12",
      description: "800G VR8 — 50m, 850nm, Dual MPO 12, VCSEL+PIN, <14W"
    },
    {
      code: "DCOUC-22QQA8-M12",
      description: "800G DR8 — 500m, 1310nm, Dual MPO 12, SIPH+PIN, <14W"
    },
    {
      code: "DEOLC-CWQQA8",
      description: "800G 2*FR4 — 2km, CWDM, Dual Duplex LC, SIPH+PIN, <14W"
    },
    {
      code: "DAJ3C-00QQA8-J12",
      description: "800G DAC Copper — 2m, <0.1W"
    },
    {
      code: "DAJ2C-00QQA8-I15",
      description: "800G ACC Copper — 5m, <1.5W"
    },
    {
      code: "DAO1C-00QQB8",
      description: "800G AEC Copper — 7m, <12W"
    },
    {
      code: "DCOUC-22RRB8-M12",
      description: "1.6T DR8 LPO — 500m, 1310nm, Dual MPO 12, SIPH+PIN, <10W"
    },
    {
      code: "DCOUC-22RRD8-M12",
      description: "1.6T DR8 LRO — 500m, 1310nm, Dual MPO 12, SIPH+PIN, <16W"
    },
    {
      code: "DCOUC-22RRC8-M12",
      description: "1.6T DR8 DSP — 500m, 1310nm, Dual MPO 12, SIPH+PIN, <26W"
    },
    {
      code: "DEOLC-CWRRB8",
      description: "1.6T 2*FR4 DSP — 2km, CWDM, Dual Duplex LC, SIPH+PIN, <26W"
    }
  ]
},

{
  id: "selfoc-single-fiber-collimators",
  familyCode: "F",
  matchPrefix: "FCS",
  minLength: 16,
  maxLength: 16,
  productName: "SELFOC® Single Fiber Collimators",
  productPage: "/selfoc-single-fiber-collimators",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FSingle-Fiber-Collimators-Datasheet.pdf?alt=media&token=b71c591a-a9ba-45c5-b5a2-8f839fe63173",

  positions: [
    {
      index: 0,
      label: "Product Category - Character 1",
      group: "productCategory",
      required: true,
      options: [{ code: "F", description: "SELFOC / Fiber collimator prefix" }]
    },
    {
      index: 1,
      label: "Product Category - Character 2",
      group: "productCategory",
      required: true,
      options: [{ code: "C", description: "Collimator category" }]
    },
    {
      index: 2,
      label: "Product Category - Character 3",
      group: "productCategory",
      required: true,
      options: [{ code: "S", description: "Single Lens Collimator" }]
    },

    {
      index: 3,
      label: "Separator",
      required: true,
      options: [{ code: "-", description: "Separator" }]
    },

    {
      index: 4,
      label: "Lens Diameter - Digit 1",
      group: "lensDiameter",
      required: true,
      options: [{ code: "1", description: "1.8mm lens prefix" }]
    },
    {
      index: 5,
      label: "Lens Diameter - Digit 2",
      group: "lensDiameter",
      required: true,
      options: [{ code: "8", description: "1.8mm Lens" }]
    },

    {
      index: 6,
      label: "Separator",
      required: true,
      options: [{ code: "-", description: "Separator" }]
    },

    {
      index: 7,
      label: "Working Distance Type",
      required: true,
      options: [
        { code: "C", description: "Standard working distance" }
      ]
    },

    {
      index: 8,
      label: "Separator",
      required: true,
      options: [{ code: "-", description: "Separator" }]
    },

    {
      index: 9,
      label: "Housing",
      required: true,
      options: [
        { code: "G", description: "Glass housing" }
      ]
    },

    {
      index: 10,
      label: "Separator",
      required: true,
      options: [{ code: "-", description: "Separator" }]
    },

    {
      index: 11,
      label: "Wavelength",
      required: true,
      options: [
        { code: "3", description: "1550nm" }
      ]
    },

    {
      index: 12,
      label: "Separator",
      required: true,
      options: [{ code: "-", description: "Separator" }]
    },

    {
      index: 13,
      label: "Working Distance - Digit 1",
      group: "workingDistance",
      required: true,
      options: "0-9"
    },
    {
      index: 14,
      label: "Working Distance - Digit 2",
      group: "workingDistance",
      required: true,
      options: "0-9"
    },
    {
      index: 15,
      label: "Working Distance - Digit 3",
      group: "workingDistance",
      required: true,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productCategory",
      label: "Product Category",
      indexes: [0, 1, 2],
      options: [
        { code: "FCS", description: "SLC - Single Lens Collimator" }
      ]
    },
    {
      group: "lensDiameter",
      label: "Lens Diameter",
      indexes: [4, 5],
      options: [
        { code: "18", description: "1.8mm Lens" }
      ]
    },
    {
      group: "workingDistance",
      label: "Working Distance",
      indexes: [13, 14, 15],
      options: [
        { code: "005", description: "5mm" },
        { code: "010", description: "10mm" },
        { code: "020", description: "20mm" }
      ]
    }
  ],

  examples: [
    {
      code: "FCS-18-C-G-3-020",
      description:
        "Single fiber collimator with 1.8mm lens, standard working distance, glass housing, 1550nm wavelength, and working distance of 20mm."
    }
  ]
},

{
  id: "peacoc-small-terminal-360-st360",
  familyCode: "P",
  matchPrefix: "PST",
  minLength: 12,
  maxLength: 12,
  productName: "PEACOC® Small Terminal 360 (ST360)",
  productPage: "/peacoc-small-terminal-360-st360",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FST360%20Datasheet.pdf?alt=media&token=f88a5402-6d90-427e-954e-e47039a0a67c",

  positions: [
    {
      index: 0,
      label: "Product Family",
      required: true,
      options: [
        { code: "P", description: "PEACOC" }
      ]
    },
    {
      index: 1,
      label: "Product Type - Character 1",
      group: "productType",
      required: true,
      options: [
        { code: "S", description: "Small Terminal prefix" }
      ]
    },
    {
      index: 2,
      label: "Product Type - Character 2",
      group: "productType",
      required: true,
      options: [
        { code: "T", description: "Small Terminal 360" }
      ]
    },
    {
      index: 3,
      label: "Stub Connector",
      required: true,
      options: [
        { code: "M", description: "MPO" },
        { code: "C", description: "None" }
      ]
    },
    {
      index: 4,
      label: "Number of Drop Ports - Digit 1",
      group: "numberOfDropPorts",
      required: true,
      options: "0-9"
    },
    {
      index: 5,
      label: "Number of Drop Ports - Digit 2",
      group: "numberOfDropPorts",
      required: true,
      options: "0-9"
    },
    {
      index: 6,
      label: "Adapter Type",
      required: true,
      options: [
        { code: "1", description: "LC/UPC Duplex" },
        { code: "2", description: "LC/APC Duplex" },
        { code: "3", description: "SC/UPC Simplex" },
        { code: "4", description: "SC/APC Simplex" }
      ]
    },
    {
      index: 7,
      label: "Stub Cable Type",
      required: true,
      options: [
        { code: "A", description: "12F 3.0mm Riser Rated" },
        { code: "B", description: "12F 3.0mm Plenum Rated" },
        { code: "C", description: "24F 3.8mm Riser Rated" },
        { code: "D", description: "24F 3.8mm Plenum Rated" }
      ]
    },
    {
      index: 8,
      label: "Unit of Length",
      required: true,
      options: [
        { code: "F", description: "Feet" },
        { code: "M", description: "Meters" }
      ]
    },
    {
      index: 9,
      label: "Stub Cable Length - Digit 1",
      group: "stubCableLength",
      required: true,
      options: "0-9"
    },
    {
      index: 10,
      label: "Stub Cable Length - Digit 2",
      group: "stubCableLength",
      required: true,
      options: "0-9"
    },
    {
      index: 11,
      label: "Stub Cable Length - Digit 3",
      group: "stubCableLength",
      required: true,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productType",
      label: "Product Type",
      indexes: [1, 2],
      options: [
        { code: "ST", description: "Small Terminal 360" }
      ]
    },
    {
      group: "numberOfDropPorts",
      label: "Number of Drop Ports",
      indexes: [4, 5],
      options: [
        { code: "06", description: "6 Ports" },
        { code: "12", description: "12 Ports" },
        { code: "16", description: "16 Ports" },
        { code: "24", description: "24 Ports" }
      ],
      description: "Maximum of 12 ports for SC or 24 ports for LC."
    },
    {
      group: "stubCableLength",
      label: "Stub Cable Length",
      indexes: [9, 10, 11],
      description: "3-digit length. 50 to 1000 ft in 50 ft increments.",
      allowNumeric: true
    }
  ]
},
{
  id: "selfoc-microlens",
  familyCode: "X",
  matchPrefix: "X",
  minLength: 19,
  maxLength: 19,
  productName: "SELFOC® Microlens",
  productPage: "/selfoc-microlens",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FSelfoc-Micro-Lenses-Data-Sheet.pdf?alt=media&token=a23dcb82-bb2a-4845-a89d-94c1fc7e1998",

  positions: [
    {
      index: 0,
      label: "SML Type",
      required: true,
      options: [
        { code: "P", description: "Plano" },
        { code: "X", description: "Angled" }
      ]
    },
    {
      index: 1,
      label: "Side Coating",
      required: true,
      options: [
        { code: "N", description: "No Coating" },
        { code: "U", description: "U-Metallization" },
        { code: "M", description: "M-Metallization" }
      ]
    },
    {
      index: 2,
      label: "Lens Type",
      required: true,
      options: [
        { code: "C", description: "C-Type" },
        { code: "W", description: "W-Type" },
        { code: "H", description: "H-Type" }
      ]
    },

    {
      index: 3,
      label: "Lens Diameter - Digit 1",
      group: "lensDiameter",
      required: true,
      options: [
        { code: "1", description: "1.0mm or 1.8mm prefix" },
        { code: "2", description: "2.0mm prefix" },
        { code: "3", description: "3.0mm prefix" },
        { code: "4", description: "4.0mm prefix" }
      ]
    },
    {
      index: 4,
      label: "Lens Diameter - Digit 2",
      group: "lensDiameter",
      required: true,
      options: [
        { code: "0", description: "Lens diameter suffix" },
        { code: "8", description: "1.8mm suffix" }
      ]
    },

    {
      index: 5,
      label: "Variable Pitch - Prefix",
      group: "variablePitch",
      required: true,
      options: [
        { code: "S", description: "Maximum Root A" }
      ]
    },
    {
      index: 6,
      label: "Variable Pitch - Digit 1",
      group: "variablePitch",
      required: true,
      options: "0-9"
    },
    {
      index: 7,
      label: "Variable Pitch - Digit 2",
      group: "variablePitch",
      required: true,
      options: "0-9"
    },
    {
      index: 8,
      label: "Variable Pitch - Digit 3",
      group: "variablePitch",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "Variable Pitch - Digit 4",
      group: "variablePitch",
      required: true,
      options: "0-9"
    },

    {
      index: 10,
      label: "Variable Cutting Wavelength - Digit 1",
      group: "variableCuttingWavelength",
      required: true,
      options: [
        { code: "0", description: "630nm or 830nm prefix" },
        { code: "1", description: "1310nm or 1550nm prefix" }
      ]
    },
    {
      index: 11,
      label: "Variable Cutting Wavelength - Digit 2",
      group: "variableCuttingWavelength",
      required: true,
      options: [
        { code: "6", description: "630nm" },
        { code: "8", description: "830nm" },
        { code: "3", description: "1310nm" },
        { code: "5", description: "1550nm" }
      ]
    },
    {
      index: 12,
      label: "Variable Cutting Wavelength - Digit 3",
      group: "variableCuttingWavelength",
      required: true,
      options: [
        { code: "3", description: "630nm or 830nm" },
        { code: "1", description: "1310nm" },
        { code: "5", description: "1550nm" }
      ]
    },

    {
      index: 13,
      label: "Side A",
      required: true,
      options: [
        { code: "K", description: "1450 nm AR coating" },
        { code: "S", description: "Standard AR coating" },
        { code: "D", description: "830/1310 nm AR coating" },
        { code: "H", description: "980/1550 nm AR coating" },
        { code: "U", description: "600 nm AR coating" },
        { code: "P", description: "Passivation Coating" },
        { code: "N", description: "Non Coat" }
      ]
    },
    {
      index: 14,
      label: "Side B",
      required: true,
      options: [
        { code: "K", description: "1450 nm AR coating" },
        { code: "S", description: "Standard AR coating" },
        { code: "D", description: "830/1310 nm AR coating" },
        { code: "H", description: "980/1550 nm AR coating" },
        { code: "U", description: "600 nm AR coating" },
        { code: "P", description: "Passivation Coating" },
        { code: "N", description: "Non Coat" }
      ]
    },
    {
      index: 15,
      label: "AR Coating Type",
      required: true,
      options: [
        { code: "0", description: "630 nm" },
        { code: "3", description: "830 nm" },
        { code: "7", description: "1310 nm" },
        { code: "8", description: "1550 nm" },
        { code: "N", description: "Not Applicable" }
      ]
    },
    {
      index: 16,
      label: "Angle A",
      required: true,
      options: [
        { code: "0", description: "Flat" },
        { code: "8", description: "8°" }
      ]
    },
    {
      index: 17,
      label: "Angle B",
      required: true,
      options: [
        { code: "0", description: "Flat" },
        { code: "8", description: "8°" }
      ]
    },
    {
      index: 18,
      label: "Angle Shape",
      required: true,
      options: [
        { code: "T", description: "Trapezoid" },
        { code: "P", description: "Parallel" }
      ]
    }
  ],

  groupedOptions: [
    {
      group: "lensDiameter",
      label: "Lens Diameter",
      indexes: [3, 4],
      options: [
        { code: "10", description: "1.0 mm" },
        { code: "18", description: "1.8 mm" },
        { code: "20", description: "2.0 mm" },
        { code: "30", description: "3.0 mm" },
        { code: "40", description: "4.0 mm" }
      ]
    },
    {
      group: "variablePitch",
      label: "Variable Pitch",
      indexes: [5, 6, 7, 8, 9],
      description:
        "S followed by 4 numeric digits. Example: S0250 = 0.250 pitch, S0245 = 0.245 pitch.",
      allowPattern: "^S[0-9]{4}$"
    },
    {
      group: "variableCuttingWavelength",
      label: "Variable Cutting Wavelength",
      indexes: [10, 11, 12],
      options: [
        { code: "063", description: "630 nm" },
        { code: "083", description: "830 nm" },
        { code: "131", description: "1310 nm" },
        { code: "155", description: "1550 nm" }
      ]
    }
  ],

  notes: [
    "Lens Diameter is limited to 10, 18, 20, 30, and 40.",
    "Variable Pitch must start with S followed by 4 numeric digits.",
    "Variable Cutting Wavelength is limited to 063, 083, 131, or 155.",
    "Side A and Side B AR coating codes correspond to the AR Coating table."
  ],

  example: {
    code: "XNW18S0250155KKN28T",
    description:
      "SELFOC Microlens example with angled SML type, no side coating, W-Type lens, 1.8 mm diameter, S0250 variable pitch, 1550 nm cutting wavelength, AR coating values, and angled trapezoid configuration."
  }
},
{
  id: "selfoc-imaging-lenses",
  familyCode: "I",
  matchPrefix: "I",
  minLength: 16,
  maxLength: 16,
  productName: "SELFOC® Imaging Lenses",
  productPage: "/selfoc-imaging-lenses",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FSELFOC-Imaging-Lens-Basic-Character-Data-Sheet.pdf?alt=media&token=56f9161b-68fb-498e-a98f-37e092b7aa1b",

  positions: [
    {
      index: 0,
      label: "Lens Type - Character 1",
      group: "lensType",
      required: true,
      options: [{ code: "I", description: "SELFOC Imaging Lens prefix" }]
    },
    {
      index: 1,
      label: "Lens Type - Character 2",
      group: "lensType",
      required: true,
      options: [{ code: "L", description: "SELFOC Imaging Lens prefix" }]
    },
    {
      index: 2,
      label: "Lens Type - Character 3",
      group: "lensType",
      required: true,
      options: [
        { code: "H", description: "ILH" },
        { code: "W", description: "ILW" }
      ]
    },
    {
      index: 3,
      label: "Side Coating",
      required: true,
      options: [
        { code: "N", description: "No Coating" }
      ]
    },

    {
      index: 4,
      label: "Lens Diameter - Digit 1",
      group: "lensDiameter",
      required: true,
      options: [
        { code: "0", description: "0.20mm, 0.25mm, 0.35mm, 0.50mm, or 0.70mm prefix" },
        { code: "1", description: "1.00mm, 1.30mm, or 1.80mm prefix" },
        { code: "2", description: "2.00mm or 2.70mm prefix" }
      ]
    },
    {
      index: 5,
      label: "Lens Diameter - Digit 2",
      group: "lensDiameter",
      required: true,
      options: [
        { code: "2", description: "0.20mm or 0.25mm" },
        { code: "3", description: "0.35mm" },
        { code: "5", description: "0.50mm" },
        { code: "7", description: "0.70mm or 2.70mm" },
        { code: "0", description: "1.00mm or 2.00mm" },
        { code: "8", description: "1.80mm" }
      ]
    },
    {
      index: 6,
      label: "Lens Diameter - Digit 3",
      group: "lensDiameter",
      required: true,
      options: [
        { code: "0", description: "Standard diameter suffix" },
        { code: "5", description: "0.25mm or 0.35mm suffix" }
      ]
    },

    {
      index: 7,
      label: "Given Parameter",
      required: true,
      options: [
        { code: "W", description: "Working Distance" }
      ]
    },

    {
      index: 8,
      label: "Variable Parameter Value - Digit 1",
      group: "variableParameterValue",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "Variable Parameter Value - Digit 2",
      group: "variableParameterValue",
      required: true,
      options: "0-9"
    },
    {
      index: 10,
      label: "Variable Parameter Value - Digit 3",
      group: "variableParameterValue",
      required: true,
      options: "0-9"
    },

    {
      index: 11,
      label: "Wavelength - Digit 1",
      group: "wavelength",
      required: true,
      options: [{ code: "0", description: "550nm prefix" }]
    },
    {
      index: 12,
      label: "Wavelength - Digit 2",
      group: "wavelength",
      required: true,
      options: [{ code: "5", description: "550nm" }]
    },
    {
      index: 13,
      label: "Wavelength - Digit 3",
      group: "wavelength",
      required: true,
      options: [{ code: "5", description: "550nm" }]
    },

    {
      index: 14,
      label: "Side A Coating",
      required: true,
      options: [
        { code: "N", description: "NON COAT" }
      ]
    },
    {
      index: 15,
      label: "Side B Coating",
      required: true,
      options: [
        { code: "N", description: "NON COAT" }
      ]
    }
  ],

  groupedOptions: [
    {
      group: "lensType",
      label: "Lens Type",
      indexes: [0, 1, 2],
      options: [
        { code: "ILH", description: "ILH" },
        { code: "ILW", description: "ILW" }
      ]
    },
    {
      group: "lensDiameter",
      label: "Lens Diameter",
      indexes: [4, 5, 6],
      options: [
        { code: "020", description: "0.20 mm" },
        { code: "025", description: "0.25 mm" },
        { code: "035", description: "0.35 mm" },
        { code: "050", description: "0.50 mm" },
        { code: "070", description: "0.70 mm" },
        { code: "100", description: "1.00 mm" },
        { code: "130", description: "1.30 mm" },
        { code: "180", description: "1.80 mm" },
        { code: "200", description: "2.00 mm" },
        { code: "270", description: "2.70 mm" }
      ]
    },
    {
      group: "variableParameterValue",
      label: "Given Parameter Value",
      indexes: [8, 9, 10],
      description:
        "3 numeric value of given parameter. Example: 050 = 5.0 mm, 100 = 10.0 mm, 002 = 0.2 mm.",
      allowNumeric: true
    },
    {
      group: "wavelength",
      label: "Wavelength",
      indexes: [11, 12, 13],
      options: [
        { code: "055", description: "550 nm" }
      ]
    }
  ],

  notes: [
    "Lens Diameter is limited to 020, 025, 035, 050, 070, 100, 130, 180, 200, or 270.",
    "Given parameter W represents working distance.",
    "Given parameter value uses a 3 numeric value.",
    "Wavelength code 055 represents 550 nm.",
    "Side A and Side B coating are fixed to N for NON COAT."
  ],

  example: {
    code: "ILHN050W050055NN",
    description:
      "SELFOC Imaging Lens example with ILH lens type, no coating, 0.50 mm lens diameter, working distance parameter, 5.0 mm parameter value, 550 nm wavelength, and non-coated sides A and B."
  }
},
{
  id: "selfoc-rod-lenses",
  familyCode: "S",
  matchPrefix: "SRL",
  minLength: 14,
  maxLength: 14,
  productName: "SELFOC® Rod Lenses",
  productPage: "/selfoc-rod-lenses",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FSelfoc-Rod-Lenses-Datasheet.pdf?alt=media&token=c7372f5a-568a-4592-b583-2a1e48c48841",

  positions: [
    {
      index: 0,
      label: "Lens Type - Character 1",
      group: "lensType",
      required: true,
      options: [{ code: "S", description: "SELFOC Rod Lens prefix" }]
    },
    {
      index: 1,
      label: "Lens Type - Character 2",
      group: "lensType",
      required: true,
      options: [{ code: "R", description: "SELFOC Rod Lens prefix" }]
    },
    {
      index: 2,
      label: "Lens Type - Character 3",
      group: "lensType",
      required: true,
      options: [{ code: "L", description: "SELFOC Rod Lens" }]
    },

    {
      index: 3,
      label: "Lens Diameter - Digit 1",
      group: "lensDiameter",
      required: true,
      options: [
        { code: "0", description: "0.20mm, 0.25mm, 0.35mm, 0.50mm, or 0.70mm prefix" },
        { code: "1", description: "1.00mm, 1.30mm, or 1.80mm prefix" },
        { code: "2", description: "2.00mm or 2.70mm prefix" }
      ]
    },
    {
      index: 4,
      label: "Lens Diameter - Digit 2",
      group: "lensDiameter",
      required: true,
      options: [
        { code: "2", description: "0.20mm or 0.25mm" },
        { code: "3", description: "0.35mm" },
        { code: "5", description: "0.50mm" },
        { code: "7", description: "0.70mm or 2.70mm" },
        { code: "0", description: "1.00mm or 2.00mm" },
        { code: "8", description: "1.80mm" }
      ]
    },
    {
      index: 5,
      label: "Lens Diameter - Digit 3",
      group: "lensDiameter",
      required: true,
      options: [
        { code: "0", description: "Standard diameter suffix" },
        { code: "5", description: "0.25mm or 0.35mm suffix" }
      ]
    },

    {
      index: 6,
      label: "Pitch - Prefix",
      group: "pitch",
      required: true,
      options: [{ code: "P", description: "Pitch prefix" }]
    },
    {
      index: 7,
      label: "Pitch - Digit 1",
      group: "pitch",
      required: true,
      options: [
        { code: "1", description: "1.0 pitch prefix" },
        { code: "2", description: "2.5 pitch prefix" },
        { code: "3", description: "3.25 pitch prefix" },
        { code: "4", description: "4.0 pitch prefix" },
        { code: "5", description: "5.25 pitch prefix" }
      ]
    },
    {
      index: 8,
      label: "Pitch - Digit 2",
      group: "pitch",
      required: true,
      options: [
        { code: "0", description: "1.0 or 4.0 pitch" },
        { code: "5", description: "2.5 or 5.25 pitch" },
        { code: "2", description: "3.25 pitch" }
      ]
    },
    {
      index: 9,
      label: "Pitch - Digit 3",
      group: "pitch",
      required: true,
      options: [
        { code: "0", description: "1.0, 2.5, or 4.0 pitch" },
        { code: "5", description: "3.25 or 5.25 pitch" }
      ]
    },

    {
      index: 10,
      label: "Objective Lens",
      required: true,
      options: [
        { code: "0", description: "Not Included" },
        { code: "1", description: "Included but not Assembled" },
        { code: "2", description: "Assembled" }
      ]
    },
    {
      index: 11,
      label: "Front Cover Lens",
      required: true,
      options: [
        { code: "0", description: "Not Included" },
        { code: "1", description: "Included but not Assembled" },
        { code: "2", description: "Assembled" }
      ]
    },
    {
      index: 12,
      label: "Rear Cover Lens",
      required: true,
      options: [
        { code: "0", description: "Not Included" },
        { code: "1", description: "Included but not Assembled" },
        { code: "2", description: "Assembled" }
      ]
    },
    {
      index: 13,
      label: "SS Tube",
      required: true,
      options: [
        { code: "0", description: "Not Included" },
        { code: "1", description: "Included but not assembled" },
        { code: "2", description: "Assembled, 0.5mm protrusion at distal (SRL) end" },
        { code: "3", description: "Assembled, 0.25mm protrusion at each end" },
        { code: "4", description: "Assembled, 0.50mm protrusion at proximal (ILW) end" }
      ]
    }
  ],

  groupedOptions: [
    {
      group: "lensType",
      label: "Lens Type",
      indexes: [0, 1, 2],
      options: [
        { code: "SRL", description: "SELFOC Rod Lens" }
      ]
    },
    {
      group: "lensDiameter",
      label: "Lens Diameter",
      indexes: [3, 4, 5],
      options: [
        { code: "020", description: "0.20 mm" },
        { code: "025", description: "0.25 mm" },
        { code: "035", description: "0.35 mm" },
        { code: "050", description: "0.50 mm" },
        { code: "070", description: "0.70 mm" },
        { code: "100", description: "1.00 mm" },
        { code: "130", description: "1.30 mm" },
        { code: "180", description: "1.80 mm" },
        { code: "200", description: "2.00 mm" },
        { code: "270", description: "2.70 mm" }
      ]
    },
    {
      group: "pitch",
      label: "Pitch",
      indexes: [6, 7, 8, 9],
      options: [
        { code: "P100", description: "1.0 Pitch" },
        { code: "P250", description: "2.5 Pitch" },
        { code: "P325", description: "3.25 Pitch" },
        { code: "P400", description: "4.0 Pitch" },
        { code: "P525", description: "5.25 Pitch" }
      ]
    }
  ],

  notes: [
    "Lens Diameter is limited to 020, 025, 035, 050, 070, 100, 130, 180, 200, or 270.",
    "Pitch is limited to P100, P250, P325, P400, or P525.",
    "Objective Lens, Front Cover Glass, and Rear Cover Glass use the same option set.",
    "SS Tube options define whether the tube is included, assembled, and protrusion details."
  ],

  example: {
    code: "SRL050P1000000",
    description:
      "SELFOC Rod Lens example with 0.50 mm lens diameter, 1.0 pitch, no objective lens, no front cover lens, no rear cover lens, and no SS tube."
  }
},
{
  id: "neuroscience-imaging-lenses",
  familyCode: "C",
  matchPrefix: "CLH",
  prefixMatches: ["CLH", "CLE", "CLP", "CEP"],
  allowPrefixMatch: true,
  lookupOnly: true,
  minLength: 3,
  maxLength: 13,
  productName: "Neuroscience Imaging Lenses",
  productPage: "/neuroscience-imaging-lenses",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FCLH-CLE%20Datasheet.pdf?alt=media&token=30737ae0-ed72-4c06-bed1-3337b45aa05b",

  positions: [
    { index: 0, label: "Model Code", required: true, options: "A-Z" },
    { index: 1, label: "Model Code", required: true, options: "A-Z" },
    { index: 2, label: "Model Code", required: true, options: "A-Z" },
    { index: 3, label: "Model Code", required: false, options: "A-Z" },
    { index: 4, label: "Model Code", required: false, options: "0-9" },
    { index: 5, label: "Model Code", required: false, options: "0-9" },
    { index: 6, label: "Model Code", required: false, options: "0-9" },
    { index: 7, label: "Model Code", required: false, options: "A-Z" },
    { index: 8, label: "Model Code", required: false, options: "A-Z" },
    { index: 9, label: "Model Code", required: false, options: "A-Z" },
    { index: 10, label: "Model Code", required: false, options: "0-9" },
    { index: 11, label: "Model Code", required: false, options: "0-9" },
    {
      index: 12,
      label: "Model Code",
      required: false,
      options: [
        { code: "0", description: "Model Code" },
        { code: "1", description: "Model Code" },
        { code: "2", description: "Model Code" },
        { code: "3", description: "Model Code" },
        { code: "4", description: "Model Code" },
        { code: "5", description: "Model Code" },
        { code: "6", description: "Model Code" },
        { code: "7", description: "Model Code" },
        { code: "8", description: "Model Code" },
        { code: "9", description: "Model Code" },
        { code: "S", description: "Model Code" }
      ]
    }
  ],

  knownPartNumbers: [
    {
      code: "CLHS200GFT048",
      description:
        "OD 2.0mm; Lens Length 3.95 ± 0.55mm; Working Distance in Air 0.2; Distance in Water ∞; Wavelength 550; Application: Single Photon"
    },
    {
      code: "CLHS100GFT003",
      description:
        "OD 1.0mm; Lens Length 3.71 ± 0.50mm; Working Distance in Air 0.2; Distance in Water 0.2; Wavelength 550; Application: Single Photon"
    },
    {
      code: "CLHS100GFT022",
      description:
        "OD 1.0mm; Lens Length 7.99 ± 1.10mm; Working Distance in Air 0.2; Distance in Water 0.2; Wavelength 550; Application: Single Photon"
    },
    {
      code: "CLHS050GFT073",
      description:
        "OD 0.5mm; Lens Length 3.73 ± 0.50mm; Working Distance in Air 0.2; Distance in Water 0.2; Wavelength 550; Application: Single Photon"
    },
    {
      code: "CLHS050GFT013",
      description:
        "OD 0.5mm; Lens Length 5.87 ± 0.79mm; Working Distance in Air 0.2; Distance in Water 0.2; Wavelength 550; Application: Single Photon"
    },
    {
      code: "CLHS050GFT009",
      description:
        "OD 0.5mm; Lens Length 8.02 ± 1.08mm; Working Distance in Air 0.2; Distance in Water 0.2; Wavelength 550; Application: Single Photon"
    },
    {
      code: "CLES050GFT120",
      description:
        "OD 0.5mm; Lens Length 3.71 ± 0.50mm; Working Distance in Air 0.2; Distance in Water 0.2; Wavelength 550; Application: Single Photon"
    },
    {
      code: "CLES050GFT100",
      description:
        "OD 0.5mm; Lens Length 7.99 ± 1.10mm; Working Distance in Air 0.2; Distance in Water 0.2; Wavelength 550; Application: Single Photon"
    },
    {
      code: "CLHS100GFT088",
      description:
        "OD 1.0mm; Lens Length 3.90 ± 0.54mm; Working Distance in Air 0.2; Distance in Water 0.2; Wavelength 920; Application: Two Photon"
    },
    {
      code: "CLHS100GFT089",
      description:
        "OD 1.0mm; Lens Length 8.34 ± 1.13mm; Working Distance in Air 0.2; Distance in Water 0.2; Wavelength 920; Application: Two Photon"
    },
    {
      code: "CLHS050GFT126",
      description:
        "OD 0.5mm; Lens Length 3.89 ± 0.54mm; Working Distance in Air 0.2; Distance in Water 0.2; Wavelength 920; Application: Two Photon"
    },
    {
      code: "CLHS050GFT039",
      description:
        "OD 0.5mm; Lens Length 6.11 ± 0.85mm; Working Distance in Air 0.2; Distance in Water 0.2; Wavelength 920; Application: Two Photon"
    },
    {
      code: "CLHS050GFT090",
      description:
        "OD 0.5mm; Lens Length 8.33 ± 1.13mm; Working Distance in Air 0.2; Distance in Water 0.2; Wavelength 920; Application: Two Photon"
    },
    {
      code: "CLPBC030202S",
      description:
        "Lens OD 1.0mm; Lens Length 3.78 ± 0.50mm; Working Distance in Air 0.2; Distance in Water 0.2; Wavelength 550; Application: Single Photon"
    },
    {
      code: "CLPBC070202S",
      description:
        "Lens OD 1.0mm; Lens Length 8.23 ± 1.02mm; Working Distance in Air 0.2; Distance in Water 0.2; Wavelength 550; Application: Single Photon"
    },
    {
      code: "CLPAA030202S",
      description:
        "Lens OD 0.5mm; Lens Length 3.79 ± 0.50mm; Working Distance in Air 0.2; Distance in Water 0.2; Wavelength 550; Application: Single Photon"
    },
    {
      code: "CEPAA030202S",
      description:
        "Lens OD 0.5mm; Lens Length 3.71 ± 0.50mm; Working Distance in Air 0.2; Distance in Water 0.2; Wavelength 550; Application: Single Photon Wide View"
    },
    {
      code: "CLPAA050202S",
      description:
        "Lens OD 0.5mm; Lens Length 5.80 ± 0.70mm; Working Distance in Air 0.2; Distance in Water 0.2; Wavelength 550; Application: Single Photon"
    },
    {
      code: "CLPAA070202S",
      description:
        "Lens OD 0.5mm; Lens Length 7.89 ± 1.00mm; Working Distance in Air 0.2; Distance in Water 0.2; Wavelength 550; Application: Single Photon"
    },
    {
      code: "CEPAA070202S",
      description:
        "Lens OD 0.5mm; Lens Length 7.89 ± 1.00mm; Working Distance in Air 0.2; Distance in Water 0.2; Wavelength 550; Application: Single Photon Wide View"
    }
  ],

  notes: [
    "This product is lookup-only and does not have a character-by-character ordering guide.",
    "Typing CLH, CLE, CLP, or CEP should identify the Neuroscience Imaging Lenses product page and datasheet.",
    "Typing a full known part number should show the exact matching part-number description."
  ],

  example: {
    code: "CLHS200GFT048",
    description:
      "Neuroscience Imaging Lenses known part number example."
  }
},

{
  id: "ultra-low-leakage-pigtail-power-monitors",
  familyCode: "P",
  matchPrefix: "PP",
  minLength: 14,
  maxLength: 14,
  productName: "Ultra Low Leakage Pigtail Power Monitors",
  productPage: "/ultra-low-leakage-pigtail-power-monitors",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FUltra-Low-Leakage-Pigtail-Power-Monitor.pdf?alt=media&token=56d2a2da-b2f6-4488-a660-e3b20051c526",

  positions: [
    {
      index: 0,
      label: "Product Structure - Character 1",
      group: "productStructure",
      required: true,
      options: [{ code: "P", description: "Pigtail PD prefix" }]
    },
    {
      index: 1,
      label: "Product Structure - Character 2",
      group: "productStructure",
      required: true,
      options: [{ code: "P", description: "Pigtail PD" }]
    },
    {
      index: 2,
      label: "Packaging Size",
      required: true,
      options: [
        { code: "S", description: "Standard Package" },
        { code: "M", description: "Micro Package" }
      ]
    },
    {
      index: 3,
      label: "Product Grade",
      required: true,
      options: [
        { code: "V", description: "Ultra Low Leakage" },
        { code: "L", description: "Low Leakage" }
      ]
    },
    {
      index: 4,
      label: "Number of Channels - Digit 1",
      group: "numberOfChannels",
      required: true,
      options: [{ code: "0", description: "Single Channel prefix" }]
    },
    {
      index: 5,
      label: "Number of Channels - Digit 2",
      group: "numberOfChannels",
      required: true,
      options: [{ code: "1", description: "Single Channel" }]
    },
    {
      index: 6,
      label: "Tap Ratio - Character 1",
      group: "tapRatio",
      required: true,
      options: [{ code: "X", description: "Pigtail PD default tap ratio" }]
    },
    {
      index: 7,
      label: "Tap Ratio - Character 2",
      group: "tapRatio",
      required: true,
      options: [{ code: "X", description: "Pigtail PD default tap ratio" }]
    },
    {
      index: 8,
      label: "Wavelength Range",
      required: true,
      options: [
        { code: "C", description: "1520-1570nm" },
        { code: "L", description: "1570-1610nm" },
        { code: "F", description: "1520-1610nm" },
        { code: "D", description: "1270-1350nm + 1520-1570nm" }
      ]
    },
    {
      index: 9,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "250um (SMF)" },
        { code: "2", description: "900um Loose Tube (SMF)" },
        { code: "3", description: "900um Tight Buffer (SMF)" }
      ]
    },
    {
      index: 10,
      label: "Fiber Length",
      required: true,
      options: [
        { code: "1", description: "1000mm, 1000±100mm" },
        { code: "2", description: "2000mm, 2000±100mm" }
      ]
    },
    {
      index: 11,
      label: "Flange / Mounting Bracket",
      required: true,
      options: [
        { code: "0", description: "No Flange" },
        { code: "1", description: "With Flange" }
      ]
    },
    {
      index: 12,
      label: "Connector - COM Port",
      required: true,
      options: [
        { code: "0", description: "None" },
        { code: "1", description: "FC/SPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/SPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/PC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" }
      ]
    },
    {
      index: 13,
      label: "Connector - REF Port",
      required: true,
      options: [
        { code: "0", description: "None" }
      ]
    }
  ],

  groupedOptions: [
    {
      group: "productStructure",
      label: "Product Structure",
      indexes: [0, 1],
      options: [
        { code: "PP", description: "Pigtail PD" }
      ]
    },
    {
      group: "numberOfChannels",
      label: "Number of Channels",
      indexes: [4, 5],
      options: [
        { code: "01", description: "Single Channel" }
      ]
    },
    {
      group: "tapRatio",
      label: "Tap Ratio",
      indexes: [6, 7],
      options: [
        { code: "XX", description: "Pigtail PD default tap ratio" }
      ]
    }
  ],

  notes: [
    "PP is the default product structure code for Pigtail Power Monitor.",
    "01 is the default single-channel code.",
    "XX is the default tap ratio code for Pigtail Power Monitor.",
    "Connector REF Port uses 0 for none by default."
  ],

  example: {
    code: "PPSV01XXC11000",
    description:
      "Ultra Low Leakage Pigtail Power Monitor example with standard package, ultra low leakage grade, single channel, default tap ratio, C wavelength range, 250um SMF, 1000mm fiber length, no flange, no COM connector, and no REF connector."
  }
},

{
  id: "power-monitor-pin-photodiode-standard",
  familyCode: "P",
  matchPrefix: "PM300",
  minLength: 11,
  maxLength: 11,
  productName: "Power Monitor PIN Photodiode Standard",
  productPage: "/power-monitor-pin-photodiode-standard",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FPower-Monitor-PIN-Photo-Diode.pdf?alt=media&token=cc4bea66-5f81-43c5-9379-c11301f8e2ab",

  positions: [
    {
      index: 0,
      label: "Product Category - Character 1",
      group: "productCategory",
      required: true,
      options: [{ code: "P", description: "Power Monitor" }]
    },
    {
      index: 1,
      label: "Product Category - Character 2",
      group: "productCategory",
      required: true,
      options: [{ code: "M", description: "Power Monitor" }]
    },
    {
      index: 2,
      label: "Product Category - Character 3",
      group: "productCategory",
      required: true,
      options: [{ code: "3", description: "PIN Photodiode Standard" }]
    },
    {
      index: 3,
      label: "Product Category - Character 4",
      group: "productCategory",
      required: true,
      options: [{ code: "0", description: "PIN Photodiode Standard" }]
    },
    {
      index: 4,
      label: "Product Category - Character 5",
      group: "productCategory",
      required: true,
      options: [{ code: "0", description: "PIN Photodiode Standard" }]
    },
    {
      index: 5,
      label: "Package",
      required: true,
      options: [
        { code: "C", description: "Compact" }
      ]
    },
    {
      index: 6,
      label: "Wavelength",
      required: true,
      options: [
        { code: "C", description: "C-Band" }
      ]
    },
    {
      index: 7,
      label: "Flange",
      required: true,
      options: [
        { code: "0", description: "No Flange" },
        { code: "1", description: "With Flange" }
      ]
    },
    {
      index: 8,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "SMF-28e Bare Fiber" },
        { code: "2", description: "900µm Loose Tube" },
        { code: "3", description: "900µm Tight Buffer" }
      ]
    },
    {
      index: 9,
      label: "Fiber Length",
      required: true,
      options: [
        { code: "1", description: "1 Meter" },
        { code: "5", description: "1.5 Meters" },
        { code: "2", description: "2 Meters" }
      ]
    },
    {
      index: 10,
      label: "Connector Type",
      required: true,
      options: [
        { code: "1", description: "FC/SPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/SPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC" },
        { code: "6", description: "MU" },
        { code: "0", description: "None" }
      ]
    }
  ],

  groupedOptions: [
    {
      group: "productCategory",
      label: "Product Category",
      indexes: [0, 1, 2, 3, 4],
      options: [
        { code: "PM300", description: "Power Monitor PIN Photodiode Pigtail Assembly" }
      ]
    }
  ],

  notes: [
    "This ordering guide is shown with hyphens in the datasheet, but the builder should use the clean code without hyphens.",
    "Example PM300-S-C-0-1-1-0 should be entered as PM300SC0110."
  ],

  example: {
    code: "PM300SC0110",
    description:
      "Power Monitor PIN Photodiode Pigtail Assembly, C-Band operating wavelength, no flange, SMF-28e bare fiber, 1 meter length, and no connector."
  }
},
{
  id: "single-channel-tap-detector-standard-and-compact-packaging",
  familyCode: "T",
  matchPrefix: "TP",
  minLength: 14,
  maxLength: 14,
  productName: "Single Channel TAP Detector: Standard and Compact Packaging",
  productPage: "/single-channel-tap-detector-standard-and-compact-packaging",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FSingle-Channel-TAP-Detector-Datasheet-1.pdf?alt=media&token=825a3562-e176-45fb-964d-7b137613c961",

  positions: [
    {
      index: 0,
      label: "Product Structure - Character 1",
      group: "productStructure",
      required: true,
      options: [{ code: "T", description: "TAPD prefix" }]
    },
    {
      index: 1,
      label: "Product Structure - Character 2",
      group: "productStructure",
      required: true,
      options: [{ code: "P", description: "TAPD" }]
    },
    {
      index: 2,
      label: "Package Size",
      required: true,
      options: [
        { code: "S", description: "Standard Package" },
        { code: "C", description: "Compact Package" }
      ]
    },
    {
      index: 3,
      label: "Product Grade",
      required: true,
      options: [
        { code: "L", description: "Low Leakage" }
      ]
    },
    {
      index: 4,
      label: "Number of Channels - Digit 1",
      group: "numberOfChannels",
      required: true,
      options: [{ code: "0", description: "Single Channel prefix" }]
    },
    {
      index: 5,
      label: "Number of Channels - Digit 2",
      group: "numberOfChannels",
      required: true,
      options: [{ code: "1", description: "Single Channel" }]
    },
    {
      index: 6,
      label: "Tap Ratio - Character 1",
      group: "tapRatio",
      required: true,
      options: [
        { code: "0", description: "0.5% prefix" },
        { code: "1", description: "1% prefix" },
        { code: "2", description: "2% prefix" },
        { code: "5", description: "5% prefix" },
        { code: "3", description: "30% prefix" }
      ]
    },
    {
      index: 7,
      label: "Tap Ratio - Character 2",
      group: "tapRatio",
      required: true,
      options: [
        { code: "5", description: "0.5%" },
        { code: "P", description: "1%, 2%, or 5%" },
        { code: "0", description: "10%, 30%, or 50%" }
      ]
    },
    {
      index: 8,
      label: "Wavelength Range",
      required: true,
      options: [
        { code: "C", description: "1520-1570nm" },
        { code: "L", description: "1570-1610nm" },
        { code: "F", description: "1520-1610nm" },
        { code: "D", description: "1270-1350nm + 1520-1570nm" }
      ]
    },
    {
      index: 9,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "250um (SMF)" },
        { code: "2", description: "900um Loose Tube (SMF)" },
        { code: "3", description: "900um Tight Buffer (SMF)" }
      ]
    },
    {
      index: 10,
      label: "Fiber Length",
      required: true,
      options: [
        { code: "1", description: "1000mm, 1000±100mm" },
        { code: "2", description: "2000mm, 2000±100mm" }
      ]
    },
    {
      index: 11,
      label: "Flange / Mounting Bracket",
      required: true,
      options: [
        { code: "0", description: "No Flange" },
        { code: "1", description: "With Flange" }
      ]
    },
    {
      index: 12,
      label: "Connector - COM Port",
      required: true,
      options: [
        { code: "0", description: "None" },
        { code: "1", description: "FC/SPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/SPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/PC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" }
      ]
    },
    {
      index: 13,
      label: "Connector - REF Port",
      required: true,
      options: [
        { code: "0", description: "None" },
        { code: "1", description: "FC/SPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/SPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/PC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" }
      ]
    }
  ],

  groupedOptions: [
    {
      group: "productStructure",
      label: "Product Structure",
      indexes: [0, 1],
      options: [
        { code: "TP", description: "TAPD" }
      ]
    },
    {
      group: "numberOfChannels",
      label: "Number of Channels",
      indexes: [4, 5],
      options: [
        { code: "01", description: "Single Channel" }
      ]
    },
    {
      group: "tapRatio",
      label: "Tap Ratio",
      indexes: [6, 7],
      options: [
        { code: "05", description: "0.5%" },
        { code: "1P", description: "1%" },
        { code: "2P", description: "2%" },
        { code: "5P", description: "5%" },
        { code: "10", description: "10%" },
        { code: "30", description: "30%" },
        { code: "50", description: "50%" }
      ]
    }
  ],

  notes: [
    "TP is the default product structure code for TAPD.",
    "01 is the default single-channel code.",
    "Connector COM Port and Connector REF Port both support connector options 0 through 7."
  ],

  example: {
    code: "TPSL011PC11000",
    description:
      "Single Channel TAP Detector example with standard package, low leakage grade, single channel, 1% tap ratio, C wavelength range, 250um SMF, 1000mm fiber length, no flange, no COM connector, and no REF connector."
  }
},

{
  id: "compact-unidirectional-tap-detector-arrays",
  familyCode: "T",
  matchPrefix: "TPA",
  minLength: 14,
  maxLength: 14,
  productName: "Compact Unidirectional TAP Detector Arrays",
  productPage: "/compact-unidirectional-tap-detector-arrays",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FCompact-Unidirectional-TAP-Detector-Array-Datasheet-1.pdf?alt=media&token=a5ada50a-7ba3-4842-b6d7-ea2f508635cd",

  positions: [
    {
      index: 0,
      label: "Product Structure - Character 1",
      group: "productStructure",
      required: true,
      options: [{ code: "T", description: "TAPD prefix" }]
    },
    {
      index: 1,
      label: "Product Structure - Character 2",
      group: "productStructure",
      required: true,
      options: [{ code: "P", description: "TAPD" }]
    },
    {
      index: 2,
      label: "Array Type",
      required: true,
      options: [{ code: "A", description: "TAP Detector Array" }]
    },
    {
      index: 3,
      label: "Product Grade",
      required: true,
      options: [
        { code: "U", description: "Unidirectional" },
        { code: "P", description: "Premium Unidirectional" }
      ]
    },
    {
      index: 4,
      label: "Number of Channels - Digit 1",
      group: "numberOfChannels",
      required: true,
      options: [{ code: "0", description: "Single Channel prefix" }]
    },
    {
      index: 5,
      label: "Number of Channels - Digit 2",
      group: "numberOfChannels",
      required: true,
      options: [{ code: "1", description: "Single Channel" }]
    },
    {
      index: 6,
      label: "Tap Ratio - Character 1",
      group: "tapRatio",
      required: true,
      options: [
        { code: "0", description: "0.5% prefix" },
        { code: "1", description: "1% prefix" },
        { code: "2", description: "2% prefix" },
        { code: "5", description: "5% prefix" },
        { code: "3", description: "30% prefix" }
      ]
    },
    {
      index: 7,
      label: "Tap Ratio - Character 2",
      group: "tapRatio",
      required: true,
      options: [
        { code: "5", description: "0.5%" },
        { code: "P", description: "1%, 2%, or 5%" },
        { code: "0", description: "10%, 30%, or 50%" }
      ]
    },
    {
      index: 8,
      label: "Wavelength Range",
      required: true,
      options: [
        { code: "C", description: "1520-1570nm" },
        { code: "L", description: "1570-1610nm" },
        { code: "F", description: "1520-1610nm" }
      ]
    },
    {
      index: 9,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "250um (SMF)" }
      ]
    },
    {
      index: 10,
      label: "Fiber Length",
      required: true,
      options: [
        { code: "1", description: "1000mm, 1000±100mm" },
        { code: "2", description: "2000mm, 2000±100mm" }
      ]
    },
    {
      index: 11,
      label: "Flange / Mounting Bracket",
      required: true,
      options: [
        { code: "0", description: "No Flange" }
      ]
    },
    {
      index: 12,
      label: "Connector - INPUT Port",
      required: true,
      options: [
        { code: "0", description: "None" },
        { code: "1", description: "FC/SPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/SPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/PC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" }
      ]
    },
    {
      index: 13,
      label: "Connector - OUTPUT Port",
      required: true,
      options: [
        { code: "0", description: "None" },
        { code: "1", description: "FC/SPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/SPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/PC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" }
      ]
    }
  ],

  groupedOptions: [
    {
      group: "productStructure",
      label: "Product Structure",
      indexes: [0, 1],
      options: [
        { code: "TP", description: "TAPD" }
      ]
    },
    {
      group: "numberOfChannels",
      label: "Number of Channels",
      indexes: [4, 5],
      options: [
        { code: "01", description: "Single Channel" }
      ]
    },
    {
      group: "tapRatio",
      label: "Tap Ratio",
      indexes: [6, 7],
      options: [
        { code: "05", description: "0.5%" },
        { code: "1P", description: "1%" },
        { code: "2P", description: "2%" },
        { code: "5P", description: "5%" },
        { code: "10", description: "10%" },
        { code: "30", description: "30%" },
        { code: "50", description: "50%" }
      ]
    }
  ],

  notes: [
    "The screenshot shows the array product beginning with TPA, so this schema uses matchPrefix: \"TPA\" to avoid conflicting with other TP products.",
    "TP is the TAPD product structure code.",
    "01 is the default single-channel code.",
    "Fiber Type 1 and Flange 0 are shown as default codes in the datasheet."
  ],

  example: {
    code: "TPAU011PC11000",
    description:
      "Compact Unidirectional TAP Detector Array example with unidirectional grade, single channel, 1% tap ratio, C wavelength range, 250um SMF, 1000mm fiber length, no flange, no input connector, and no output connector."
  }
},

{
  id: "integrated-tap-detector-for-fttp-13101550-wdm",
  familyCode: "T",
  matchPrefix: "TPS",
  minLength: 14,
  maxLength: 14,
  productName: "Integrated TAP Detector for FTTP 1310/1550 WDM",
  productPage: "/integrated-tap-detector-for-fttp-13101550-wdm",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FIntegrated-1310-1550-WDM-TAP-Detector-Datasheet-1.pdf?alt=media&token=cd5ddb3f-7d21-43c0-9474-685079ddd000",

  positions: [
    {
      index: 0,
      label: "Product Structure - Character 1",
      group: "productStructure",
      required: true,
      options: [{ code: "T", description: "TAPD prefix" }]
    },
    {
      index: 1,
      label: "Product Structure - Character 2",
      group: "productStructure",
      required: true,
      options: [{ code: "P", description: "TAPD" }]
    },
    {
      index: 2,
      label: "Packaging Size",
      required: true,
      options: [
        { code: "S", description: "Standard Package" }
      ]
    },
    {
      index: 3,
      label: "Product Grade",
      required: true,
      options: [
        { code: "B", description: "Bidirectional" },
        { code: "N", description: "Non-unidirectional" }
      ]
    },
    {
      index: 4,
      label: "Number of Channels - Digit 1",
      group: "numberOfChannels",
      required: true,
      options: [{ code: "0", description: "Single Channel prefix" }]
    },
    {
      index: 5,
      label: "Number of Channels - Digit 2",
      group: "numberOfChannels",
      required: true,
      options: [{ code: "1", description: "Single Channel" }]
    },
    {
      index: 6,
      label: "Tap Ratio - Character 1",
      group: "tapRatio",
      required: true,
      options: [
        { code: "0", description: "0.5% prefix" },
        { code: "1", description: "1% prefix" },
        { code: "2", description: "2% prefix" },
        { code: "5", description: "5% prefix" },
        { code: "3", description: "30% prefix" }
      ]
    },
    {
      index: 7,
      label: "Tap Ratio - Character 2",
      group: "tapRatio",
      required: true,
      options: [
        { code: "5", description: "0.5%" },
        { code: "P", description: "1%, 2%, or 5%" },
        { code: "0", description: "10%, 30%, or 50%" }
      ]
    },
    {
      index: 8,
      label: "Wavelength Range",
      required: true,
      options: [
        { code: "C", description: "1520-1570nm" },
        { code: "L", description: "1570-1610nm" },
        { code: "F", description: "1520-1610nm" },
        { code: "D", description: "1270-1350nm + 1520-1570nm" }
      ]
    },
    {
      index: 9,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "250um (SMF)" },
        { code: "2", description: "900um Loose Tube (SMF)" },
        { code: "3", description: "900um Tight Buffer (SMF)" }
      ]
    },
    {
      index: 10,
      label: "Fiber Length",
      required: true,
      options: [
        { code: "1", description: "1000mm, 1000±100mm" },
        { code: "2", description: "2000mm, 2000±100mm" }
      ]
    },
    {
      index: 11,
      label: "Flange / Mounting Bracket",
      required: true,
      options: [
        { code: "0", description: "No Flange" },
        { code: "1", description: "With Flange" }
      ]
    },
    {
      index: 12,
      label: "Connector - INPUT Port",
      required: true,
      options: [
        { code: "0", description: "None" },
        { code: "1", description: "FC/SPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/SPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/PC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" }
      ]
    },
    {
      index: 13,
      label: "Connector - OUTPUT Port",
      required: true,
      options: [
        { code: "0", description: "None" },
        { code: "1", description: "FC/SPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/SPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/PC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" }
      ]
    }
  ],

  groupedOptions: [
    {
      group: "productStructure",
      label: "Product Structure",
      indexes: [0, 1],
      options: [
        { code: "TP", description: "TAPD" }
      ]
    },
    {
      group: "numberOfChannels",
      label: "Number of Channels",
      indexes: [4, 5],
      options: [
        { code: "01", description: "Single Channel" }
      ]
    },
    {
      group: "tapRatio",
      label: "Tap Ratio",
      indexes: [6, 7],
      options: [
        { code: "05", description: "0.5%" },
        { code: "1P", description: "1%" },
        { code: "2P", description: "2%" },
        { code: "5P", description: "5%" },
        { code: "10", description: "10%" },
        { code: "30", description: "30%" },
        { code: "50", description: "50%" }
      ]
    }
  ],

  notes: [
    "TP is the TAPD product structure code.",
    "S is the standard package code.",
    "01 is the default single-channel code.",
    "This schema uses matchPrefix: \"TPS\" to separate it from other TP/TAP detector products."
  ],

  example: {
    code: "TPSB011PC11000",
    description:
      "Integrated TAP Detector for FTTP 1310/1550 WDM example with standard package, bidirectional grade, single channel, 1% tap ratio, C wavelength range, 250um SMF, 1000mm fiber length, no flange, no input connector, and no output connector."
  }
},

{
  id: "ingaas-avalanche-photodiode-apd-for-otdr",
  familyCode: "P",
  matchPrefix: "PPS",
  minLength: 14,
  maxLength: 14,
  productName: "InGaAs Avalanche Photodiode (APD) for OTDR",
  productPage: "/ingaas-avalanche-photodiode-apd-for-otdr",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FPigtailed-Avalanche-Photo-Detector-Module-Datasheet-1.pdf?alt=media&token=d040169a-e3eb-47a4-a366-9a0df4fa0254",

  positions: [
    {
      index: 0,
      label: "Product Structure - Character 1",
      group: "productStructure",
      required: true,
      options: [{ code: "P", description: "Pigtail PD prefix" }]
    },
    {
      index: 1,
      label: "Product Structure - Character 2",
      group: "productStructure",
      required: true,
      options: [{ code: "P", description: "Pigtail PD" }]
    },
    {
      index: 2,
      label: "Packaging Size",
      required: true,
      options: [
        { code: "S", description: "Standard Package" }
      ]
    },
    {
      index: 3,
      label: "Product Grade",
      required: true,
      options: [
        { code: "L", description: "Low Leakage" }
      ]
    },
    {
      index: 4,
      label: "Number of Channels - Digit 1",
      group: "numberOfChannels",
      required: true,
      options: [{ code: "0", description: "Single Channel prefix" }]
    },
    {
      index: 5,
      label: "Number of Channels - Digit 2",
      group: "numberOfChannels",
      required: true,
      options: [{ code: "1", description: "Single Channel" }]
    },
    {
      index: 6,
      label: "Tap Ratio - Character 1",
      group: "tapRatio",
      required: true,
      options: [{ code: "X", description: "Pigtail PD default tap ratio" }]
    },
    {
      index: 7,
      label: "Tap Ratio - Character 2",
      group: "tapRatio",
      required: true,
      options: [{ code: "X", description: "Pigtail PD default tap ratio" }]
    },
    {
      index: 8,
      label: "Wavelength Range",
      required: true,
      options: [
        { code: "C", description: "1520-1570nm" },
        { code: "L", description: "1570-1610nm" },
        { code: "F", description: "1520-1610nm" },
        { code: "D", description: "1270-1350nm + 1520-1570nm" }
      ]
    },
    {
      index: 9,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "250um (SMF)" },
        { code: "2", description: "900um Loose Tube (SMF)" },
        { code: "3", description: "900um Tight Buffer (SMF)" }
      ]
    },
    {
      index: 10,
      label: "Fiber Length",
      required: true,
      options: [
        { code: "1", description: "1000mm, 1000±100mm" },
        { code: "2", description: "2000mm, 2000±100mm" }
      ]
    },
    {
      index: 11,
      label: "Flange / Mounting Bracket",
      required: true,
      options: [
        { code: "0", description: "No Flange" },
        { code: "1", description: "With Flange" }
      ]
    },
    {
      index: 12,
      label: "Connector - INPUT Port",
      required: true,
      options: [
        { code: "0", description: "None" },
        { code: "1", description: "FC/SPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/SPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/PC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" }
      ]
    },
    {
      index: 13,
      label: "Connector - OUTPUT Port",
      required: true,
      options: [
        { code: "0", description: "None" }
      ]
    }
  ],

  groupedOptions: [
    {
      group: "productStructure",
      label: "Product Structure",
      indexes: [0, 1],
      options: [
        { code: "PP", description: "Pigtail PD" }
      ]
    },
    {
      group: "numberOfChannels",
      label: "Number of Channels",
      indexes: [4, 5],
      options: [
        { code: "01", description: "Single Channel" }
      ]
    },
    {
      group: "tapRatio",
      label: "Tap Ratio",
      indexes: [6, 7],
      options: [
        { code: "XX", description: "Pigtail PD default tap ratio" }
      ]
    }
  ],

  notes: [
    "PP is the default product structure code for Pigtail PD.",
    "S is the standard package code.",
    "L is the default low leakage product grade.",
    "01 is the default single-channel code.",
    "XX is the default tap ratio code.",
    "Connector OUTPUT Port uses 0 for none by default.",
    "This schema uses matchPrefix: \"PPS\" to separate it from other PP pigtail detector products."
  ],

  example: {
    code: "PPSL01XXC11000",
    description:
      "InGaAs Avalanche Photodiode APD for OTDR example with standard package, low leakage grade, single channel, default tap ratio, C wavelength range, 250um SMF, 1000mm fiber length, no flange, no input connector, and no output connector."
  }
},
{
  id: "dense-wavelength-division-multiplexer-dwdm-100-ghz-spacing-single-channel",
  familyCode: "D",
  matchPrefix: "DW",
  minLength: 18,
  maxLength: 18,
  productName: "Dense Wavelength Division Multiplexer (DWDM) 100 GHz Spacing Single Channel",
  productPage: "/dense-wavelength-division-multiplexer-dwdm-100-ghz-spacing-single-channel",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FDWDM-100GHz-Spacing-1x2-Single-Channel-Datasheet.pdf?alt=media&token=71614213-9427-418f-a3ec-d93a58faa23f",

  positions: [
    {
      index: 0,
      label: "Product Category - Character 1",
      group: "productCategory",
      required: true,
      options: [{ code: "D", description: "DWDM prefix" }]
    },
    {
      index: 1,
      label: "Product Category - Character 2",
      group: "productCategory",
      required: true,
      options: [{ code: "W", description: "DWDM" }]
    },
    {
      index: 2,
      label: "Sub Family - Character 1",
      group: "subFamily",
      required: true,
      options: [{ code: "9", description: "DWDM single channel sub family prefix" }]
    },
    {
      index: 3,
      label: "Sub Family - Character 2",
      group: "subFamily",
      required: true,
      options: [{ code: "0", description: "DWDM single channel sub family prefix" }]
    },
    {
      index: 4,
      label: "Sub Family - Character 3",
      group: "subFamily",
      required: true,
      options: [
        { code: "D", description: "Drop" },
        { code: "A", description: "Add" }
      ]
    },
    {
      index: 5,
      label: "Channel Spacing",
      required: true,
      options: [
        { code: "D", description: "100GHz" }
      ]
    },
    {
      index: 6,
      label: "Pass Channel - Band",
      group: "passChannel",
      required: true,
      options: [
        { code: "C", description: "C-band" },
        { code: "L", description: "L-band" }
      ]
    },
    {
      index: 7,
      label: "Pass Channel - Digit 1",
      group: "passChannel",
      required: true,
      options: "0-9"
    },
    {
      index: 8,
      label: "Pass Channel - Digit 2",
      group: "passChannel",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "250um Bare Fiber (Single Mode)" },
        { code: "2", description: "900um Loose Tube White with Single Mode 250um Bare" },
        { code: "3", description: "900um Tight Buffer (Single Mode)" },
        { code: "D", description: "1.2mm Cable (Single Mode)" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },
    {
      index: 10,
      label: "Fiber Length",
      required: true,
      options: [
        { code: "1", description: "1 meter" },
        { code: "2", description: "2 meters" },
        { code: "3", description: "3 meters" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },
    {
      index: 11,
      label: "Connector Type",
      required: true,
      options: [
        { code: "0", description: "No Connector" },
        { code: "1", description: "FC/UPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/UPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/UPC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },
    {
      index: 12,
      label: "Customer Code - Letter 1",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 13,
      label: "Customer Code - Letter 2",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 14,
      label: "Customer Code - Letter 3",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 15,
      label: "Product Series - Digit 1",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 16,
      label: "Product Series - Digit 2",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 17,
      label: "Product Series - Digit 3",
      group: "productSeries",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productCategory",
      label: "Product Category",
      indexes: [0, 1],
      options: [
        { code: "DW", description: "DWDM" }
      ]
    },
    {
      group: "subFamily",
      label: "Sub Family",
      indexes: [2, 3, 4],
      options: [
        { code: "90D", description: "Drop" },
        { code: "90A", description: "Add" }
      ]
    },
    {
      group: "passChannel",
      label: "Pass Channel",
      indexes: [6, 7, 8],
      description:
        "DWDM pass channel. First character is C-band or L-band. The next two characters are numeric channel digits. Example: C21 = C-band channel 21."
    },
    {
      group: "customerCode",
      label: "Customer Code",
      indexes: [12, 13, 14],
      description: "3-letter customer code. Only applicable for products not covered by the standard specification."
    },
    {
      group: "productSeries",
      label: "Product Series",
      indexes: [15, 16, 17],
      description: "3-digit product series. Only applicable for products not covered by the standard specification.",
      allowNumeric: true
    }
  ],

  notes: [
    "Standard Fiber Type is ITU-T G657.A2/B2 and G652.D compliant single mode fiber.",
    "Standard package size is OD5.5mm x L40[49]mm for fiber types 1–3.",
    "For 1.2mm cable, package size is OD3.2mm x L65[75]mm.",
    "Fiber length tolerance is +/-0.1 meter for products with connector termination.",
    "All ports use connectors of the same type.",
    "Customer Code and Product Series are only applicable for products not covered by the standard specification."
  ],

  example: {
    code: "DW90DDC21110",
    description:
      "DWDM, 3PM, 100GHz, C21, 250um bare fiber, 1 meter length, no connector on all ports."
  }
},

{
  id: "planar-lightwave-circuit-plc-splitter",
  familyCode: "P",
  matchPrefix: "PLCS",
  minLength: 18,
  maxLength: 18,
  productName: "Planar Lightwave Circuit (PLC) Splitter",
  productPage: "/planar-lightwave-circuit-plc-splitter",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FPLC-Datasheet.pdf?alt=media&token=46ad4e9b-f895-4d53-8b16-d1a01e1ff27a",

  positions: [
    {
      index: 0,
      label: "Product Category - Character 1",
      group: "productCategory",
      required: true,
      options: [{ code: "P", description: "PLC Splitter prefix" }]
    },
    {
      index: 1,
      label: "Product Category - Character 2",
      group: "productCategory",
      required: true,
      options: [{ code: "L", description: "PLC Splitter prefix" }]
    },
    {
      index: 2,
      label: "Product Category - Character 3",
      group: "productCategory",
      required: true,
      options: [{ code: "C", description: "PLC Splitter prefix" }]
    },
    {
      index: 3,
      label: "Product Category - Character 4",
      group: "productCategory",
      required: true,
      options: [{ code: "S", description: "PLC Splitter" }]
    },
    {
      index: 4,
      label: "Type",
      required: true,
      options: [
        { code: "S", description: "Standard" }
      ]
    },

    {
      index: 5,
      label: "Configuration - Character 1",
      group: "configuration",
      required: true,
      options: [{ code: "1", description: "1x splitter prefix" }]
    },
    {
      index: 6,
      label: "Configuration - Character 2",
      group: "configuration",
      required: true,
      options: "0-9"
    },
    {
      index: 7,
      label: "Configuration - Character 3",
      group: "configuration",
      required: true,
      options: "0-9"
    },

    {
      index: 8,
      label: "Package",
      required: true,
      options: [
        { code: "M", description: "Mini" },
        { code: "B", description: "Box" },
        { code: "N", description: "Blockless" }
      ]
    },
    {
      index: 9,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "250um Bare Fiber Ribbon (Single Mode)" },
        { code: "2", description: "900um Loose Tube White with Single Mode 250um Bare Fiber Inside" },
        { code: "C", description: "2mm Cable (Single Mode)" },
        { code: "D", description: "1.2mm Cable (Single Mode)" },
        { code: "N", description: "250um Bare Fiber Non-Ribbon (Single Mode)" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },
    {
      index: 10,
      label: "Fiber Length",
      required: true,
      options: [
        { code: "1", description: "1 meter" },
        { code: "2", description: "2 meters" },
        { code: "3", description: "3 meters" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },
    {
      index: 11,
      label: "Connector Type",
      required: true,
      options: [
        { code: "0", description: "No connector" },
        { code: "1", description: "FC/UPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/UPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/UPC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },

    {
      index: 12,
      label: "Customer Code - Letter 1",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 13,
      label: "Customer Code - Letter 2",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 14,
      label: "Customer Code - Letter 3",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },

    {
      index: 15,
      label: "Product Series - Digit 1",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 16,
      label: "Product Series - Digit 2",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 17,
      label: "Product Series - Digit 3",
      group: "productSeries",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productCategory",
      label: "Product Category",
      indexes: [0, 1, 2, 3],
      options: [
        { code: "PLCS", description: "PLC Splitter" }
      ]
    },
    {
      group: "configuration",
      label: "Configuration",
      indexes: [5, 6, 7],
      options: [
        { code: "102", description: "1x2 Splitter" },
        { code: "104", description: "1x4 Splitter" },
        { code: "108", description: "1x8 Splitter" },
        { code: "112", description: "1x12 Splitter" },
        { code: "116", description: "1x16 Splitter" },
        { code: "124", description: "1x24 Splitter" },
        { code: "132", description: "1x32 Splitter" },
        { code: "164", description: "1x64 Splitter" }
      ]
    },
    {
      group: "customerCode",
      label: "Customer Code",
      indexes: [12, 13, 14],
      description: "3-letter customer code."
    },
    {
      group: "productSeries",
      label: "Product Series",
      indexes: [15, 16, 17],
      description: "3-digit product series.",
      allowNumeric: true
    }
  ],

  notes: [
    "PLC in blockless, mini, and box configurations.",
    "Customer Code and Product Series are only applicable for products not covered by the standard specification."
  ],

  example: {
    code: "PLCSS104M110",
    description:
      "PLC Splitter, standard type, 1x4 configuration, mini package, 250um bare fiber ribbon single mode, 1 meter fiber length, no connector."
  }
},

{
  id: "dense-wavelength-division-multiplexer-dwdm-100-ghz-spacing-multi-channel",
  familyCode: "D",
  matchPrefix: "DW",
  minLength: 14,
  maxLength: 20,
  productName: "Dense Wavelength Division Multiplexer (DWDM) 100 GHz Spacing Multi-Channel",
  productPage: "/dense-wavelength-division-multiplexer-dwdm-100-ghz-spacing-multi-channel",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FDWDM-100G-Spacing-Multi-Channel-Datasheet.pdf?alt=media&token=8990fb0b-8b03-462f-9094-a76fb84fac52",

  positions: [
    {
      index: 0,
      label: "Product Category - Character 1",
      group: "productCategory",
      required: true,
      options: [{ code: "D", description: "DWDM prefix" }]
    },
    {
      index: 1,
      label: "Product Category - Character 2",
      group: "productCategory",
      required: true,
      options: [{ code: "W", description: "DWDM" }]
    },

    {
      index: 2,
      label: "Product Sub-Category - Character 1",
      group: "productSubCategory",
      required: true,
      options: [{ code: "0", description: "WDM cassette sub-category prefix" }]
    },
    {
      index: 3,
      label: "Product Sub-Category - Character 2",
      group: "productSubCategory",
      required: true,
      options: [
        { code: "1", description: "4CH Multiplexer / Demultiplexer" },
        { code: "2", description: "8CH Multiplexer / Demultiplexer" },
        { code: "3", description: "16CH Multiplexer / Demultiplexer" },
        { code: "4", description: "20CH Multiplexer / Demultiplexer" },
        { code: "5", description: "40CH Multiplexer / Demultiplexer" },
        { code: "9", description: "Other number of channels" }
      ]
        },
        {
          index: 4,
          label: "Product Sub-Category - Character 3",
          group: "productSubCategory",
          required: true,
          options: [
            { code: "M", description: "Multiplexer" },
            { code: "X", description: "Demultiplexer" },
            { code: "P", description: "Premium grade channel configuration" }
          ]
        },

        {
          index: 5,
          label: "Channel Spacing",
          required: true,
          options: [
            { code: "D", description: "100GHz DWDM" }
          ]
        },

      {
        index: 6,
        label: "Channel Plan - Band",
        group: "channelPlan",
        required: true,
        options: [
          { code: "C", description: "C-band" },
          { code: "L", description: "L-band" }
        ]
      },
      {
        index: 7,
        label: "Longest Channel - Digit 1",
        group: "channelPlan",
        required: true,
        options: "0-9"
      },
      {
        index: 8,
        label: "Longest Channel - Digit 2",
        group: "channelPlan",
        required: true,
        options: "0-9"
      },
      {
        index: 9,
        label: "Shortest Channel - Digit 1",
        group: "channelPlan",
        required: true,
        options: "0-9"
      },
      {
        index: 10,
        label: "Shortest Channel - Digit 2",
        group: "channelPlan",
        required: true,
        options: "0-9"
      },

    {
      index: 11,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "250um Bare Fiber (Single Mode)" },
        { code: "2", description: "900um Loose Tube White with Single Mode 250um Bare Fiber Inside" },
        { code: "3", description: "900um Tight Buffer (Single Mode)" },
        { code: "C", description: "2mm Cable (Single Mode)" },
        { code: "D", description: "1.2mm Cable (Single Mode)" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },
    {
      index: 12,
      label: "Fiber Length",
      required: true,
      options: [
        { code: "1", description: "1 meter" },
        { code: "2", description: "2 meters" },
        { code: "3", description: "3 meters" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },
    {
      index: 13,
      label: "Connector Type",
      required: true,
      options: [
        { code: "0", description: "No Connector" },
        { code: "1", description: "FC/UPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/UPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/UPC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },

    {
      index: 14,
      label: "Customer Code - Letter 1",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 15,
      label: "Customer Code - Letter 2",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 16,
      label: "Customer Code - Letter 3",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },

    {
      index: 17,
      label: "Product Series - Digit 1",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 18,
      label: "Product Series - Digit 2",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 19,
      label: "Product Series - Digit 3",
      group: "productSeries",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productCategory",
      label: "Product Category",
      indexes: [0, 1],
      options: [
        { code: "DW", description: "DWDM" }
      ]
    },
    {
      group: "productSubCategory",
      label: "Product Sub-Category",
      indexes: [2, 3, 4],
      options: [
        { code: "01M", description: "4CH Multiplexer" },
        { code: "01X", description: "4CH Demultiplexer" },
        { code: "02M", description: "8CH Multiplexer" },
        { code: "02X", description: "8CH Demultiplexer" },
        { code: "03M", description: "16CH Multiplexer" },
        { code: "03X", description: "16CH Demultiplexer" },
        { code: "04M", description: "20CH Multiplexer" },
        { code: "04X", description: "20CH Demultiplexer" },
        { code: "05M", description: "40CH Multiplexer" },
        { code: "05X", description: "40CH Demultiplexer" },
        { code: "09M", description: "Other Number of Channels Multiplexer" },
        { code: "09X", description: "Other Number of Channels Demultiplexer" },
        { code: "01P", description: "4CH Premium Grade Channel Configuration" },
        { code: "02P", description: "8CH Premium Grade Channel Configuration" },
        { code: "03P", description: "16CH Premium Grade Channel Configuration" },
        { code: "04P", description: "20CH Premium Grade Channel Configuration" },
        { code: "05P", description: "40CH Premium Grade Channel Configuration" },
        { code: "09P", description: "Other Number of Channels Premium Grade Channel Configuration" }
      ]
    },
    {
      group: "channelPlan",
      label: "Channel Plan",
      indexes: [6, 7, 8, 9, 10],
      description:
        "DWDM channel plan. First character is C-band or L-band. The next two digits are the longest channel, and the final two digits are the shortest channel. Example: C3925 = C-band, longest channel 39, shortest channel 25."
    },
    {
      group: "customerCode",
      label: "Customer Code",
      indexes: [14, 15, 16],
      description: "3-letter customer code. Only applicable for products not covered by the standard specification."
    },
    {
      group: "productSeries",
      label: "Product Series",
      indexes: [17, 18, 19],
      description: "3-digit product series. Only applicable for products not covered by the standard specification.",
      allowNumeric: true
    }
  ],

  notes: [
    "Standard Fiber Type is ITU-T G657.A2/B2 and G652.D compliant single mode fiber.",
    "Standard package size is 60x35x6mm for 4CH, 70x45x8mm for 8CH, 110x90x8mm for 16CH and 20CH, and 140x95x16mm for 40CH.",
    "Fiber length tolerance is +/-0.1 meter.",
    "All ports use connectors of the same type.",
    "Customer Code and Product Series are only applicable for products not covered by the standard specification."
  ],

  example: {
    code: "DW02XDC2720317",
    description:
      "DWDM 100GHz module, 8CH demultiplexer, C2720 channel plan, 900um tight buffer single mode, 1 meter, LC/APC connector."
  }
},

{
  id: "dense-wavelength-division-multiplexer-dwdm-200-ghz-spacing-single-channel",
  familyCode: "D",
  matchPrefix: "DW",
  minLength: 18,
  maxLength: 18,
  productName: "Dense Wavelength Division Multiplexer (DWDM) 200 GHz Spacing Single Channel",
  productPage: "/dense-wavelength-division-multiplexer-dwdm-200-ghz-spacing-single-channel",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FDWDM-200GHz-Spacing-1x2-Single-Channel-Datasheet-2.pdf?alt=media&token=5355d810-e98a-4a3e-a3f5-33ddc475ab35",

  positions: [
    {
      index: 0,
      label: "Product Category - Character 1",
      group: "productCategory",
      required: true,
      options: [{ code: "D", description: "DWDM prefix" }]
    },
    {
      index: 1,
      label: "Product Category - Character 2",
      group: "productCategory",
      required: true,
      options: [{ code: "W", description: "DWDM" }]
    },
    {
      index: 2,
      label: "Sub Family - Character 1",
      group: "subFamily",
      required: true,
      options: [{ code: "9", description: "DWDM single channel sub family prefix" }]
    },
    {
      index: 3,
      label: "Sub Family - Character 2",
      group: "subFamily",
      required: true,
      options: [{ code: "0", description: "DWDM single channel sub family prefix" }]
    },
    {
      index: 4,
      label: "Sub Family - Character 3",
      group: "subFamily",
      required: true,
      options: [
        { code: "D", description: "Drop" },
        { code: "A", description: "Add" }
      ]
    },
    {
      index: 5,
      label: "Channel Spacing",
      required: true,
      options: [
        { code: "E", description: "200GHz" }
      ]
    },
    {
      index: 6,
      label: "Pass Channel - Band",
      group: "passChannel",
      required: true,
      options: [
        { code: "C", description: "C-band" },
        { code: "L", description: "L-band" }
      ]
    },
    {
      index: 7,
      label: "Pass Channel - Digit 1",
      group: "passChannel",
      required: true,
      options: "0-9"
    },
    {
      index: 8,
      label: "Pass Channel - Digit 2",
      group: "passChannel",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "250um Bare Fiber (Single Mode)" },
        { code: "2", description: "900um Loose Tube White with Single Mode 250um Bare Fiber Inside" },
        { code: "3", description: "900um Tight Buffer (Single Mode)" },
        { code: "D", description: "1.2mm Cable (Single Mode)" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },
    {
      index: 10,
      label: "Fiber Length",
      required: true,
      options: [
        { code: "1", description: "1 meter" },
        { code: "2", description: "2 meters" },
        { code: "3", description: "3 meters" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },
    {
      index: 11,
      label: "Connector Type",
      required: true,
      options: [
        { code: "0", description: "No Connector" },
        { code: "1", description: "FC/UPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/UPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/UPC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },
    {
      index: 12,
      label: "Customer Code - Letter 1",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 13,
      label: "Customer Code - Letter 2",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 14,
      label: "Customer Code - Letter 3",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 15,
      label: "Product Series - Digit 1",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 16,
      label: "Product Series - Digit 2",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 17,
      label: "Product Series - Digit 3",
      group: "productSeries",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productCategory",
      label: "Product Category",
      indexes: [0, 1],
      options: [
        { code: "DW", description: "DWDM" }
      ]
    },
    {
      group: "subFamily",
      label: "Sub Family",
      indexes: [2, 3, 4],
      options: [
        { code: "90D", description: "Drop" },
        { code: "90A", description: "Add" }
      ]
    },
    {
      group: "passChannel",
      label: "Pass Channel",
      indexes: [6, 7, 8],
      description:
        "DWDM pass channel. First character is C-band or L-band. The next two characters are numeric channel digits. Example: C21 = C-band channel 21."
    },
    {
      group: "customerCode",
      label: "Customer Code",
      indexes: [12, 13, 14],
      description: "3-letter customer code. Only applicable for products not covered by the standard specification."
    },
    {
      group: "productSeries",
      label: "Product Series",
      indexes: [15, 16, 17],
      description: "3-digit product series. Only applicable for products not covered by the standard specification.",
      allowNumeric: true
    }
  ],

  notes: [
    "Standard Fiber Type is ITU-T G657.A2/B2 and G652.D compliant single mode fiber.",
    "Standard package size is OD5.5mm x L40[49]mm for fiber types 1–3.",
    "For 1.2mm cable, package size is OD3.2mm x L65[75]mm.",
    "Fiber length tolerance is +/-0.1 meter for products with connector termination.",
    "All ports use connectors of the same type.",
    "Customer Code and Product Series are only applicable for products not covered by the standard specification."
  ],

  example: {
    code: "DW90DEC21110",
    description:
      "DWDM, 3PM, 200GHz, C21, 250um bare fiber, 1 meter length, no connector on all ports."
  }
},
{
  id: "dense-wavelength-division-multiplexer-dwdm-200-ghz-spacing-multi-channel",
  familyCode: "D",
  matchPrefix: "DW",
  minLength: 14,
  maxLength: 20,
  productName: "Dense Wavelength Division Multiplexer (DWDM) 200 GHz Spacing Multi-Channel",
  productPage: "/dense-wavelength-division-multiplexer-dwdm-200-ghz-spacing-multi-channel",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FDWDM-200GHz-Spacing-1x2-Single-Channel-Datasheet-2-1.pdf?alt=media&token=c5e7d20d-dea6-45d3-8b42-cf8aa79930fb",

  positions: [
    {
      index: 0,
      label: "Product Category - Character 1",
      group: "productCategory",
      required: true,
      options: [{ code: "D", description: "DWDM prefix" }]
    },
    {
      index: 1,
      label: "Product Category - Character 2",
      group: "productCategory",
      required: true,
      options: [{ code: "W", description: "DWDM" }]
    },
    {
      index: 2,
      label: "Product Sub-Category - Character 1",
      group: "productSubCategory",
      required: true,
      options: [{ code: "0", description: "WDM cassette sub-category prefix" }]
    },
    {
      index: 3,
      label: "Product Sub-Category - Character 2",
      group: "productSubCategory",
      required: true,
      options: [
        { code: "1", description: "4CH" },
        { code: "2", description: "8CH" },
        { code: "3", description: "16CH" },
        { code: "4", description: "20CH" },
        { code: "5", description: "40CH" },
        { code: "9", description: "Other number of channels" }
      ]
    },
    {
      index: 4,
      label: "Product Sub-Category - Character 3",
      group: "productSubCategory",
      required: true,
      options: [
        { code: "M", description: "Multiplexer" },
        { code: "X", description: "Demultiplexer" },
        { code: "P", description: "Premium grade channel configuration" }
      ]
    },
    {
      index: 5,
      label: "Channel Spacing",
      required: true,
      options: [
        { code: "E", description: "200GHz DWDM" }
      ]
    },
    {
      index: 6,
      label: "Channel Plan - Band",
      group: "channelPlan",
      required: true,
      options: [
        { code: "C", description: "C-band" },
        { code: "L", description: "L-band" }
      ]
    },
    {
      index: 7,
      label: "Longest Channel - Digit 1",
      group: "channelPlan",
      required: true,
      options: "0-9"
    },
    {
      index: 8,
      label: "Longest Channel - Digit 2",
      group: "channelPlan",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "Shortest Channel - Digit 1",
      group: "channelPlan",
      required: true,
      options: "0-9"
    },
    {
      index: 10,
      label: "Shortest Channel - Digit 2",
      group: "channelPlan",
      required: true,
      options: "0-9"
    },
    {
      index: 11,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "250um Bare Fiber (Single Mode)" },
        { code: "2", description: "900um Loose Tube White with Single Mode 250um Bare Fiber Inside" },
        { code: "3", description: "900um Tight Buffer (Single Mode)" },
        { code: "C", description: "2mm Cable (Single Mode)" },
        { code: "D", description: "1.2mm Cable (Single Mode)" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },
    {
      index: 12,
      label: "Fiber Length",
      required: true,
      options: [
        { code: "1", description: "1 meter" },
        { code: "2", description: "2 meters" },
        { code: "3", description: "3 meters" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },
    {
      index: 13,
      label: "Connector Type",
      required: true,
      options: [
        { code: "0", description: "No Connector" },
        { code: "1", description: "FC/UPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/UPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/UPC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },
    {
      index: 14,
      label: "Customer Code - Letter 1",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 15,
      label: "Customer Code - Letter 2",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 16,
      label: "Customer Code - Letter 3",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 17,
      label: "Product Series - Digit 1",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 18,
      label: "Product Series - Digit 2",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 19,
      label: "Product Series - Digit 3",
      group: "productSeries",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productCategory",
      label: "Product Category",
      indexes: [0, 1],
      options: [
        { code: "DW", description: "DWDM" }
      ]
    },
    {
      group: "productSubCategory",
      label: "Product Sub-Category",
      indexes: [2, 3, 4],
      options: [
        { code: "01M", description: "4CH Multiplexer" },
        { code: "01X", description: "4CH Demultiplexer" },
        { code: "02M", description: "8CH Multiplexer" },
        { code: "02X", description: "8CH Demultiplexer" },
        { code: "03M", description: "16CH Multiplexer" },
        { code: "03X", description: "16CH Demultiplexer" },
        { code: "04M", description: "20CH Multiplexer" },
        { code: "04X", description: "20CH Demultiplexer" },
        { code: "05M", description: "40CH Multiplexer" },
        { code: "05X", description: "40CH Demultiplexer" },
        { code: "09M", description: "Other Number of Channels Multiplexer" },
        { code: "09X", description: "Other Number of Channels Demultiplexer" }
      ]
    },
    {
      group: "channelPlan",
      label: "Channel Plan",
      indexes: [6, 7, 8, 9, 10],
      description:
        "DWDM channel plan. First character is C-band or L-band. The next two digits are the longest channel, and the final two digits are the shortest channel. Example: C2720 = C-band, longest channel 27, shortest channel 20."
    },
    {
      group: "customerCode",
      label: "Customer Code",
      indexes: [14, 15, 16],
      description: "3-letter customer code. Only applicable for products not covered by the standard specification."
    },
    {
      group: "productSeries",
      label: "Product Series",
      indexes: [17, 18, 19],
      description: "3-digit product series. Only applicable for products not covered by the standard specification.",
      allowNumeric: true
    }
  ],

  notes: [
    "Standard Fiber Type is ITU-T G657.A2/B2 and G652.D compliant single mode fiber.",
    "Standard package size is 60x35x6mm for 4CH, 70x45x8mm for 8CH, 110x90x8mm for 16CH and 20CH, and 140x95x16mm for 40CH.",
    "Fiber length tolerance is +/-0.1 meter.",
    "All ports use connectors of the same type.",
    "Customer Code and Product Series are only applicable for products not covered by the standard specification."
  ],

  example: {
    code: "DW02XEC2720317",
    description:
      "DWDM 200GHz module, 8CH demultiplexer, C-band channel plan 27 to 20, 900um tight buffer single mode, 1 meter, LC/APC connector."
  }
},

{
  id: "coarse-wavelength-division-multiplexer-cwdm-single-channel",
  familyCode: "C",
  matchPrefix: "CW",
  minLength: 12,
  maxLength: 18,
  productName: "Coarse Wavelength Division Multiplexer (CWDM) Single Channel",
  productPage: "/coarse-wavelength-division-multiplexer-cwdm-single-channel",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FCWDM-1x2-Single-Channel-Datasheet.pdf?alt=media&token=071862a4-fd53-4033-9989-bfa7cda9b837",

  positions: [
    {
      index: 0,
      label: "Product Category - Character 1",
      group: "productCategory",
      required: true,
      options: [{ code: "C", description: "CWDM prefix" }]
    },
    {
      index: 1,
      label: "Product Category - Character 2",
      group: "productCategory",
      required: true,
      options: [{ code: "W", description: "CWDM" }]
    },

    {
      index: 2,
      label: "Sub Family - Character 1",
      group: "subFamily",
      required: true,
      options: [{ code: "9", description: "CWDM single channel sub family prefix" }]
    },
    {
      index: 3,
      label: "Sub Family - Character 2",
      group: "subFamily",
      required: true,
      options: [{ code: "0", description: "CWDM single channel sub family prefix" }]
    },
    {
      index: 4,
      label: "Sub Family - Character 3",
      group: "subFamily",
      required: true,
      options: [
        { code: "D", description: "Drop" },
        { code: "A", description: "Add" }
      ]
    },

    {
      index: 5,
      label: "Channel Spacing",
      required: true,
      options: [
        { code: "9", description: "20nm" }
      ]
    },

    {
      index: 6,
      label: "Pass Channel - Digit 1",
      group: "passChannel",
      required: true,
      options: "0-9"
    },
    {
      index: 7,
      label: "Pass Channel - Digit 2",
      group: "passChannel",
      required: true,
      options: "0-9"
    },
    {
      index: 8,
      label: "Pass Channel - Digit 3",
      group: "passChannel",
      required: true,
      options: "0-9"
    },

    {
      index: 9,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "250um Bare Fiber (Single Mode)" },
        { code: "2", description: "900um Loose Tube White with Single Mode 250um Bare" },
        { code: "3", description: "900um Tight Buffer (Single Mode)" },
        { code: "D", description: "1.2mm Cable (Single Mode)" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },

    {
      index: 10,
      label: "Fiber Length",
      required: true,
      options: [
        { code: "1", description: "1 meter" },
        { code: "2", description: "2 meters" },
        { code: "3", description: "3 meters" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },

    {
      index: 11,
      label: "Connector Type",
      required: true,
      options: [
        { code: "0", description: "No Connector" },
        { code: "1", description: "FC/UPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/UPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/UPC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },

    {
      index: 12,
      label: "Customer Code - Letter 1",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 13,
      label: "Customer Code - Letter 2",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 14,
      label: "Customer Code - Letter 3",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },

    {
      index: 15,
      label: "Product Series - Digit 1",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 16,
      label: "Product Series - Digit 2",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 17,
      label: "Product Series - Digit 3",
      group: "productSeries",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productCategory",
      label: "Product Category",
      indexes: [0, 1],
      options: [
        { code: "CW", description: "CWDM" }
      ]
    },
    {
      group: "subFamily",
      label: "Sub Family",
      indexes: [2, 3, 4],
      options: [
        { code: "90D", description: "Drop" },
        { code: "90A", description: "Add" }
      ]
    },
    {
      group: "passChannel",
      label: "Pass Channel",
      indexes: [6, 7, 8],
      description: "Last 3 digits of CWDM wavelength/channel. Example: 551 = 1551.",
      allowNumeric: true,
      options: [
        { code: "551", description: "1551" }
      ]
    },
    {
      group: "customerCode",
      label: "Customer Code",
      indexes: [12, 13, 14],
      description: "3-letter customer code. Only applicable for products not covered by the standard specification."
    },
    {
      group: "productSeries",
      label: "Product Series",
      indexes: [15, 16, 17],
      description: "3-digit product series. Only applicable for products not covered by the standard specification.",
      allowNumeric: true
    }
  ],

  notes: [
    "Standard Fiber Type is ITU-T G657.A2/B2 and G652.D compliant single mode fiber.",
    "Standard package size is OD5.5mm x L40[49]mm for fiber types 1–3.",
    "For 1.2mm cable, package size is OD3.2mm x L65[75]mm.",
    "Fiber length tolerance is +/-0.1 meter for products with connector termination.",
    "All ports use connectors of the same type.",
    "Customer Code and Product Series are only applicable for products not covered by the standard specification."
  ],

  example: {
    code: "CW90D9551310",
    description:
      "CWDM, 3PM, 20nm, 1551, 900um tight buffer, 1 meter length, no connector on all ports."
  }
},

{
  id: "coarse-wavelength-division-multiplexer-cwdm-multi-channel-cassette",
  familyCode: "C",
  matchPrefix: "CW0",
  minLength: 14,
  maxLength: 20,
  productName: "Coarse Wavelength Division Multiplexer (CWDM) Multi-Channel",
  productPage: "/coarse-wavelength-division-multiplexer-cwdm-multi-channel",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FCWDM-Multi-Channel-Datasheet.pdf?alt=media&token=396e6e9d-6860-4e57-ae14-fa965051b3cf",

  positions: [
    {
      index: 0,
      label: "Product Category - Character 1",
      group: "productCategory",
      required: true,
      options: [{ code: "C", description: "CWDM prefix" }]
    },
    {
      index: 1,
      label: "Product Category - Character 2",
      group: "productCategory",
      required: true,
      options: [{ code: "W", description: "CWDM" }]
    },

    {
      index: 2,
      label: "Product Sub-Category - Character 1",
      group: "productSubCategory",
      required: true,
      options: [{ code: "0", description: "WDM cassette sub-category prefix" }]
    },
    {
      index: 3,
      label: "Product Sub-Category - Character 2",
      group: "productSubCategory",
      required: true,
      options: [
        { code: "1", description: "4CH" },
        { code: "2", description: "8CH" },
        { code: "3", description: "16CH" },
        { code: "4", description: "20CH" },
        { code: "5", description: "40CH" },
        { code: "9", description: "Other number of channels" }
      ]
    },
    {
      index: 4,
      label: "Product Sub-Category - Character 3",
      group: "productSubCategory",
      required: true,
      options: [
        { code: "M", description: "Multiplexer" },
        { code: "X", description: "Demultiplexer" },
        { code: "P", description: "Premium grade channel configuration" }
      ]
    },

    {
      index: 5,
      label: "Channel Spacing",
      required: true,
      options: [{ code: "9", description: "20nm CWDM" }]
    },

    {
      index: 6,
      label: "Channel Plan - Character 1",
      group: "channelPlan",
      required: true,
      options: "0-9"
    },
    {
      index: 7,
      label: "Channel Plan - Character 2",
      group: "channelPlan",
      required: true,
      options: "0-9"
    },
    {
      index: 8,
      label: "Channel Plan - Character 3",
      group: "channelPlan",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "Channel Plan - Character 4",
      group: "channelPlan",
      required: true,
      options: "0-9"
    },

    {
      index: 10,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "250um Bare Fiber (Single Mode)" },
        { code: "2", description: "900um Loose Tube White with Single Mode 250um Bare Fiber Inside" },
        { code: "3", description: "900um Tight Buffer (Single Mode)" },
        { code: "C", description: "2mm Cable (Single Mode)" },
        { code: "D", description: "1.2mm Cable (Single Mode)" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },
    {
      index: 11,
      label: "Fiber Length",
      required: true,
      options: [
        { code: "1", description: "1 meter" },
        { code: "2", description: "2 meters" },
        { code: "3", description: "3 meters" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },
    {
      index: 12,
      label: "Connector Type",
      required: true,
      options: [
        { code: "0", description: "No Connector" },
        { code: "1", description: "FC/UPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/UPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/UPC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },

    {
      index: 13,
      label: "Customer Code - Letter 1",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 14,
      label: "Customer Code - Letter 2",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 15,
      label: "Customer Code - Letter 3",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },

    {
      index: 16,
      label: "Product Series - Digit 1",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 17,
      label: "Product Series - Digit 2",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 18,
      label: "Product Series - Digit 3",
      group: "productSeries",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productCategory",
      label: "Product Category",
      indexes: [0, 1],
      options: [{ code: "CW", description: "CWDM" }]
    },
    {
      group: "productSubCategory",
      label: "Product Sub-Category",
      indexes: [2, 3, 4],
      options: [
        { code: "01M", description: "4CH Multiplexer" },
        { code: "01X", description: "4CH Demultiplexer" },
        { code: "02M", description: "8CH Multiplexer" },
        { code: "02X", description: "8CH Demultiplexer" },
        { code: "03M", description: "16CH Multiplexer" },
        { code: "03X", description: "16CH Demultiplexer" },
        { code: "04M", description: "20CH Multiplexer" },
        { code: "04X", description: "20CH Demultiplexer" },
        { code: "05M", description: "40CH Multiplexer" },
        { code: "05X", description: "40CH Demultiplexer" },
        { code: "09M", description: "Other Number of Channels Multiplexer" },
        { code: "09X", description: "Other Number of Channels Demultiplexer" }
      ]
    },
    {
      group: "channelPlan",
      label: "Channel Plan",
      indexes: [6, 7, 8, 9],
      description:
        "For CWDM, first two digits are the shortest wavelength and final two digits are the longest wavelength. Example: 4761 = 1471 to 1611.",
      allowNumeric: true,
      options: [
        { code: "4761", description: "CWDM channel plan, 1471 to 1611" }
      ]
    },
    {
      group: "customerCode",
      label: "Customer Code",
      indexes: [13, 14, 15],
      description: "3-letter customer code. Only applicable for products not covered by the standard specification."
    },
    {
      group: "productSeries",
      label: "Product Series",
      indexes: [16, 17, 18],
      description: "3-digit product series. Only applicable for products not covered by the standard specification.",
      allowNumeric: true
    }
  ],

  notes: [
    "WDM in Cassette configuration.",
    "Standard Fiber Type is ITU-T G657.A2/B2 and G652.D.",
    "Standard package size is 60x35x6mm for 4CH, 70x45x8mm for 8CH, 110x90x8mm for 16CH and 20CH, and 140x95x16mm for 40CH.",
    "Fiber length tolerance is +/-0.1 meter.",
    "All ports use connectors of the same type.",
    "Customer Code and Product Series are only applicable for products not covered by the standard specification."
  ],

  example: {
    code: "CW02X94761317",
    description:
      "CWDM cassette, 8CH demultiplexer, 20nm spacing, 1471 to 1611 channel plan, 900um tight buffer single mode, 1 meter, LC/APC connector."
  }
},

{
  id: "coarse-wavelength-division-multiplexer-cwdm-multi-channel-enclosure",
  familyCode: "C",
  matchPrefix: "CWL",
  minLength: 11,
  maxLength: 17,
  productName: "Coarse Wavelength Division Multiplexer (CWDM) Multi-Channel",
  productPage: "/coarse-wavelength-division-multiplexer-cwdm-multi-channel",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FCWDM-Multi-Channel-Datasheet.pdf?alt=media&token=396e6e9d-6860-4e57-ae14-fa965051b3cf",

  positions: [
    {
      index: 0,
      label: "Product Category - Character 1",
      group: "productCategory",
      required: true,
      options: [{ code: "C", description: "CWDM prefix" }]
    },
    {
      index: 1,
      label: "Product Category - Character 2",
      group: "productCategory",
      required: true,
      options: [{ code: "W", description: "CWDM" }]
    },

    {
      index: 2,
      label: "Enclosure Type - Character 1",
      group: "enclosureType",
      required: true,
      options: [
        { code: "L", description: "LGX prefix" },
        { code: "C", description: "CUS/CGM prefix" },
        { code: "B", description: "Basket prefix" }
      ]
    },
    {
      index: 3,
      label: "Enclosure Type - Character 2",
      group: "enclosureType",
      required: true,
      options: [
        { code: "G", description: "LGX/CGM" },
        { code: "U", description: "CUS" },
        { code: "S", description: "Basket" }
      ]
    },
    {
      index: 4,
      label: "Enclosure Type - Character 3",
      group: "enclosureType",
      required: true,
      options: [
        { code: "X", description: "LGX" },
        { code: "S", description: "CUS" },
        { code: "M", description: "CGM" },
        { code: "K", description: "Basket" }
      ]
    },

    {
      index: 5,
      label: "Channel Spacing",
      required: true,
      options: [{ code: "9", description: "20nm CWDM" }]
    },

    {
      index: 6,
      label: "Channel Plan - Character 1",
      group: "channelPlan",
      required: true,
      options: "0-9"
    },
    {
      index: 7,
      label: "Channel Plan - Character 2",
      group: "channelPlan",
      required: true,
      options: "0-9"
    },
    {
      index: 8,
      label: "Channel Plan - Character 3",
      group: "channelPlan",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "Channel Plan - Character 4",
      group: "channelPlan",
      required: true,
      options: "0-9"
    },

    {
      index: 10,
      label: "Adapter Type",
      required: true,
      options: [
        { code: "1", description: "LC/UPC; Blue Duplex Adapter" },
        { code: "2", description: "LC/APC; Green Duplex Adapter" },
        { code: "3", description: "SC/UPC; Blue Simplex Adapter" },
        { code: "4", description: "SC/APC; Green Simplex Adapter" },
        { code: "5", description: "LC/UPC; Blue Simplex Adapter" },
        { code: "6", description: "LC/APC; Green Simplex Adapter" },
        { code: "P", description: "Others" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },

    {
      index: 11,
      label: "Customer Code - Letter 1",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 12,
      label: "Customer Code - Letter 2",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 13,
      label: "Customer Code - Letter 3",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },

    {
      index: 14,
      label: "Product Series - Digit 1",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 15,
      label: "Product Series - Digit 2",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 16,
      label: "Product Series - Digit 3",
      group: "productSeries",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productCategory",
      label: "Product Category",
      indexes: [0, 1],
      options: [{ code: "CW", description: "CWDM" }]
    },
    {
      group: "enclosureType",
      label: "Enclosure Type",
      indexes: [2, 3, 4],
      options: [
        { code: "LGX", description: "LGX" },
        { code: "CUS", description: "Custom" },
        { code: "CGM", description: "CGM" },
        { code: "BSK", description: "Basket" }
      ]
    },
    {
      group: "channelPlan",
      label: "Channel Plan",
      indexes: [6, 7, 8, 9],
      description:
        "For CWDM, first two digits are the shortest wavelength and final two digits are the longest wavelength. Example: 4761 = 1471 to 1611.",
      allowNumeric: true,
      options: [
        { code: "4761", description: "CWDM channel plan, 1471 to 1611" }
      ]
    },
    {
      group: "customerCode",
      label: "Customer Code",
      indexes: [11, 12, 13],
      description: "3-letter customer code. Only applicable for products not covered by the standard specification."
    },
    {
      group: "productSeries",
      label: "Product Series",
      indexes: [14, 15, 16],
      description: "3-digit product series. Only applicable for products not covered by the standard specification.",
      allowNumeric: true
    }
  ],

  notes: [
    "WDM in Enclosure configuration.",
    "Standard package size is 1 slot for 4CH and 8CH, 2 slots for 16CH and 20CH, and 3 slots for 40CH.",
    "All ports use connectors and adapters of the same type.",
    "Customer Code and Product Series are only applicable for products not covered by the standard specification.",
    "Channel plan may vary depending on customer request."
  ],

  example: {
    code: "CWLGX947614",
    description:
      "CWDM module with channels 1471 to 1611, SC/APC, SC green simplex adapter."
  }
},

{
  id: "thin-film-filter-tff-tap-coupler-single-mode",
  familyCode: "T",
  matchPrefix: "TC",
  minLength: 9,
  maxLength: 15,
  productName: "Thin Film Filter (TFF) Tap Coupler Single Mode",
  productPage: "/thin-film-filter-tff-tap-coupler-single-mode",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FTFF-1x2-Tap-Coupler-SM-Datasheet-1.pdf?alt=media&token=563c1ae4-7949-4f06-992e-a3ec7d4e7d46",

  positions: [
    {
      index: 0,
      label: "Product Category - Character 1",
      group: "productCategory",
      required: true,
      options: [{ code: "T", description: "TAPC prefix" }]
    },
    {
      index: 1,
      label: "Product Category - Character 2",
      group: "productCategory",
      required: true,
      options: [{ code: "C", description: "TAPC" }]
    },

    {
      index: 2,
      label: "Transmission Tap Ratio - Character 1",
      group: "transmissionTapRatio",
      required: true,
      options: [
        { code: "9", description: "TAP 90%" },
        { code: "7", description: "TAP 70%" },
        { code: "5", description: "TAP 50%" },
        { code: "3", description: "TAP 30%" },
        { code: "1", description: "TAP 10%" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },
    {
      index: 3,
      label: "Transmission Tap Ratio - Character 2",
      group: "transmissionTapRatio",
      required: true,
      options: [
        { code: "0", description: "TAP ratio ending digit" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },

    {
      index: 4,
      label: "Operating Wavelength Range - Character 1",
      group: "operatingWavelengthRange",
      required: true,
      options: [
        { code: "S", description: "Single Window" },
        { code: "D", description: "Dual Window" },
        { code: "F", description: "Full band" }
      ]
    },
    {
      index: 5,
      label: "Operating Wavelength Range - Character 2",
      group: "operatingWavelengthRange",
      required: true,
      options: [
        { code: "1", description: "Single Window 1310 ± 40nm" },
        { code: "2", description: "Single Window 1550 ± 40nm" },
        { code: "W", description: "Dual Window or Full band" }
      ]
    },

    {
      index: 6,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "250um Bare Fiber (Single Mode)" },
        { code: "2", description: "900um Loose Tube White with Single Mode 250um Bare Fiber Inside" },
        { code: "3", description: "900um Tight Buffer (Single Mode)" },
        { code: "D", description: "1.2mm Cable (Single Mode)" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },

    {
      index: 7,
      label: "Fiber Length",
      required: true,
      options: [
        { code: "1", description: "1 meter" },
        { code: "2", description: "2 meters" },
        { code: "3", description: "3 meters" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },

    {
      index: 8,
      label: "Connector Type",
      required: true,
      options: [
        { code: "0", description: "No Connector" },
        { code: "1", description: "FC/UPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/UPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/UPC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },

    {
      index: 9,
      label: "Customer Code - Letter 1",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 10,
      label: "Customer Code - Letter 2",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 11,
      label: "Customer Code - Letter 3",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },

    {
      index: 12,
      label: "Product Series - Digit 1",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 13,
      label: "Product Series - Digit 2",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 14,
      label: "Product Series - Digit 3",
      group: "productSeries",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productCategory",
      label: "Product Category",
      indexes: [0, 1],
      options: [
        { code: "TC", description: "TAPC" }
      ]
    },
    {
      group: "transmissionTapRatio",
      label: "Transmission Tap Ratio",
      indexes: [2, 3],
      options: [
        { code: "90", description: "TAP 90%" },
        { code: "70", description: "TAP 70%" },
        { code: "50", description: "TAP 50%" },
        { code: "30", description: "TAP 30%" },
        { code: "10", description: "TAP 10%" },
        { code: "XX", description: "Special or as specified by Customer" }
      ]
    },
    {
      group: "operatingWavelengthRange",
      label: "Operating Wavelength Range",
      indexes: [4, 5],
      options: [
        { code: "S1", description: "Single Window 1310 ± 40nm" },
        { code: "S2", description: "Single Window 1550 ± 40nm" },
        { code: "DW", description: "Dual Window 1310 ± 40nm, 1550 ± 40nm" },
        { code: "FW", description: "Full band 1260–1625nm" }
      ]
    },
    {
      group: "customerCode",
      label: "Customer Code",
      indexes: [9, 10, 11],
      description: "3-letter customer code. Only applicable for products not covered by the standard specification."
    },
    {
      group: "productSeries",
      label: "Product Series",
      indexes: [12, 13, 14],
      description: "3-digit product series. Only applicable for products not covered by the standard specification.",
      allowNumeric: true
    }
  ],

  notes: [
    "Standard Fiber Type is ITU-T G657.A2/B2 and G652.D compliant single mode fiber.",
    "Standard package size is OD5.5mm x L40[49]mm for fiber type 1–3.",
    "For 1.2mm cable, package size is OD3.2mm x L65[75]mm.",
    "Fiber length tolerance is +/-0.1 meter for products with connector termination.",
    "All ports use connectors of the same type.",
    "Customer Code and Product Series are only applicable for products not covered by the standard specification."
  ],

  example: {
    code: "TC50FW110",
    description:
      "TAP Coupler, 50%, full band, 250um bare fiber, 1 meter length, no connector on all ports."
  }
},

{
  id: "dual-window-fused-tap-coupler-fbt",
  familyCode: "F",
  matchPrefix: "FTC",
  minLength: 11,
  maxLength: 17,
  productName: "Dual Window Fused Tap Coupler (FBT)",
  productPage: "/dual-window-fused-tap-coupler-fbt",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FDual-Window-Fused-Tap-Coupler-Datasheet.pdf?alt=media&token=dd2d7976-8c25-4ce2-b806-2b54cd3b9992",

  positions: [
    {
      index: 0,
      label: "Product Category - Character 1",
      group: "productCategory",
      required: true,
      options: [{ code: "F", description: "Fused Tap Coupler prefix" }]
    },
    {
      index: 1,
      label: "Product Category - Character 2",
      group: "productCategory",
      required: true,
      options: [{ code: "T", description: "Fused Tap Coupler prefix" }]
    },
    {
      index: 2,
      label: "Product Category - Character 3",
      group: "productCategory",
      required: true,
      options: [{ code: "C", description: "Fused Tap Coupler" }]
    },

    {
      index: 3,
      label: "Operating Wavelength",
      required: true,
      options: [
        { code: "D", description: "Dual Wavelength, 1310±40nm and 1550±40nm" }
      ]
    },

    {
      index: 4,
      label: "Grade Type",
      required: true,
      options: [
        { code: "P", description: "Premium" },
        { code: "A", description: "Grade A" }
      ]
    },

    {
      index: 5,
      label: "Configuration",
      required: true,
      options: [
        { code: "1", description: "1x2" },
        { code: "2", description: "2x2" }
      ]
    },

    {
      index: 6,
      label: "Coupling Ratio - Character 1",
      group: "couplingRatio",
      required: true,
      options: "0-9"
    },
    {
      index: 7,
      label: "Coupling Ratio - Character 2",
      group: "couplingRatio",
      required: true,
      options: "0-9"
    },

    {
      index: 8,
      label: "Package Type",
      required: true,
      options: [
        { code: "1", description: "250um Single Mode Fiber" },
        { code: "2", description: "900um Loose Tube White with 250um Single Mode Fiber" },
        { code: "X", description: "Special or specified by customer" }
      ]
    },

    {
      index: 9,
      label: "Fiber Length",
      required: true,
      options: [
        { code: "1", description: "1 meter" },
        { code: "2", description: "2 meters" },
        { code: "3", description: "3 meters" },
        { code: "X", description: "Special or specified by customer" }
      ]
    },

    {
      index: 10,
      label: "Connectors",
      required: true,
      options: [
        { code: "0", description: "None" },
        { code: "1", description: "FC/UPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/UPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/UPC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" },
        { code: "X", description: "Special or as specified by customer" }
      ]
    },

    {
      index: 11,
      label: "Customer Code - Letter 1",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 12,
      label: "Customer Code - Letter 2",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 13,
      label: "Customer Code - Letter 3",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },

    {
      index: 14,
      label: "Product Series - Digit 1",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 15,
      label: "Product Series - Digit 2",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 16,
      label: "Product Series - Digit 3",
      group: "productSeries",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productCategory",
      label: "Product Category",
      indexes: [0, 1, 2],
      options: [
        { code: "FTC", description: "Fused Tap Coupler" }
      ]
    },
    {
      group: "couplingRatio",
      label: "Coupling Ratio",
      indexes: [6, 7],
      options: [
        { code: "50", description: "50/50" },
        { code: "40", description: "60/40" },
        { code: "30", description: "70/30" },
        { code: "20", description: "80/20" },
        { code: "10", description: "90/10" },
        { code: "05", description: "95/5" },
        { code: "02", description: "98/2" },
        { code: "01", description: "99/1" }
      ]
    },
    {
      group: "customerCode",
      label: "Customer Code",
      indexes: [11, 12, 13],
      description: "3-letter customer code. Only applicable for products not covered by the standard specification."
    },
    {
      group: "productSeries",
      label: "Product Series",
      indexes: [14, 15, 16],
      description: "3-digit product series. Only applicable for products not covered by the standard specification.",
      allowNumeric: true
    }
  ],

  notes: [
    "Mechanical fiber length tolerance is ±0.1 meters.",
    "All ports use connectors of the same type.",
    "Customer Code and Product Series are only applicable for products not covered by standard specifications."
  ],

  example: {
    code: "FTCDP150115",
    description:
      "Fused Tap Coupler, dual window, premium grade, 1x2 configuration, 50/50 coupling ratio, 250um single mode bare fiber, 1 meter, LC/UPC termination."
  }
},

{
  id: "single-window-fused-tap-coupler-fbt",
  familyCode: "F",
  matchPrefix: "FTC",
  minLength: 12,
  maxLength: 18,
  productName: "Single Window Fused Tap Coupler (FBT)",
  productPage: "/single-window-fused-tap-coupler-fbt",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FSingle-Window-Fused-Tap-Coupler-Datasheet.pdf?alt=media&token=89cf430e-9e4e-4170-8d73-dc60e4931355",

  positions: [
    {
      index: 0,
      label: "Product Category - Character 1",
      group: "productCategory",
      required: true,
      options: [{ code: "F", description: "Fused Tap Coupler prefix" }]
    },
    {
      index: 1,
      label: "Product Category - Character 2",
      group: "productCategory",
      required: true,
      options: [{ code: "T", description: "Fused Tap Coupler prefix" }]
    },
    {
      index: 2,
      label: "Product Category - Character 3",
      group: "productCategory",
      required: true,
      options: [{ code: "C", description: "Fused Tap Coupler" }]
    },

    {
      index: 3,
      label: "Operating Wavelength - Character 1",
      group: "operatingWavelength",
      required: true,
      options: [
        { code: "S", description: "Single Window" },
        { code: "X", description: "Special or specified by customer" }
      ]
    },
    {
      index: 4,
      label: "Operating Wavelength - Character 2",
      group: "operatingWavelength",
      required: true,
      options: [
        { code: "1", description: "1310±40nm" },
        { code: "2", description: "1550±40nm" },
        { code: "X", description: "Special or specified by customer" }
      ]
    },

    {
      index: 5,
      label: "Grade Type",
      required: true,
      options: [
        { code: "P", description: "Premium" },
        { code: "A", description: "Grade A" }
      ]
    },

    {
      index: 6,
      label: "Configuration",
      required: true,
      options: [
        { code: "1", description: "1x2" },
        { code: "2", description: "2x2" }
      ]
    },

    {
      index: 7,
      label: "Coupling Ratio - Character 1",
      group: "couplingRatio",
      required: true,
      options: "0-9"
    },
    {
      index: 8,
      label: "Coupling Ratio - Character 2",
      group: "couplingRatio",
      required: true,
      options: "0-9"
    },

    {
      index: 9,
      label: "Package Type",
      required: true,
      options: [
        { code: "1", description: "250um Single Mode Bare Fiber" },
        { code: "2", description: "900um Loose Tube White with 250um Single Mode Fiber" },
        { code: "X", description: "Special or specified by customer" }
      ]
    },

    {
      index: 10,
      label: "Fiber Length",
      required: true,
      options: [
        { code: "1", description: "1 meter" },
        { code: "2", description: "2 meters" },
        { code: "3", description: "3 meters" },
        { code: "X", description: "Special or specified by customer" }
      ]
    },

    {
      index: 11,
      label: "Connectors",
      required: true,
      options: [
        { code: "0", description: "None" },
        { code: "1", description: "FC/UPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/UPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/UPC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" },
        { code: "X", description: "Special or as specified by customer" }
      ]
    },

    {
      index: 12,
      label: "Customer Code - Letter 1",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 13,
      label: "Customer Code - Letter 2",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 14,
      label: "Customer Code - Letter 3",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },

    {
      index: 15,
      label: "Product Series - Digit 1",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 16,
      label: "Product Series - Digit 2",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 17,
      label: "Product Series - Digit 3",
      group: "productSeries",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productCategory",
      label: "Product Category",
      indexes: [0, 1, 2],
      options: [
        { code: "FTC", description: "Fused Tap Coupler" }
      ]
    },
    {
      group: "operatingWavelength",
      label: "Operating Wavelength",
      indexes: [3, 4],
      options: [
        { code: "S1", description: "1310±40nm" },
        { code: "S2", description: "1550±40nm" },
        { code: "XX", description: "Special or specified by customer" }
      ]
    },
    {
      group: "couplingRatio",
      label: "Coupling Ratio",
      indexes: [7, 8],
      options: [
        { code: "50", description: "50/50" },
        { code: "40", description: "60/40" },
        { code: "30", description: "70/30" },
        { code: "20", description: "80/20" },
        { code: "10", description: "90/10" },
        { code: "05", description: "95/5" },
        { code: "02", description: "98/2" },
        { code: "01", description: "99/1" }
      ]
    },
    {
      group: "customerCode",
      label: "Customer Code",
      indexes: [12, 13, 14],
      description: "3-letter customer code. Only applicable for products not covered by standard specifications."
    },
    {
      group: "productSeries",
      label: "Product Series",
      indexes: [15, 16, 17],
      description: "3-digit product series. Only applicable for products not covered by standard specifications.",
      allowNumeric: true
    }
  ],

  notes: [
    "Mechanical fiber length tolerance is ±0.1 meters.",
    "All ports use connectors of the same type.",
    "Customer Code and Product Series are only applicable for products not covered by standard specifications."
  ],

  example: {
    code: "FTCS2P110112",
    description:
      "Fused Tap Coupler, single window at 1550nm, premium grade, 1x2 configuration, 90/10 coupling ratio, 250um single mode bare fiber, 1 meter, FC/APC termination."
  }
},
{
  id: "dwdm-optical-add-drop-module-oadm-100ghz-spacing",
  familyCode: "D",
  matchPrefix: "DW",
  minLength: 13,
  maxLength: 19,
  productName: "DWDM Optical Add-Drop Module (OADM) 100GHz Spacing",
  productPage: "/dwdm-optical-add-drop-module-oadm-100ghz-spacing",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FDWDM-100G-Spacing-OADM-Datasheet-1-1.pdf?alt=media&token=c952c1a2-d9ac-4599-96d7-10feb49128c0",

  positions: [
    {
      index: 0,
      label: "Product Category - Character 1",
      group: "productCategory",
      required: true,
      options: [{ code: "D", description: "DWDM prefix" }]
    },
    {
      index: 1,
      label: "Product Category - Character 2",
      group: "productCategory",
      required: true,
      options: [{ code: "W", description: "DWDM" }]
    },
    {
      index: 2,
      label: "Sub Family - Digit 1",
      group: "subFamily",
      required: true,
      options: [{ code: "1", description: "OADM prefix" }]
    },
    {
      index: 3,
      label: "Sub Family - Digit 2",
      group: "subFamily",
      required: true,
      options: [
        { code: "1", description: "1-Channel OADM" },
        { code: "2", description: "2-Channel OADM" },
        { code: "3", description: "3-Channel OADM" },
        { code: "4", description: "4-Channel OADM" }
      ]
    },
    {
      index: 4,
      label: "Sub Family - Digit 3",
      group: "subFamily",
      required: true,
      options: [{ code: "0", description: "OADM suffix" }]
    },

    {
      index: 5,
      label: "Channel Spacing",
      required: true,
      options: [
        { code: "D", description: "100GHz DWDM" }
      ]
    },

    {
      index: 6,
      label: "Wavelength - Digit 1",
      group: "wavelength",
      required: true,
      options: "0-9"
    },
    {
      index: 7,
      label: "Wavelength - Digit 2",
      group: "wavelength",
      required: true,
      options: "0-9"
    },
    {
      index: 8,
      label: "Wavelength - Digit 3",
      group: "wavelength",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "Wavelength - Digit 4",
      group: "wavelength",
      required: true,
      options: "0-9"
    },

    {
      index: 10,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "250um Bare Fiber (Single Mode)" },
        { code: "2", description: "900um Loose Tube White with Single Mode 250um Bare Fiber Inside" },
        { code: "3", description: "900um Tight Buffer (Single Mode)" },
        { code: "C", description: "2mm Cable (Single Mode)" },
        { code: "D", description: "1.2mm Cable (Single Mode)" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },
    {
      index: 11,
      label: "Fiber Length",
      required: true,
      options: [
        { code: "1", description: "1 meter" },
        { code: "2", description: "2 meters" },
        { code: "3", description: "3 meters" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },
    {
      index: 12,
      label: "Connector Type",
      required: true,
      options: [
        { code: "0", description: "No Connector" },
        { code: "1", description: "FC/UPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/UPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/UPC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },

    {
      index: 13,
      label: "Customer Code - Letter 1",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 14,
      label: "Customer Code - Letter 2",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 15,
      label: "Customer Code - Letter 3",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },

    {
      index: 16,
      label: "Product Series - Digit 1",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 17,
      label: "Product Series - Digit 2",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 18,
      label: "Product Series - Digit 3",
      group: "productSeries",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productCategory",
      label: "Product Category",
      indexes: [0, 1],
      options: [
        { code: "DW", description: "DWDM" }
      ]
    },
    {
      group: "subFamily",
      label: "Sub Family",
      indexes: [2, 3, 4],
      options: [
        { code: "110", description: "1-Channel OADM" },
        { code: "120", description: "2-Channel OADM" },
        { code: "130", description: "3-Channel OADM" },
        { code: "140", description: "4-Channel OADM" }
      ]
    },
    {
      group: "wavelength",
      label: "Wavelength",
      indexes: [6, 7, 8, 9],
      description:
        "4 numeric digits. For DWDM, xx is the longest channel and yy is the shortest channel. Example: 4131."
    },
    {
      group: "customerCode",
      label: "Customer Code",
      indexes: [13, 14, 15],
      description: "3-letter customer code. Only applicable for products not covered by the standard specification."
    },
    {
      group: "productSeries",
      label: "Product Series",
      indexes: [16, 17, 18],
      description: "3-digit product series. Only applicable for products not covered by the standard specification.",
      allowNumeric: true
    }
  ],

  notes: [
    "Standard Fiber Type is ITU-T G657.A2/B2 and G652.D.",
    "Standard package size is 60x35x6mm for 1-channel OADM and 70x45x8mm for 2-channel OADM.",
    "Fiber length tolerance is +/-0.1 meter.",
    "All ports use connectors of the same type.",
    "Customer Code and Product Series are only applicable for products not covered by the standard specification."
  ],

  example: {
    code: "DW110D4131315",
    description:
      "1-Channel DWDM OADM, 100GHz spacing, wavelength/channel range 4131, one meter 900um tight buffer with LC/UPC connectors."
  }
},

{
  id: "dwdm-optical-add-drop-module-oadm-200ghz-spacing",
  familyCode: "D",
  matchPrefix: "DW",
  minLength: 13,
  maxLength: 19,
  productName: "DWDM Optical Add-Drop Module (OADM) 200GHz Spacing",
  productPage: "/dwdm-optical-add-drop-module-oadm-200ghz-spacing",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FDWDM-200G-Spacing-OADM-Datasheet.pdf?alt=media&token=3081b7d2-e36c-4a52-849f-9b4f4dedb8ea",

  positions: [
    {
      index: 0,
      label: "Product Category - Character 1",
      group: "productCategory",
      required: true,
      options: [{ code: "D", description: "DWDM prefix" }]
    },
    {
      index: 1,
      label: "Product Category - Character 2",
      group: "productCategory",
      required: true,
      options: [{ code: "W", description: "DWDM" }]
    },
    {
      index: 2,
      label: "Sub Family - Digit 1",
      group: "subFamily",
      required: true,
      options: [{ code: "1", description: "OADM prefix" }]
    },
    {
      index: 3,
      label: "Sub Family - Digit 2",
      group: "subFamily",
      required: true,
      options: [
        { code: "1", description: "1-Channel OADM" },
        { code: "2", description: "2-Channel OADM" },
        { code: "3", description: "3-Channel OADM" },
        { code: "4", description: "4-Channel OADM" }
      ]
    },
    {
      index: 4,
      label: "Sub Family - Digit 3",
      group: "subFamily",
      required: true,
      options: [{ code: "0", description: "OADM suffix" }]
    },

    {
      index: 5,
      label: "Channel Spacing",
      required: true,
      options: [
        { code: "E", description: "200GHz DWDM" }
      ]
    },

    {
      index: 6,
      label: "Wavelength - Digit 1",
      group: "wavelength",
      required: true,
      options: "0-9"
    },
    {
      index: 7,
      label: "Wavelength - Digit 2",
      group: "wavelength",
      required: true,
      options: "0-9"
    },
    {
      index: 8,
      label: "Wavelength - Digit 3",
      group: "wavelength",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "Wavelength - Digit 4",
      group: "wavelength",
      required: true,
      options: "0-9"
    },

    {
      index: 10,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "250um Bare Fiber (Single Mode)" },
        { code: "2", description: "900um Loose Tube White with Single Mode 250um Bare Fiber Inside" },
        { code: "3", description: "900um Tight Buffer (Single Mode)" },
        { code: "C", description: "2mm Cable (Single Mode)" },
        { code: "D", description: "1.2mm Cable (Single Mode)" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },
    {
      index: 11,
      label: "Fiber Length",
      required: true,
      options: [
        { code: "1", description: "1 meter" },
        { code: "2", description: "2 meters" },
        { code: "3", description: "3 meters" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },
    {
      index: 12,
      label: "Connector Type",
      required: true,
      options: [
        { code: "0", description: "No Connector" },
        { code: "1", description: "FC/UPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/UPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/UPC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },

    {
      index: 13,
      label: "Customer Code - Letter 1",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 14,
      label: "Customer Code - Letter 2",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 15,
      label: "Customer Code - Letter 3",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },

    {
      index: 16,
      label: "Product Series - Digit 1",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 17,
      label: "Product Series - Digit 2",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 18,
      label: "Product Series - Digit 3",
      group: "productSeries",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productCategory",
      label: "Product Category",
      indexes: [0, 1],
      options: [
        { code: "DW", description: "DWDM" }
      ]
    },
    {
      group: "subFamily",
      label: "Sub Family",
      indexes: [2, 3, 4],
      options: [
        { code: "110", description: "1-Channel OADM" },
        { code: "120", description: "2-Channel OADM" },
        { code: "130", description: "3-Channel OADM" },
        { code: "140", description: "4-Channel OADM" }
      ]
    },
    {
      group: "wavelength",
      label: "Wavelength",
      indexes: [6, 7, 8, 9],
      description:
        "4 numeric digits. For DWDM, xx is the longest channel and yy is the shortest channel. Example: 3332."
    },
    {
      group: "customerCode",
      label: "Customer Code",
      indexes: [13, 14, 15],
      description: "3-letter customer code. Only applicable for products not covered by the standard specification."
    },
    {
      group: "productSeries",
      label: "Product Series",
      indexes: [16, 17, 18],
      description: "3-digit product series. Only applicable for products not covered by the standard specification.",
      allowNumeric: true
    }
  ],

  notes: [
    "Standard Fiber Type is ITU-T G657.A2/B2 and G652.D.",
    "Standard package size is 60x35x6mm for 1-channel OADM and 70x45x8mm for 2-channel OADM.",
    "Fiber length tolerance is +/-0.1 meter.",
    "All ports use connectors of the same type.",
    "Customer Code and Product Series are only applicable for products not covered by the standard specification."
  ],

  example: {
    code: "DW110E3332D32",
    description:
      "1-Channel DWDM OADM, 200GHz spacing, wavelength/channel range 3332, three meter 1.2mm cable single mode with FC/APC connectors."
  }
},

{
  id: "cwdm-optical-add-drop-multiplexer-oadm",
  familyCode: "C",
  matchPrefix: "CW",
  minLength: 12,
  maxLength: 18,
  productName: "CWDM Optical Add-Drop Multiplexer (OADM)",
  productPage: "/cwdm-optical-add-drop-multiplexer-oadm",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FCWDM-OADM-Datasheet.pdf?alt=media&token=32b419cb-4c55-4391-82ef-29025804e93d",

  positions: [
    {
      index: 0,
      label: "Product Category - Character 1",
      group: "productCategory",
      required: true,
      options: [{ code: "C", description: "CWDM prefix" }]
    },
    {
      index: 1,
      label: "Product Category - Character 2",
      group: "productCategory",
      required: true,
      options: [{ code: "W", description: "CWDM" }]
    },

    {
      index: 2,
      label: "Sub Family - Digit 1",
      group: "subFamily",
      required: true,
      options: [{ code: "1", description: "OADM prefix" }]
    },
    {
      index: 3,
      label: "Sub Family - Digit 2",
      group: "subFamily",
      required: true,
      options: [
        { code: "1", description: "1-Channel OADM" },
        { code: "2", description: "2-Channel OADM" },
        { code: "3", description: "3-Channel OADM" },
        { code: "4", description: "4-Channel OADM" }
      ]
    },
    {
      index: 4,
      label: "Sub Family - Digit 3",
      group: "subFamily",
      required: true,
      options: [{ code: "0", description: "OADM suffix" }]
    },

    {
      index: 5,
      label: "Channel Spacing",
      required: true,
      options: [
        { code: "9", description: "20nm CWDM" }
      ]
    },

    {
      index: 6,
      label: "Wavelength - Digit 1",
      group: "wavelength",
      required: true,
      options: "0-9"
    },
    {
      index: 7,
      label: "Wavelength - Digit 2",
      group: "wavelength",
      required: true,
      options: "0-9"
    },
    {
      index: 8,
      label: "Wavelength - Digit 3",
      group: "wavelength",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "Wavelength - Digit 4",
      group: "wavelength",
      required: true,
      options: "0-9"
    },

    {
      index: 10,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "250um Bare Fiber (Single Mode)" },
        { code: "2", description: "900um Loose Tube White with Single Mode 250um Bare Fiber Inside" },
        { code: "3", description: "900um Tight Buffer (Single Mode)" },
        { code: "C", description: "2mm Cable (Single Mode)" },
        { code: "D", description: "1.2mm Cable (Single Mode)" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },

    {
      index: 11,
      label: "Fiber Length",
      required: true,
      options: [
        { code: "1", description: "1 meter" },
        { code: "2", description: "2 meters" },
        { code: "3", description: "3 meters" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },

    {
      index: 12,
      label: "Connector Type",
      required: true,
      options: [
        { code: "0", description: "No Connector" },
        { code: "1", description: "FC/UPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/UPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/UPC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" },
        { code: "X", description: "Special or as specified by Customer" }
      ]
    },

    {
      index: 13,
      label: "Customer Code - Letter 1",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 14,
      label: "Customer Code - Letter 2",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 15,
      label: "Customer Code - Letter 3",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },

    {
      index: 16,
      label: "Product Series - Digit 1",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 17,
      label: "Product Series - Digit 2",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 18,
      label: "Product Series - Digit 3",
      group: "productSeries",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productCategory",
      label: "Product Category",
      indexes: [0, 1],
      options: [
        { code: "CW", description: "CWDM" }
      ]
    },
    {
      group: "subFamily",
      label: "Sub Family",
      indexes: [2, 3, 4],
      options: [
        { code: "110", description: "1-Channel OADM" },
        { code: "120", description: "2-Channel OADM" },
        { code: "130", description: "3-Channel OADM" },
        { code: "140", description: "4-Channel OADM" }
      ]
    },
    {
      group: "wavelength",
      label: "Wavelength",
      indexes: [6, 7, 8, 9],
      description:
        "For CWDM, first two digits are the shortest wavelength and final two digits are the longest wavelength. Example: 4753 = 1471 to 1531.",
      allowNumeric: true,
      options: [
        { code: "4753", description: "1471 to 1531" },
        { code: "4761", description: "1471 to 1611" }
      ]
    },
    {
      group: "customerCode",
      label: "Customer Code",
      indexes: [13, 14, 15],
      description: "3-letter customer code. Only applicable for products not covered by the standard specification."
    },
    {
      group: "productSeries",
      label: "Product Series",
      indexes: [16, 17, 18],
      description: "3-digit product series. Only applicable for products not covered by the standard specification.",
      allowNumeric: true
    }
  ],

  notes: [
    "Standard Fiber Type is ITU-T G657.A2/B2 and G652.D.",
    "Standard package size is 60x35x6mm for 1-channel OADM and 70x45x8mm for 2-channel OADM.",
    "Fiber length tolerance is +/-0.1 meter.",
    "All ports use connectors of the same type.",
    "Customer Code and Product Series are only applicable for products not covered by the standard specification."
  ],

  example: {
    code: "CW14094753324",
    description:
      "4-Channel CWDM OADM, 1471 to 1531, two meter 900um tight buffer with SC/APC connectors."
  }
},

{
  id: "tec-fiber-thermally-expanded-core",
  familyCode: "T",
  matchPrefix: "TECF",
  minLength: 12,
  maxLength: 18,
  productName: "TEC Fiber (Thermally Expanded Core)",
  productPage: "/tec-fiber-thermally-expanded-core",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FTEC-Fiber-Datasheet.pdf?alt=media&token=4d254013-79ed-49ae-9e7a-c141fb5ef72a",

  positions: [
    {
      index: 0,
      label: "Product Category - Character 1",
      group: "productCategory",
      required: true,
      options: [{ code: "T", description: "Thermally Expanded Core Fiber prefix" }]
    },
    {
      index: 1,
      label: "Product Category - Character 2",
      group: "productCategory",
      required: true,
      options: [{ code: "E", description: "Thermally Expanded Core Fiber prefix" }]
    },
    {
      index: 2,
      label: "Product Category - Character 3",
      group: "productCategory",
      required: true,
      options: [{ code: "C", description: "Thermally Expanded Core Fiber prefix" }]
    },
    {
      index: 3,
      label: "Product Category - Character 4",
      group: "productCategory",
      required: true,
      options: [{ code: "F", description: "Thermally Expanded Core Fiber" }]
    },

    {
      index: 4,
      label: "Package Type",
      required: true,
      options: [
        { code: "A", description: "Bare Fiber Package, Cleaved" },
        { code: "B", description: "Φ 1.8mm Glass Capillary Packaged" },
        { code: "C", description: "Φ 2.5mm Ceramic Ferrule with Flange Packaged" }
      ]
    },

    {
      index: 5,
      label: "Mode Field Diameter - Digit 1",
      group: "modeFieldDiameter",
      required: true,
      options: "0-9"
    },
    {
      index: 6,
      label: "Mode Field Diameter - Digit 2",
      group: "modeFieldDiameter",
      required: true,
      options: "0-9"
    },

    {
      index: 7,
      label: "Operating Wavelength - Digit 1",
      group: "operatingWavelength",
      required: true,
      options: "0-9"
    },
    {
      index: 8,
      label: "Operating Wavelength - Digit 2",
      group: "operatingWavelength",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "Operating Wavelength - Digit 3",
      group: "operatingWavelength",
      required: true,
      options: "0-9"
    },

    {
      index: 10,
      label: "Fiber Length",
      required: true,
      options: [
        { code: "1", description: "1 meter" },
        { code: "2", description: "2 meters" },
        { code: "3", description: "3 meters" },
        { code: "X", description: "Special or specified by customer" }
      ]
    },

    {
      index: 11,
      label: "Connectors",
      required: true,
      options: [
        { code: "0", description: "None" },
        { code: "1", description: "FC/UPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/UPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC/UPC" },
        { code: "6", description: "MU/PC" },
        { code: "7", description: "LC/APC" },
        { code: "X", description: "Special or as specified by customer" }
      ]
    },

    {
      index: 12,
      label: "Customer Code - Letter 1",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 13,
      label: "Customer Code - Letter 2",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },
    {
      index: 14,
      label: "Customer Code - Letter 3",
      group: "customerCode",
      required: false,
      options: "A-Z"
    },

    {
      index: 15,
      label: "Product Series - Digit 1",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 16,
      label: "Product Series - Digit 2",
      group: "productSeries",
      required: false,
      options: "0-9"
    },
    {
      index: 17,
      label: "Product Series - Digit 3",
      group: "productSeries",
      required: false,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productCategory",
      label: "Product Category",
      indexes: [0, 1, 2, 3],
      options: [
        { code: "TECF", description: "Thermally Expanded Core Fiber" }
      ]
    },
    {
      group: "modeFieldDiameter",
      label: "Mode Field Diameter",
      indexes: [5, 6],
      options: [
        { code: "15", description: "15um" },
        { code: "20", description: "20um" },
        { code: "30", description: "30um" },
        { code: "40", description: "40um" },
        { code: "XX", description: "Special or specified by customer" }
      ]
    },
    {
      group: "operatingWavelength",
      label: "Operating Wavelength",
      indexes: [7, 8, 9],
      options: [
        { code: "550", description: "1550nm" },
        { code: "310", description: "1310nm" },
        { code: "XXX", description: "Special or specified by customer" }
      ]
    },
    {
      group: "customerCode",
      label: "Customer Code",
      indexes: [12, 13, 14],
      description: "3-letter customer code. Only applicable for products not covered by standard specifications."
    },
    {
      group: "productSeries",
      label: "Product Series",
      indexes: [15, 16, 17],
      description: "3-digit product series. Only applicable for products not covered by standard specifications.",
      allowNumeric: true
    }
  ],

  notes: [
    "See mechanical drawing above for more details of the packaged dimensions.",
    "Glass capillary and ceramic ferrule package is available for MFD 30um and below only.",
    "Tolerance for other requested MFD ≤ 30um is ±2.0um and for MFD ≤ 40um is ±5.0um.",
    "Mechanical fiber length tolerance is ±0.1 meters.",
    "All ports use connectors of the same type.",
    "Customer Code and Product Series are only applicable for products not covered by standard specifications."
  ],

  example: {
    code: "TECFA3055032",
    description:
      "Thermally Expanded Core Fiber, cleaved bare fiber with 30um MFD at 1550nm operating wavelength, 3 meters length with FC/APC termination."
  }
},

{
  id: "visible-wavelength-fused-coupler",
  familyCode: "V",
  matchPrefix: "VWFC",
  minLength: 13,
  maxLength: 13,
  productName: "Visible Wavelength Fused Coupler",
  productPage: "/visible-wavelength-fused-coupler",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FVisible-Wavelength-Fused-Coupler.pdf?alt=media&token=c408b8b6-c1b8-4893-8816-7649ab1d7010",

  positions: [
    {
      index: 0,
      label: "Product Category - Character 1",
      group: "productCategory",
      required: true,
      options: [{ code: "V", description: "Visible Wavelength Fused Coupler prefix" }]
    },
    {
      index: 1,
      label: "Product Category - Character 2",
      group: "productCategory",
      required: true,
      options: [{ code: "W", description: "Visible Wavelength Fused Coupler prefix" }]
    },
    {
      index: 2,
      label: "Product Category - Character 3",
      group: "productCategory",
      required: true,
      options: [{ code: "F", description: "Visible Wavelength Fused Coupler prefix" }]
    },
    {
      index: 3,
      label: "Product Category - Character 4",
      group: "productCategory",
      required: true,
      options: [{ code: "C", description: "Fused Fiber Related" }]
    },

    {
      index: 4,
      label: "Single Window",
      required: true,
      options: [
        { code: "B", description: "488 nm (B)" },
        { code: "G", description: "532 nm (G)" },
        { code: "R", description: "633 nm (R)" },
        { code: "C", description: "Custom Wavelength" }
      ]
    },

    {
      index: 5,
      label: "Grade",
      required: true,
      options: [
        { code: "P", description: "Premium" },
        { code: "A", description: "Grade A" }
      ]
    },

    {
      index: 6,
      label: "Coupling Ratio - Character 1",
      group: "couplingRatio",
      required: true,
      options: "0-9"
    },
    {
      index: 7,
      label: "Coupling Ratio - Character 2",
      group: "couplingRatio",
      required: true,
      options: "0-9"
    },

    {
      index: 8,
      label: "Configuration - Character 1",
      group: "configuration",
      required: true,
      options: [
        { code: "1", description: "1 x 2 prefix" },
        { code: "2", description: "2 x 2 prefix" }
      ]
    },
    {
      index: 9,
      label: "Configuration - Character 2",
      group: "configuration",
      required: true,
      options: [{ code: "2", description: "Configuration suffix" }]
    },

    {
      index: 10,
      label: "Package",
      required: true,
      options: [
        { code: "1", description: "250um Bare Fiber" },
        { code: "2", description: "900um Loose Tube" },
        { code: "C", description: "3mm Cable" }
      ]
    },

    {
      index: 11,
      label: "Pigtail Length",
      required: true,
      options: [
        { code: "1", description: "1m standard" },
        { code: "9", description: "Others" }
      ]
    },

    {
      index: 12,
      label: "Connector Type",
      required: true,
      options: [
        { code: "0", description: "None" },
        { code: "1", description: "FC/SPC" },
        { code: "2", description: "FC/APC" },
        { code: "3", description: "SC/SPC" },
        { code: "4", description: "SC/APC" },
        { code: "5", description: "LC" },
        { code: "6", description: "MU" },
        { code: "7", description: "ST" },
        { code: "9", description: "Other" }
      ]
    }
  ],

  groupedOptions: [
    {
      group: "productCategory",
      label: "Product Category",
      indexes: [0, 1, 2, 3],
      options: [
        { code: "VWFC", description: "Visible Wavelength Fused Coupler" }
      ]
    },
    {
      group: "couplingRatio",
      label: "Coupling Ratio",
      indexes: [6, 7],
      options: [
        { code: "50", description: "50/50" },
        { code: "40", description: "40/60" },
        { code: "30", description: "30/70" },
        { code: "20", description: "20/80" },
        { code: "10", description: "10/90" },
        { code: "05", description: "05/95" }
      ]
    },
    {
      group: "configuration",
      label: "Configuration",
      indexes: [8, 9],
      options: [
        { code: "12", description: "1 x 2" },
        { code: "22", description: "2 x 2" }
      ]
    }
  ],

  notes: [
    "The datasheet shows the model code with hyphens, but the builder should use the clean code without hyphens.",
    "Example VWFC-G-P-50-12-1-1-4 should be entered as VWFCGP5012114."
  ],

  example: {
    code: "VWFCGP5012114",
    description:
      "Visible Wavelength Fused Coupler, 532 nm, premium grade, 50/50 coupling ratio, 1 x 2 configuration, 250um bare fiber, 1m pigtail length, with SC/APC connectors on all ports."
  }
},
{
  id: "peacoc-any-port-panel",
  familyCode: "P",
  matchPrefix: "PAP",
  minLength: 12,
  maxLength: 13,
  productName: "PEACOC® Any Port Panel",
  productPage: "/peacoc-any-port-panel",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FPEACOC%20APP%20Datasheet.pdf?alt=media&token=41a15744-9350-4907-8d6c-ce112b54643e",

  positions: [
    {
      index: 0,
      label: "Product Family - Character 1",
      group: "productFamily",
      required: true,
      options: [{ code: "P", description: "PEACOC" }]
    },
    {
      index: 1,
      label: "Product Family - Character 2",
      group: "productFamily",
      required: true,
      options: [{ code: "A", description: "Any Port Panel prefix" }]
    },
    {
      index: 2,
      label: "Product Family - Character 3",
      group: "productFamily",
      required: true,
      options: [{ code: "P", description: "Any Port Panel" }]
    },
    {
      index: 3,
      label: "Number of RU",
      required: true,
      options: [
        { code: "1", description: "1 RU" },
        { code: "2", description: "2 RU" },
        { code: "4", description: "4 RU" },
        { code: "X", description: "Cassette only" }
      ]
    },
    {
      index: 4,
      label: "Number of Cassettes",
      required: true,
      options: [
        { code: "H", description: "Empty chassis" },
        { code: "A", description: "1" },
        { code: "B", description: "2" },
        { code: "C", description: "3" },
        { code: "D", description: "4" },
        { code: "E", description: "5" },
        { code: "F", description: "Fully loaded" }
      ]
    },
    {
      index: 5,
      label: "Cassette Type",
      required: true,
      options: [
        { code: "A", description: "All-front access" },
        { code: "P", description: "Patch" },
        { code: "S", description: "Splice" },
        { code: "C", description: "Custom" }
      ]
    },
    {
      index: 6,
      label: "Fiber Type",
      required: true,
      options: [
        { code: "1", description: "Single Mode (SMF)" },
        { code: "2", description: "Multi-mode (OM4)" }
      ]
    },
    {
      index: 7,
      label: "Cassette Front Adapter Port Count - Digit 1",
      group: "cassetteFrontAdapterPortCount",
      required: true,
      options: "0-9"
    },
    {
      index: 8,
      label: "Cassette Front Adapter Port Count - Digit 2",
      group: "cassetteFrontAdapterPortCount",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "Front Cassette Adapter Type",
      required: true,
      options: [
        { code: "A", description: "CS" },
        { code: "B", description: "SN" },
        { code: "C", description: "MMC" },
        { code: "D", description: "MDC" },
        { code: "G", description: "SN-MT" },
        { code: "K", description: "LC Simplex" },
        { code: "L", description: "LC Duplex" },
        { code: "M", description: "MPO 8/12/24" },
        { code: "N", description: "MPO 16" }
      ]
    },
    {
      index: 10,
      label: "Polish / Contact",
      required: true,
      options: [
        { code: "5", description: "UPC (aqua)" },
        { code: "6", description: "UPC (blue)" },
        { code: "7", description: "APC (green)" },
        { code: "8", description: "UPC MPO (black)" },
        { code: "9", description: "APC MPO (black)" }
      ]
    },
    {
      index: 11,
      label: "Input Adapter Type",
      required: true,
      options: [
        { code: "C", description: "MMC" },
        { code: "M", description: "MPO 8/12/24" },
        { code: "N", description: "MPO 16" },
        { code: "S", description: "SN-MT" },
        { code: "X", description: "None" }
      ]
    },
    {
      index: 12,
      label: "Inner Cable Options",
      required: false,
      options: [
        { code: "A", description: "1x12F Male to LC fanout" },
        { code: "B", description: "1x16F Male to LC fanout" },
        { code: "C", description: "1x20F Male to LC fanout" },
        { code: "D", description: "1x24F Male to LC fanout" },
        { code: "E", description: "2x8F Male to LC fanout" },
        { code: "F", description: "2x12F Male to LC fanout" },
        { code: "G", description: "2x24F Male to LC fanout" },
        { code: "H", description: "3x8F Male to LC fanout" },
        { code: "J", description: "3x16F Male to LC fanout" },
        { code: "K", description: "4x12F Male to LC fanout" },
        { code: "M", description: "Mass fusion splice" },
        { code: "N", description: "Single splice" },
        { code: "L", description: "1x8F Male MPO to LC fanout" },
        { code: "R", description: "6x8F Male MPO to LC fanout" },
        { code: "X", description: "None" }
      ]
    }
  ],

  groupedOptions: [
    {
      group: "productFamily",
      label: "Product Family",
      indexes: [0, 1, 2],
      options: [
        { code: "PAP", description: "PEACOC® Any Port Panel" }
      ]
    },
    {
      group: "cassetteFrontAdapterPortCount",
      label: "Cassette Front Adapter Port Count",
      indexes: [7, 8],
      options: [
        { code: "04", description: "4 ports" },
        { code: "06", description: "6 ports" },
        { code: "08", description: "8 ports" },
        { code: "09", description: "9 ports" },
        { code: "12", description: "12 ports" },
        { code: "24", description: "24 ports" },
        { code: "28", description: "28 ports" }
      ]
    }
  ],

  notes: [
    "Preterminated cable assemblies available upon request."
  ]
},

{
  id: "selfoc-lens-array",
  familyCode: "S",
  matchPrefix: "SL",
  minLength: 20,
  maxLength: 20,
  productName: "SELFOC® Lens Array",
  productPage: "/selfoc-lens-array",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FSelfoc%20Lens%20Array%20Datasheet.pdf?alt=media&token=efad3609-2b96-4655-b6c5-59c957ba107f",

  positions: [
    {
      index: 0,
      label: "SELFOC Lens Array - Character 1",
      group: "productCategory",
      required: true,
      options: [{ code: "S", description: "SELFOC Lens Array prefix" }]
    },
    {
      index: 1,
      label: "SELFOC Lens Array - Character 2",
      group: "productCategory",
      required: true,
      options: [{ code: "L", description: "SELFOC Lens Array" }]
    },

    {
      index: 2,
      label: "SLA Type - Character 1",
      group: "slaType",
      required: true,
      options: "0-9"
    },
    {
      index: 3,
      label: "SLA Type - Character 2",
      group: "slaType",
      required: true,
      options: "0-9"
    },
    {
      index: 4,
      label: "SLA Type - Character 3",
      group: "slaType",
      required: true,
      options: "A-Z"
    },
    {
      index: 5,
      label: "SLA Type - Character 4",
      group: "slaType",
      required: true,
      options: "A-Z"
    },

    {
      index: 6,
      label: "# of Rows - Character 1",
      group: "numberOfRows",
      required: true,
      options: [
        { code: "1", description: "1 row prefix" },
        { code: "2", description: "2 row prefix" }
      ]
    },
    {
      index: 7,
      label: "# of Rows - Character 2",
      group: "numberOfRows",
      required: true,
      options: [{ code: "R", description: "Rows" }]
    },

    {
      index: 8,
      label: "TC Value - Digit 1",
      group: "tcValue",
      required: true,
      options: "0-9"
    },
    {
      index: 9,
      label: "TC Value - Digit 2",
      group: "tcValue",
      required: true,
      options: "0-9"
    },
    {
      index: 10,
      label: "TC Value - Digit 3",
      group: "tcValue",
      required: true,
      options: "0-9"
    },
    {
      index: 11,
      label: "TC Value - Digit 4",
      group: "tcValue",
      required: true,
      options: "0-9"
    },

    {
      index: 12,
      label: "Dash",
      required: true,
      options: [{ code: "-", description: "Dash separator" }]
    },

    {
      index: 13,
      label: "Wavelength - Digit 1",
      group: "wavelength",
      required: true,
      options: "0-9"
    },
    {
      index: 14,
      label: "Wavelength - Digit 2",
      group: "wavelength",
      required: true,
      options: "0-9"
    },

    {
      index: 15,
      label: "Width - Prefix",
      group: "width",
      required: true,
      options: [{ code: "W", description: "Width prefix" }]
    },
    {
      index: 16,
      label: "Width - Digit 1",
      group: "width",
      required: true,
      options: "0-9"
    },
    {
      index: 17,
      label: "Width - Digit 2",
      group: "width",
      required: true,
      options: "0-9"
    },
    {
      index: 18,
      label: "Width - Digit 3",
      group: "width",
      required: true,
      options: "0-9"
    },
    {
      index: 19,
      label: "Width - Digit 4",
      group: "width",
      required: true,
      options: "0-9"
    }
  ],

  groupedOptions: [
    {
      group: "productCategory",
      label: "SELFOC Lens Array",
      indexes: [0, 1],
      options: [
        { code: "SL", description: "SELFOC® Lens Array" }
      ]
    },
    {
      group: "slaType",
      label: "SLA Type",
      indexes: [2, 3, 4, 5],
      options: [
        { code: "05AG", description: "05AG" },
        { code: "05DG", description: "05DG" },
        { code: "05EG", description: "05EG" },
        { code: "09AG", description: "09AG" },
        { code: "12AG", description: "12AG" },
        { code: "12DR", description: "12DR" },
        { code: "12DX", description: "12DX" },
        { code: "12EG", description: "12EG" },
        { code: "12BG", description: "12BG" },
        { code: "20BG", description: "20BG" },
        { code: "20DG", description: "20DG" }
      ]
    },
    {
      group: "numberOfRows",
      label: "# of Rows",
      indexes: [6, 7],
      options: [
        { code: "1R", description: "1 row" },
        { code: "2R", description: "2 rows" }
      ]
    },
    {
      group: "tcValue",
      label: "TC Value",
      indexes: [8, 9, 10, 11],
      description: "4 digit value in mm, format XXX.X.",
      allowNumeric: true
    },
    {
      group: "wavelength",
      label: "Wavelength",
      indexes: [13, 14],
      options: [
        { code: "51", description: "510nm" },
        { code: "53", description: "530nm" },
        { code: "57", description: "570nm" },
        { code: "66", description: "660nm" },
        { code: "74", description: "740nm" }
      ]
    },
    {
      group: "width",
      label: "Width",
      indexes: [15, 16, 17, 18, 19],
      description:
        "W + 4 digit value in mm, format XXX.X. For 09AGX, use W + 3 digit value.",
      options: [
        { code: "W0000", description: "Width value, format XXX.X" }
      ],
      allowAlphanumeric: true
    }
  ],

  notes: [
    "TC Value uses 4 digits in mm, formatted as XXX.X.",
    "Width uses W plus a 4 digit value in mm, formatted as XXX.X.",
    "For 09AGX, width uses W plus a 3 digit value."
  ]
},

{
  id: "ingaas-avalanche-photodiode-apd-25-gbps-with-tia",
  familyCode: "P",
  matchPrefix: "PDAF",
  lookupOnly: true,
  minLength: 14,
  maxLength: 15,
  productName: "InGaAs Avalanche Photodiode (APD) 2.5 Gbps with TIA",
  productPage: "/ingaas-avalanche-photodiode-apd-25-gbps-with-tia",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FInGaAs%20Avalanche%20Photodiode%20(APD)%20Datasheet.pdf?alt=media&token=eb27b994-b9e9-44a0-a856-3bf9fc88dcd3",

  positions: [
    { index: 0, label: "Model Code", required: true, options: "A-Z" },
    { index: 1, label: "Model Code", required: true, options: "A-Z" },
    { index: 2, label: "Model Code", required: true, options: "A-Z" },
    { index: 3, label: "Model Code", required: true, options: "A-Z" },
    { index: 4, label: "Model Code", required: true, options: "0-9" },
    { index: 5, label: "Model Code", required: true, options: "0-9" },
    { index: 6, label: "Model Code", required: true, options: "0-9" },
    { index: 7, label: "Model Code", required: true, options: "0-9" },
    { index: 8, label: "Model Code", required: true, options: "A-Z" },
    { index: 9, label: "Model Code", required: true, options: "A-Z" },
    { index: 10, label: "Model Code", required: true, options: "A-Z" },
    { index: 11, label: "Model Code", required: true, options: "A-Z" },
    { index: 12, label: "Model Code", required: true, options: "0-9" },
    { index: 13, label: "Model Code", required: true, options: "0-9" },
    { index: 14, label: "Optional Dash", required: false, options: [{ code: "-", description: "Optional dash in datasheet model code" }] }
  ],

  groupedOptions: [
    {
      group: "knownPartNumbers",
      label: "Known Part Numbers",
      indexes: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
      options: [
        {
          code: "PDAF0055TOLT10",
          description: "InGaAs Avalanche Photodiode (APD) 2.5 Gbps with TIA"
        },
        {
          code: "PDAF0055TOL-T10",
          description: "InGaAs Avalanche Photodiode (APD) 2.5 Gbps with TIA"
        }
      ]
    }
  ],

  knownPartNumbers: [
    {
      code: "PDAF0055TOLT10",
      description: "InGaAs Avalanche Photodiode (APD) 2.5 Gbps with TIA"
    },
    {
      code: "PDAF0055TOL-T10",
      description: "InGaAs Avalanche Photodiode (APD) 2.5 Gbps with TIA"
    }
  ],

  notes: [
    "This product has one known part number and does not have a configurable ordering guide.",
    "The part number may be entered with or without the dash."
  ],

  example: {
    code: "PDAF0055TOL-T10",
    description:
      "InGaAs Avalanche Photodiode (APD) 2.5 Gbps with TIA."
  }
},

{
  id: "ingaas-pin-photodiode-with-large-photosensitive-area-chip-on-carrier",
  familyCode: "P",
  matchPrefix: "PDPF",
  lookupOnly: true,
  minLength: 10,
  maxLength: 10,
  productName: "InGaAs PIN Photodiode With Large Photosensitive Area Chip-On-Carrier",
  productPage: "/ingaas-pin-photodiode-with-large-photosensitive-area-chip-on-carrier",
  datasheet:
    "https://firebasestorage.googleapis.com/v0/b/gofoton-55796.firebasestorage.app/o/datasheets%2FInGaAs%20Larger%20Area%20PIN%20Photodiode.pdf?alt=media&token=5482ccbf-cd8d-4d5c-bd82-9ca2509105ac",

  positions: [
    { index: 0, label: "Model Code", required: true, options: "A-Z" },
    { index: 1, label: "Model Code", required: true, options: "A-Z" },
    { index: 2, label: "Model Code", required: true, options: "A-Z" },
    { index: 3, label: "Model Code", required: true, options: "A-Z" },
    { index: 4, label: "Model Code", required: true, options: "0-9" },
    { index: 5, label: "Model Code", required: true, options: "0-9" },
    { index: 6, label: "Model Code", required: true, options: "0-9" },
    { index: 7, label: "Model Code", required: true, options: "0-9" },
    { index: 8, label: "Model Code", required: true, options: "A-Z" },
    { index: 9, label: "Model Code", required: true, options: "A-Z" }
  ],

  groupedOptions: [
    {
      group: "knownPartNumbers",
      label: "Known Part Numbers",
      indexes: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
      options: [
        {
          code: "PDPF1000CC",
          description:
            "InGaAs PIN Photodiode With Large Photosensitive Area Chip-On-Carrier"
        }
      ]
    }
  ],

  knownPartNumbers: [
    {
      code: "PDPF1000CC",
      description:
        "InGaAs PIN Photodiode With Large Photosensitive Area Chip-On-Carrier"
    }
  ],

  notes: [
    "This product has one known part number and does not have a configurable ordering guide."
  ],

  example: {
    code: "PDPF1000CC",
    description:
      "InGaAs PIN Photodiode With Large Photosensitive Area Chip-On-Carrier."
  }
},



];

export default partNumberSchemas;